/* hgn-side-cart.js — moved verbatim from snippets/hgn-side-cart.liquid on 2026-09-14 (page-weight:
   inline JS → theme asset, loaded synchronously at the same position so execution order
   and DOMContentLoaded timing are unchanged). EDIT THIS FILE, not the snippet. */

(function () {
  'use strict';

  /* =========================================================
     HGNSideCart — single instance, mounted from theme.liquid.
     Public API:
       window.HGN.sideCart.open()
       window.HGN.sideCart.close()
       window.HGN.sideCart.refresh()       // re-fetch /cart.js + render
     Public events the cart listens for (open):
       'hgn:cart:open'   (preferred)
       'cart:open'       (legacy, kept for compat)
     Public events fired:
       'hgn:cart:change' (after every successful mutation)
     ========================================================= */
  var SC_SELECTOR = '[data-hgn-side-cart]';
  var BODY_OPEN_CLASS = 'hgn-side-cart-open';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function escapeAttr(s) {
    return escapeHtml(s);
  }
  /* ───────── GBP-canonical currency helpers ─────────
     Kit + gift line properties are GBP pence (canonical,
     market-agnostic). Display routes every GBP amount through
     `window.HGN.formatLive(gbp, key)` so a USD shopper sees "$50", not
     "£39.99". formatLive rounds friendly (nearest 0.50/1/5/10), so it
     can differ slightly from raw FX — the accepted trade-off for clean
     marketing numbers, and it matches the kit-build pricing block.

     `gbpToActiveCents` is the raw-FX variant, used where maths must
     match what Shopify actually deducts (it converts the worker's GBP
     discount at raw FX, not friendly-rounded): the orchestrator
     subtotal subtraction + the foot's displayed-subtotal cents. The
     two can drift by a £1–2 equivalent on big savings; live with it. */
  var FX_FALLBACK_RATES = { gbp: 1, usd: 1.25, eur: 1.15, cad: 1.70, aud: 1.95, nzd: 2.10, chf: 1.10 };
  var FX_VALID_KEYS = ['gbp', 'usd', 'eur', 'cad', 'aud', 'nzd', 'chf'];
  /* `cart.currency` from /cart.js is the authoritative presentment
     currency — `Shopify.currency.active` is unreliable in Markets
     shops (often pinned to the shop's base currency even for non-base
     buyers). Stash on the window so hgn-currency.liquid + the
     kit-build IIFE benefit from the same source.
     EMPTY-CART CAVEAT: /cart.js reports the shop's BASE currency (GBP)
     for carts with item_count 0, regardless of the visitor's market
     (verified live 2026-07-10 on the AU market). Callers must only
     pass cart.currency when the cart has items, else every new visitor
     gets pinned to GBP and formatLive stops converting. */
  function rememberPresentmentCurrency(cur) {
    if (!cur) return;
    var k = String(cur).toLowerCase();
    /* 2026-09-27: keep the RAW cart currency too, first-class or not —
       the mint maths needs to know a CZK/DKK/PLN/RON/SEK cart is one
       (see cartFxRate). Display keeps resolving long-tail to GBP. */
    window.HGN = window.HGN || {};
    window.HGN.cartCurrencyRaw = k;
    if (FX_VALID_KEYS.indexOf(k) === -1) return;
    window.HGN = window.HGN || {};
    if (window.HGN.cartCurrency === cur) return;
    window.HGN.cartCurrency = cur;
    /* Notify FX-aware components (kit-build pricing block, etc.) so
       they re-render with the now-known currency. Same event
       hgn-currency dispatches when live FX rates land. */
    try {
      document.dispatchEvent(new CustomEvent('hgn:fx:update', {
        detail: { reason: 'cart-currency', currency: cur }
      }));
    } catch (e) {}
  }
  function activeKey() {
    /* Prefer hgn-currency's helper (now itself prefers cartCurrency). */
    if (window.HGN && typeof window.HGN.activeCurrencyKey === 'function') {
      try { return window.HGN.activeCurrencyKey(); } catch (e) {}
    }
    /* Fallback chain when hgn-currency hasn't loaded yet:
       cart-derived → Shopify global → GBP. Every branch validates
       membership in FX_VALID_KEYS: an unknown presentment currency
       (czk/dkk/pln/ron/sek are enabled on this store) must resolve to
       'gbp' — this is what stops fxRate() defaulting to rate 1 and
       minting foreign-currency numbers as GBP (the CHF over-discount
       bug, pre-2026-07-11). */
    var cartCur = window.HGN && window.HGN.cartCurrency;
    if (cartCur) {
      var ck = String(cartCur).toLowerCase();
      if (FX_VALID_KEYS.indexOf(ck) !== -1) return ck;
    }
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    var sk = String(cur).toLowerCase();
    return FX_VALID_KEYS.indexOf(sk) !== -1 ? sk : 'gbp';
  }
  function fxRate(key) {
    var k = key || activeKey();
    if (k === 'gbp') return 1;
    var live = window.HGN && window.HGN.fxRates && window.HGN.fxRates[k];
    return live || FX_FALLBACK_RATES[k] || 1;
  }
  function gbpToActiveCents(gbpAmount) {
    if (!isFinite(gbpAmount)) return 0;
    return Math.round(gbpAmount * fxRate() * 100);
  }
  function gbpCentsToActiveCents(gbpPence) {
    return gbpToActiveCents((gbpPence || 0) / 100);
  }
  /* Format a GBP value in the active currency via the friendly-
     rounded formatLive helper. Falls back to a £-prefixed string
     if hgn-currency hasn't booted yet. */
  function formatGbp(gbpAmount) {
    var v = (typeof gbpAmount === 'number' && isFinite(gbpAmount)) ? gbpAmount : 0;
    if (window.HGN && typeof window.HGN.formatLive === 'function') {
      try { return window.HGN.formatLive(v, activeKey()); } catch (e) {}
    }
    return '£' + v.toFixed(2);
  }
  function formatGbpCents(gbpPence) {
    return formatGbp((gbpPence || 0) / 100);
  }

  function formatMoney(cents, currencyCode) {
    var n = (cents || 0) / 100;
    /* Normalise: callers pass an ISO string, the cart.currency OBJECT,
       or nothing (→ active presentment currency). */
    var code = (currencyCode && currencyCode.iso_code) ? currencyCode.iso_code : currencyCode;
    if (!code) code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    code = String(code).toUpperCase();
    /* Shopify.formatMoney uses theme.moneyFormat — the SHOP's (GBP)
       format string — which stamps £ on ANY magnitude. Only safe when
       the shopper's currency IS GBP (audit B5.4: line/bundle/gift
       renderers showed £-prefixed EUR/CHF amounts through this path). */
    if (code === 'GBP' && window.Shopify && window.Shopify.formatMoney) {
      try { return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat); } catch (e) {}
    }
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(n);
    } catch (e) {
      return '\u00a3' + n.toFixed(2);
    }
  }

  /* ───────── Cart fetch + mutation primitives ─────────
     /cart.js is the source of truth. Every mutation refetches before
     re-rendering so we never drift from Shopify's view of the cart. */
  /* Safely parse a Shopify cart endpoint response. When Shopify rate-
     limits (429) it returns an HTML error page, so res.json() would
     throw a SyntaxError. Reject HTML explicitly, but accept anything
     else and let the JSON parser decide — Shopify's cart endpoints
     sometimes serve text/javascript for /cart.js. */
  function safeCartJson(r) {
    if (!r || !r.ok) return null;
    var ct = r.headers && r.headers.get && r.headers.get('content-type') || '';
    if (ct.indexOf('text/html') !== -1) return null;
    return r.json().catch(function () { return null; });
  }
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(safeCartJson);
  }
  function changeLine(line, quantity) {
    /* Shopify line indexes are 1-based for /cart/change.js. */
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(safeCartJson);
  }

  /* ───────── Bundle grouping helpers ─────────
     The kit-discount worker tags every kit line with `_bundle_id` and
     `_bundle_label` line-item properties. We walk cart.items, group by
     `_bundle_id`, render each group as ONE concertina card with the
     kit name + total + per-item drill-down. Removing the group fires
     a single /cart/update.js call that zeroes every line in one go.
     Standalone items (no `_bundle_id`) render as flat rows. */
  /* Identifies a cart line as the auto-added free gift. Both spellings
     (`_gift_line` hidden, `Free gift` visible) live on line-item
     properties for resilience — Shopify sometimes drops underscore-
     prefixed keys depending on theme settings, and the visible label
     reinforces the reward at checkout. */
  function isGiftLineItem(item) {
    var p = item && item.properties;
    if (!p) return false;
    if (p._gift_line === '1' || p._gift_line === true || p['_gift_line'] === '1') return true;
    if (p['Free gift'] === '1' || p['Free gift'] === 'true') return true;
    return false;
  }

  function readBundleId(item) {
    var p = item && item.properties;
    if (!p) return null;
    /* Shopify normalizes underscore-prefixed property keys (hidden from
       the customer). The send-to-kit flow writes both
       `_bundle_id` (hidden) and `Box ID` (visible) for resilience. */
    return p['_bundle_id'] || p._bundle_id || p['_box_id'] || p['Box ID'] || null;
  }
  function readBundleLabel(item) {
    var p = item && item.properties;
    if (!p) return null;
    /* `Bundle` is the visible kit label (e.g. "Classic Wraps Starter
       Kit"). `_bundle_label` is reserved for future use. */
    return p['_bundle_label'] || p._bundle_label || p['Bundle'] || null;
  }
  /* The curated edit the kit was built from (2026-09-16) — stamped by
     autoFinalise as hidden props when the kit was still "their Halloween
     Edit" at finalise time (kitProgress owns that rule). Absent on a
     hand-built kit, so the card reads exactly as before. */
  function readBundleEdit(item) {
    var p = item && item.properties;
    if (!p) return null;
    var title = p._hgn_edit_title || p['_hgn_edit_title'];
    if (!title) return null;
    return { title: String(title), slug: String(p._hgn_edit_slug || p['_hgn_edit_slug'] || ''), skin: String(p._hgn_edit_skin || p['_hgn_edit_skin'] || '') };
  }
  function readBundleTier(item) {
    var p = item && item.properties;
    var bt = String((p && (p._bundle_type || p['_bundle_type'])) || '');
    var m = bt.match(/^(classic|gels|press-ons)-starter-kit$/);
    return m ? m[1] : '';
  }
  /* Bundle target price (GBP pence) — written by `autoFinalise` as
     `_bundle_price_gbp_cents` on every bundle line. Source of truth
     for the discounted price the side cart shows on the bundle card;
     with mint-at-checkout we no longer have `discount_allocations` to
     read a paid price from until the very end of checkout-click.
     Always GBP pence regardless of buyer's market — the side cart
     formats via formatLive() at display time. */
  function readBundleTargetGbpCents(item) {
    var p = item && item.properties;
    if (!p) return null;
    var raw = p['_bundle_price_gbp_cents'] || p._bundle_price_gbp_cents;
    if (raw == null) return null;
    var n = parseInt(raw, 10);
    return isFinite(n) && n >= 0 ? n : null;
  }
  /* Bundle target in PRESENTMENT cents (sticker markets only): the
     promise VERBATIM, so savings skip the rate-sensitive GBP round
     trip. Null on GBP / legacy / post-switch carts (GBP path). */
  function readBundleTargetPresentmentCents(item) {
    var p = item && item.properties;
    if (!p) return null;
    var raw = p['_bundle_price_local_cents'] || p._bundle_price_local_cents;
    var iso = p['_bundle_price_currency'] || p._bundle_price_currency;
    if (raw == null || !iso) return null;
    if (String(iso).toUpperCase() !== activeKey().toUpperCase()) return null;
    var n = parseInt(raw, 10);
    return isFinite(n) && n >= 0 ? n : null;
  }
  /* Bundle full retail (GBP pence) — written by `autoFinalise` from
     the same HGN_KIT_RETAILS table the kit-build pricing block uses.
     Drives the bundle card's strikethrough RRP and the "you save"
     savings figure on the side cart's foot. Stored on every bundle
     line for resilience; we read it from whichever line we encounter
     first per bundle. */
  function readBundleRetailGbpCents(item) {
    var p = item && item.properties;
    if (!p) return null;
    var raw = p['_bundle_retail_gbp_cents'] || p._bundle_retail_gbp_cents;
    if (raw == null) return null;
    var n = parseInt(raw, 10);
    return isFinite(n) && n >= 0 ? n : null;
  }
  /* Gift line retail (GBP pence) — written by `_addGiftLine` from
     `config.gift.tiers[0].price` (a GBP value emitted by the
     announcement bar). Used by the savings calc + the gift line
     rendering so the "Free Gift — worth $X" pill stays accurate
     across markets. */
  function readGiftRetailGbpCents(item) {
    var p = item && item.properties;
    if (!p) return null;
    var raw = p['_gift_retail_gbp_cents'] || p._gift_retail_gbp_cents;
    if (raw == null) return null;
    var n = parseInt(raw, 10);
    return isFinite(n) && n >= 0 ? n : null;
  }
  /* Sum of order-level discount allocations applied to a single line.
     `discount_allocations` is the modern /cart.js field and is what
     Shopify's checkout uses — beats `total_discount` (which can lag)
     and `final_line_price` (line-level only, ignores order discounts). */
  function lineDiscountCents(item) {
    var allocs = item && item.discount_allocations;
    if (!allocs || !allocs.length) return 0;
    var total = 0;
    for (var i = 0; i < allocs.length; i++) {
      total += allocs[i].amount || 0;
    }
    return total;
  }
  /* What the shopper actually pays for this line — retail minus every
     discount allocation Shopify has computed (line-level + order-level
     combined). Used for both standalone line prices and the bundle
     card total so the side cart never shows a price that disagrees
     with the cart page or checkout. */
  function linePaidCents(item) {
    if (!item) return 0;
    var retail = item.original_line_price != null
      ? item.original_line_price
      : (item.line_price || 0);
    return Math.max(0, retail - lineDiscountCents(item));
  }
  /* ───── Actual-price savings basis (2026-07-10 rewrite) ─────
     Bundle savings = what Shopify will actually charge for the
     bundle's lines MINUS the kit's target price. The old basis
     (`_bundle_retail_gbp_cents`, a static per-slot table) drifted from
     real line prices — an uplift-upsell pick understated savings and
     under-minted BASKET-*, so the shopper overpaid. Deriving from the
     live cart is self-correcting: the target is the only input we
     control; retail is whatever Shopify says the lines cost.

     Presentment cents in, presentment cents out — no FX involved
     for GBP shoppers, and for non-GBP markets the retail side is
     already the buyer's real market pricing. Only the kit target
     (GBP-canonical) needs converting. */
  function bundleSavingsPresentmentCents(bundle) {
    if (!bundle || bundle.gbpPaidCents == null) return 0;
    /* Prefer the target the shopper was actually promised, in the
       currency it was promised in (see readBundleTargetPresentmentCents).
       Falls back to the GBP conversion for GBP markets + legacy lines. */
    var targetPresentment = bundle.presentmentPaidCents != null
      ? bundle.presentmentPaidCents
      : gbpCentsToActiveCents(bundle.gbpPaidCents);
    /* Savings basis is ONE unit per bundle line (retailOneUnitCents),
       not the qty-inclusive line total. The kit target covers exactly
       one of each pick — summing qty × unit let a shopper bump any
       bundle line's qty (native /cart inputs, or the in-drawer +/−
       during a Nail Points intent) and inflate the minted BASKET-*
       1:1, making the extra units free (audit B1). Excess units now
       ride at normal retail: card retail stays qty-inclusive, savings
       don't move, paid = retail − savings absorbs the difference.
       For well-formed kits (every line qty 1, as autoFinalise creates
       them) the two bases are identical. */
    var basis = bundle.retailOneUnitCents != null ? bundle.retailOneUnitCents : (bundle.retailCents || 0);
    return Math.max(0, basis - targetPresentment);
  }
  /* One unit's retail for a line, regardless of quantity. */
  function lineOneUnitRetailCents(it) {
    if (!it) return 0;
    if (it.original_price != null) return it.original_price;
    var lineTotal = it.original_line_price != null ? it.original_line_price : (it.line_price || 0);
    return Math.round(lineTotal / Math.max(1, it.quantity || 1));
  }
  /* Invert presentment cents to GBP pence for worker mint payloads
     (Shopify mints discount codes in shop currency = GBP). Identity
     for GBP carts; for non-GBP the same acceptable £1-2 FX drift as
     the ad-hoc mint path applies. */
  function presentmentToGbpCents(cents) {
    return Math.round((cents || 0) / cartFxRate());
  }
  /* Presentment-per-GBP for the cart's REAL currency — the rate that
     turns cart line money into the GBP pence a mint needs.
     First-class currencies (and unknown/GBP) → fxRate(), unchanged.
     Long-tail (czk dkk pln ron sek) → Shopify's own storefront rate,
     `Shopify.currency.rate`, when it describes the same currency. That
     is the exact rate Shopify uses to convert a GBP code back at
     checkout. Before 2026-09-27 these carts hit fxRate()'s GBP
     fallback of 1, so CZK money was minted as pounds: a 797.60 CZK
     saving became a £797.60 BASKET-* with a £797.60 minimum spend,
     which Shopify refused — full price at checkout (Help Scout #15329). */
  function cartFxRate() {
    var raw = window.HGN && window.HGN.cartCurrencyRaw;
    if (!raw || raw === 'gbp' || FX_VALID_KEYS.indexOf(raw) !== -1) return fxRate();
    var sc = window.Shopify && window.Shopify.currency;
    if (sc && String(sc.active || '').toLowerCase() === raw) {
      var r = parseFloat(sc.rate);
      if (isFinite(r) && r > 0) return r;
    }
    return fxRate();
  }
  /* The cart's real currency code for the worker's percentage mint.
     Long-tail carts send their true code (e.g. CZK), so the worker
     mints savings ÷ subtotal as a percentage in that currency — no FX
     step at all. First-class carts keep today's activeKey() value. */
  function cartCurrencyCode() {
    var raw = window.HGN && window.HGN.cartCurrencyRaw;
    if (raw && raw !== 'gbp' && FX_VALID_KEYS.indexOf(raw) === -1) return raw.toUpperCase();
    return activeKey().toUpperCase();
  }
  /* GBP pence → the cart's real presentment cents (kit5 fold into the
     percentage payload). First-class carts: gbpCentsToActiveCents. */
  function gbpCentsToCartCents(gbpPence) {
    return Math.round(((gbpPence || 0) / 100) * cartFxRate() * 100);
  }
  /* The gift line's actual retail in presentment cents — what the
     consolidated BASKET-* must cover for the gift to end up free.
     Reads the live cart line, NOT the `_gift_retail_gbp_cents`
     config snapshot (which captured the announcement bar's render-
     time price — a stale value after a price change, and on
     non-GBP markets a presentment value mislabelled as GBP). */
  function giftRetailPresentmentCents(item) {
    if (!item) return 0;
    return item.original_line_price != null
      ? item.original_line_price
      : (item.line_price || 0);
  }

  function groupCartLines(items) {
    var bundles = {};
    var standalones = [];
    var gifts = [];
    items.forEach(function (it, idx) {
      /* Shopify line index is 1-based; preserve it on the line so the
         qty buttons can fire /cart/change.js without re-counting. */
      it._lineIndex = idx + 1;
      if (isGiftLineItem(it)) {
        gifts.push(it);
        return;
      }
      var bid = readBundleId(it);
      if (bid) {
        if (!bundles[bid]) {
          bundles[bid] = {
            id: bid,
            label: readBundleLabel(it) || 'Starter Kit',
            edit: readBundleEdit(it),
            tier: readBundleTier(it),
            items: [],
            /* Presentment-currency totals (what Shopify shows the
               buyer in their market). Used by the items-list
               strikethrough math + as the "retail" baseline for
               the kit-line aggregations. The bundle CARD itself
               renders from the GBP-canonical fields below. */
            retailCents: 0,
            paidCents: 0,
            /* `gbpPaidCents` — the kit's TARGET price (GBP pence),
               written by `autoFinalise` on every bundle line and the
               single signal that a bundle carries a discount; savings
               = actual line-price sum − target (see
               bundleSavingsPresentmentCents). Null on legacy bundles
               → zero savings, rendered at retail.

               `gbpRetailCents` — HGN_KIT_RETAILS captured at finalise.
               INFORMATIONAL ONLY since the 2026-07-10 actual-price
               rewrite: the table drifted from real line prices (it
               can't see which option was picked), understating savings
               and under-minting BASKET-*. Nothing computes from it. */
            gbpPaidCents:   readBundleTargetGbpCents(it),
            /* Sticker-market target in presentment cents — the promise
               verbatim, no FX. Null everywhere else. */
            presentmentPaidCents: readBundleTargetPresentmentCents(it),
            gbpRetailCents: readBundleRetailGbpCents(it)
          };
        }
        bundles[bid].items.push(it);
        var retail = it.original_line_price != null ? it.original_line_price : (it.line_price || 0);
        bundles[bid].retailCents += retail;
        /* One-unit basis for savings math — see bundleSavingsPresentmentCents. */
        bundles[bid].retailOneUnitCents = (bundles[bid].retailOneUnitCents || 0) + lineOneUnitRetailCents(it);
        bundles[bid].paidCents += linePaidCents(it);
      } else {
        standalones.push(it);
      }
    });
    return {
      bundles: Object.keys(bundles).map(function (k) { return bundles[k]; }),
      standalones: standalones,
      gifts: gifts
    };
  }

  /* ───────── Controller ───────── */
  /* Which free-shipping threshold applies (2026-09-30). The config holds one
     GBP figure per currency key; a currency with no key used to fall back to
     'gbp' = the UK's £40. But a non-UK shopper paying in GBP (Channel Islands,
     GBP-priced EU countries) or in a long-tail currency (DKK, SEK…) is on a
     £10 market, so they now get the EU figure. Country comes from
     window.HGN_COPY.cc (hgn-market-copy); without it, the old behaviour. */
  function shipThresholdKey(shipping, cur) {
    shipping = shipping || {};
    cur = String(cur || 'gbp').toLowerCase();
    var cc = (window.HGN_COPY && window.HGN_COPY.cc) || '';
    if (cur !== 'gbp' && shipping[cur] != null) return cur;
    if (cc && cc !== 'GB' && shipping.eur != null) return 'eur';
    return 'gbp';
  }

  /* ───────── Open settle, focus, and the stowed base drawer ─────────
     From the side cart CRO audit (SIDECART-CRO-AUDIT-2026-10-02.md §5;
     record SIDECART-FIXES-2026-10-02.md): the drawer shifted as it opened
     (CLS 0.25–0.38 on a PDP add, ~1.3 on a kit add) because the cart, the
     attach row, the offer card, the free gift and lazy images all landed
     after the panel was on screen; the line just added could sit under the
     sticky foot; focus escaped the open panel; and the base theme's stowed
     <cart-drawer> threw on every PDP add. */
  var SETTLE_CAP_MS = 1200;      /* longest wait for the contents to settle */
  var KIT_SETTLE_CAP_MS = 6000;  /* stretched to this while a kit or the gift lands */
  var SETTLE_QUIET_MS = 120;     /* no DOM change for this long = settled */
  var renderCount = 0;
  var lastKitFinalise = { at: 0, tier: null };
  document.addEventListener('hgn:kit:finalise-request', function (e) {
    lastKitFinalise = { at: Date.now(), tier: (e && e.detail && e.detail.tier) || null };
  });

  function cartLineQtys(cart) {
    var m = {};
    ((cart && cart.items) || []).forEach(function (it) { m[it.key] = (m[it.key] || 0) + (it.quantity || 0); });
    return m;
  }

  /* A kit being added: the drawer opens on the add response, a beat BEFORE
     the kit-build file clears the finished kit from memory and before the
     refreshed cart carries the kit lines. Showing the drawer in that gap
     flashed the all-set build panel before the kit card. Wait while the tier
     still holds picks in kit memory, or its lines have not landed — capped,
     and never past a failure modal (the kit stays in memory on failure). */
  function kitLanding(self) {
    if (!lastKitFinalise.at || Date.now() - lastKitFinalise.at > KIT_SETTLE_CAP_MS) return false;
    if (document.querySelector('[data-hgn-kit-finalise-error], [data-hgn-kit-oos-modal]')) return false;
    var tier = lastKitFinalise.tier;
    var landed = ((self.cart && self.cart.items) || []).some(function (it) {
      var bt = String((it.properties || {})._bundle_type || '');
      return tier ? bt.indexOf(tier + '-starter-kit') === 0 : !!bt;
    });
    var kit = null;
    try { var kp = window.HGN && window.HGN.kitProgress; kit = tier && kp ? (kp.read().kits || {})[tier] : null; } catch (e) {}
    return !!(kit && (kit.items || []).length) || !landed;
  }

  /* The attach file's offer card has not resolved its candidate for THIS
     basket yet (its render wrapper starts the lookup while the drawer is open). */
  function pairPending(self) {
    if (!self.cart || !self.cart.item_count || typeof self._prefetchPairCandidate !== 'function') return false;
    var e = self._pairPrefetch;
    var sig = '';
    try { sig = self._offerSignature(); } catch (x) { return false; }
    if (!e || e.sig !== sig) return true;
    return e.result === undefined;
  }

  /* Lazy images inside a drawer that was off-screen only start loading as it
     slides in; ask the visible ones to load now and wait for them (capped). */
  function imagesPending(self) {
    var body = self.body;
    if (!body || !self.panel) return false;
    var b = body.getBoundingClientRect();
    var imgs = self.panel.querySelectorAll('[data-hgn-side-cart-body] img');
    var pending = false;
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var r = img.getBoundingClientRect();
      if (!r.width || r.bottom < b.top || r.top > b.bottom) continue;
      if (img.loading === 'lazy') { try { img.loading = 'eager'; } catch (e) {} }
      if (!img.complete) pending = true;
    }
    return pending;
  }

  function scrollIntoBody(self, el, pad) {
    var body = self.body;
    if (!body || !el) return;
    var b = body.getBoundingClientRect();
    var r = el.getBoundingClientRect();
    if (!r.height) return;
    pad = pad == null ? 12 : pad;
    if (r.bottom > b.bottom - pad) body.scrollTop += Math.min(r.bottom - b.bottom + pad, r.top - b.top - pad);
    else if (r.top < b.top + pad) body.scrollTop -= (b.top + pad - r.top);
  }

  /* The line that changed between the cart we opened on and the refreshed one. */
  function justAddedEl(self, before) {
    var items = (self.cart && self.cart.items) || [];
    if (!before || !self.itemsEl) return null;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (isGiftLineItem(it)) continue;
      if (before[it.key] != null && (it.quantity || 0) <= before[it.key]) continue;
      var bid = readBundleId(it);
      if (bid) {
        var card = self.itemsEl.querySelector('[data-hgn-bundle-id="' + String(bid).replace(/"/g, '') + '"]');
        if (card) return card;
        continue;
      }
      var btn = self.itemsEl.querySelector('[data-hgn-side-cart-line="' + (i + 1) + '"]');
      var row = btn && btn.closest('.hgn-side-cart__item');
      if (row) return row;
    }
    return null;
  }

  /* An offer that resolves after the reveal (the cap was hit) grows the
     sticky foot and can slide the line just added back under it. For 4 s,
     and only until the shopper touches or scrolls the drawer, keep that line
     in view. Scrolling the body is not a layout shift. */
  function keepInView(self, el, token) {
    var body = self.body, foot = self.footEl;
    if (!body || !foot || typeof ResizeObserver !== 'function') return;
    var stop = false, ro = null;
    var end = function () { stop = true; if (ro) { try { ro.disconnect(); } catch (e) {} } body.removeEventListener('touchstart', end); body.removeEventListener('wheel', end); body.removeEventListener('keydown', end); };
    body.addEventListener('touchstart', end, { passive: true });
    body.addEventListener('wheel', end, { passive: true });
    body.addEventListener('keydown', end);
    try {
      ro = new ResizeObserver(function () {
        if (stop || token !== self._settleToken || !self.isOpen || !el.isConnected) return end();
        scrollIntoBody(self, el);
      });
      ro.observe(foot);
      ro.observe(body);
    } catch (e) { return; }
    setTimeout(end, 4000);
  }

  function focusables(panel) {
    var sel = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.prototype.filter.call(panel.querySelectorAll(sel), function (el) {
      if (el.getAttribute('aria-hidden') === 'true' || el.closest('[hidden], [aria-hidden="true"]')) return false;
      if (!el.getClientRects().length) return false;
      var cs = window.getComputedStyle(el);
      return cs.visibility !== 'hidden' && cs.display !== 'none';
    });
  }

  /* Image-only links in the lines and the kit list get the row's title as a
     name a screen reader can read out. */
  function labelThumbs(root) {
    if (!root) return;
    var links = root.querySelectorAll('[data-hgn-side-cart-items] a[href], [data-hgn-side-cart-kit-list] a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.hasAttribute('aria-label') || a.getAttribute('aria-hidden') === 'true') continue;
      if ((a.textContent || '').replace(/\s+/g, '')) continue;
      var row = a.closest('.hgn-side-cart__item, .hgn-side-cart__bundle, .hgn-side-cart__kit-pick, li, article');
      var t = row && row.querySelector('[class*="title"]');
      var name = (t && t.textContent || '').replace(/\s+/g, ' ').trim();
      if (!name) { var img = a.querySelector('img[alt]'); name = img ? img.getAttribute('alt') : ''; }
      a.setAttribute('aria-label', name || 'View product');
    }
  }

  /* Spotlight/Dawn's <product-form> hands every add to <cart-drawer>.renderContents(),
     which re-renders the 'cart-drawer' section from the add response. Here that drawer
     is stowed (layout/theme.liquid wraps it in .hgn-cart-host-stowed; Beans/Liana needs
     the element) and its section markup is not in the response, so it threw on every
     PDP / quick-add add — after the add had succeeded. This drawer opens from its own
     /cart/add interceptor, so the stowed one records the product and stands down. */
  function patchStowedDrawer() {
    try {
      var C = window.customElements && window.customElements.get('cart-drawer');
      if (!C || !C.prototype || C.prototype.__hgnStowedPatched) return;
      C.prototype.__hgnStowedPatched = true;
      var orig = C.prototype.renderContents;
      C.prototype.renderContents = function (parsedState) {
        if (this.closest && this.closest('.hgn-cart-host-stowed')) {
          try { this.productId = parsedState && parsedState.id; } catch (e) {}
          return;
        }
        return orig ? orig.apply(this, arguments) : undefined;
      };
    } catch (e) {}
  }
  try {
    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('cart-drawer').then(patchStowedDrawer).catch(function () {});
    }
  } catch (e) {}
  patchStowedDrawer();

  function HGNSideCart(root) {
    this.root = root;
    this.panel = $('.hgn-side-cart__panel', root);
    this.body = $('[data-hgn-side-cart-body]', root);
    this.itemsEl = $('[data-hgn-side-cart-items]', root);
    this.cartSectionEl = $('[data-hgn-side-cart-cart-section]', root);
    this.cartCountEl   = $('[data-hgn-side-cart-cart-count]', root);
    this.emptyEl = $('[data-hgn-side-cart-empty]', root);
    this.footEl = $('[data-hgn-side-cart-foot]', root);
    this.subtotalEl = $('[data-hgn-side-cart-subtotal]', root);
    this.savingsEl = $('[data-hgn-side-cart-savings]', root);
    this.savingsValueEl = $('[data-hgn-side-cart-savings-value]', root);
    this.taxesEl = $('[data-hgn-side-cart-taxes]', root);
    this.checkoutBtn = $('[data-hgn-side-cart-checkout]', root);
    this.checkoutLabelEl = $('[data-hgn-side-cart-checkout-label]', root);
    /* Mint-gate note (A1) + mid-build foot / empty-state kit CTA. */
    this.checkoutNoteEl  = $('[data-hgn-side-cart-checkout-note]', root);
    this.totalsEl        = $('[data-hgn-side-cart-totals]', root);
    this.kitCtaEl        = $('[data-hgn-side-cart-kit-cta]', root);
    this.kitCtaLabelEl   = $('[data-hgn-side-cart-kit-cta-label]', root);
    this.kitCtaSubEl     = $('[data-hgn-side-cart-kit-cta-sub]', root);
    this.emptyKitCtaEl   = $('[data-hgn-side-cart-empty-kit-cta]', root);
    this.piggybackEl = $('[data-hgn-side-cart-piggyback]', root);
    this.piggybackToggleEl = $('[data-hgn-side-cart-piggyback-toggle]', root);
    this.loadingEl = $('[data-hgn-side-cart-loading]', root);
    this.progressEl = $('[data-hgn-side-cart-progress]', root);
    this.progressLineEl = $('[data-hgn-side-cart-progress-line]', root);
    this.progressFillEl = $('[data-hgn-side-cart-progress-fill]', root);
    this.upsellEl = $('[data-hgn-side-cart-upsell]', root);
    this.beansEl = $('[data-hgn-side-cart-beans]', root);
    this.beansToggleEl = $('[data-hgn-side-cart-beans-toggle]', root);
    this.beansBodyEl = $('[data-hgn-side-cart-beans-body]', root);
    this.beansSummaryEl = $('[data-hgn-side-cart-beans-summary]', root);
    this.beansMessageEl = $('[data-hgn-side-cart-beans-message]', root);
    this.beansCtaEl = $('[data-hgn-side-cart-beans-cta]', root);
    this.beansCtaLabelEl = $('[data-hgn-side-cart-beans-cta-label]', root);
    this.adhocEl       = $('[data-hgn-side-cart-adhoc]', root);
    this.adhocToggleEl = $('[data-hgn-side-cart-adhoc-toggle]', root);
    this.adhocBodyEl   = $('[data-hgn-side-cart-adhoc-body]', root);
    this.adhocSummaryEl= $('[data-hgn-side-cart-adhoc-summary]', root);
    this.adhocLabelEl  = $('[data-hgn-side-cart-adhoc-label]', root);
    this.adhocIdleEl   = $('[data-hgn-side-cart-adhoc-idle]', root);
    this.adhocInputEl  = $('[data-hgn-side-cart-adhoc-input]', root);
    this.adhocApplyEl  = $('[data-hgn-side-cart-adhoc-apply]', root);
    this.adhocErrorEl  = $('[data-hgn-side-cart-adhoc-error]', root);
    this.adhocAppliedEl= $('[data-hgn-side-cart-adhoc-applied]', root);
    this.adhocBadgeEl  = $('[data-hgn-side-cart-adhoc-badge]', root);
    this.adhocCancelEl = $('[data-hgn-side-cart-adhoc-cancel]', root);
    this.adhocNoteEl   = $('[data-hgn-side-cart-adhoc-note]', root);
    this.scrimEl = $('[data-hgn-side-cart-scrim]', root);
    this.timerEl = $('[data-hgn-side-cart-timer]', root);
    this.titleEl = $('.hgn-side-cart__title', root);

    /* Mount the shared cart-reservation countdown into the header
       slot in alternate mode — it cross-fades with the "Cart" title
       every 5s while a reservation is live. The reservation itself is
       started/cleared from `_render` based on cart contents. The
       snippet (window.HGN.cartTimer) owns all timer markup + CSS so
       this file stays under Shopify's 256 KB limit. */
    if (this.timerEl && this.titleEl && window.HGN && window.HGN.cartTimer) {
      window.HGN.cartTimer.mount(this.timerEl, { alternateWith: this.titleEl });
    }

    this.config = window.HGN_SIDE_CART_CONFIG || { shipping: {}, gift: { thresholds: {}, tiers: [] }, upsell: {} };
    this.cart = null;
    this.isOpen = false;
    this._fetchInflight = null;

    /* Beans state — populated on side-cart open via /api/beans/balance.
       `null` means we haven't fetched yet; `{ ... }` means we have a
       result (which may be zero balance). The render method branches
       on this to show one of three states (guest / empty / has-points). */
    this.beansBalance = null;
    this._beansFetchInflight = false;

    this._bind();
    this._bindPanelFocus();
    /* Pre-warm cart state so the badge count stays in sync from page
       load (independent of whether the drawer is open). */
    this.refresh();
    /* Pre-warm the Beans balance so the panel can render instantly
       when the side cart opens. Falls through to "guest" rendering
       if no customer email is on the page. */
    this._fetchBeansBalance();
  }

  HGNSideCart.prototype._bind = function () {
    var self = this;

    /* Open / close affordances. */
    document.addEventListener('hgn:cart:open', function () { self.open(); });
    /* Legacy event from other surfaces (header cart button, wishlist
       page add-to-cart, etc.). Kept until those surfaces migrate. */
    document.addEventListener('cart:open', function () { self.open(); });
    document.addEventListener('hgn:cart:close', function () { self.close(); });
    /* Re-fetch on any add/update broadcast — covers /cart/add.js calls
       from quick-add buttons, the kit Send-to-Cart flow, etc.
       Coalesce all three event names into one trailing-edge refresh so
       surfaces that paired-fire cart:refresh + cart:updated (or
       cart:change) don't trigger N back-to-back /cart.js hits and
       trip Shopify's per-IP rate limit. */
    var refreshDebounce = null;
    function debouncedRefresh() {
      if (refreshDebounce) return;
      refreshDebounce = setTimeout(function () {
        refreshDebounce = null;
        self.refresh();
      }, 150);
    }
    document.addEventListener('cart:update', debouncedRefresh);
    document.addEventListener('cart:refresh', debouncedRefresh);
    document.addEventListener('cart:change', debouncedRefresh);
    document.addEventListener('cart:updated', debouncedRefresh);
    /* Keep the foot's kit presentation live: accessory picks mutate
       kit memory without touching the cart — the button label, the
       virtual-basket subtotal/savings (an uplift pick changes the kit
       price) and the meter all have to track. Full re-render is safe
       here: it reads this.cart from memory, no fetch. */
    document.addEventListener('hgn:kit:change', function () {
      if (self.cart) self._render();
      else self._syncCheckoutLabel();
    });
    /* Back-from-checkout (bfcache). Safari/iOS restore this page with
       JS state frozen mid-checkout-click: _checkoutInflight true, the
       button disabled and stuck on "Securing your discount…", and
       every further tap silently no-ops (Matt hit this testing mixed
       baskets, 2026-08-08). pageshow{persisted:true} is the restore
       signal: reset the in-flight flags, restore the label, refresh —
       the cart may have changed at checkout. */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      self._checkoutInflight = false;
      self._kitCheckoutPending = false;
      /* Mint-gate state freezes with the page too (audit A1). */
      self._mintInflight = false;
      self._checkoutMintFailed = false;
      self._clearCheckoutNote();
      if (self.checkoutBtn) self.checkoutBtn.disabled = false;
      self._syncCheckoutLabel();
      self.refresh();
    });

    /* Surfaces that add via /cart/add without broadcasting any cart
       event — Spotlight <product-form> card quick-adds on collections/
       search, app embeds — left the header badge stale. Intercept
       fetch (same belt-and-braces pattern buy-buttons uses on the PDP)
       and ride the debounced refresh above; _syncHeaderBadge() runs on
       every refresh whether or not the drawer is open. Attaching an
       extra .then() to the returned promise doesn't consume the
       response body, so callers are unaffected. */
    if (!window.__hgnSideCartAddIntercept) {
      window.__hgnSideCartAddIntercept = true;
      var origFetch = window.fetch;
      window.fetch = function () {
        var url = arguments[0] && (arguments[0].url || arguments[0]);
        var result = origFetch.apply(this, arguments);
        try {
          if (typeof url === 'string' && /\/cart\/add(\.js)?([?#]|$)/.test(url)) {
            result.then(function (res) {
              if (res && res.ok) {
                debouncedRefresh();
                /* Audit-2 S1: a plain collection quick-add gave no
                   feedback beyond the badge tick — shoppers re-added
                   or doubted the click. Open the drawer on ANY cart
                   add (PDP parity); kit picks and drop-queue adds
                   don't travel /cart/add so modes are unaffected. */
                try { document.dispatchEvent(new CustomEvent('hgn:cart:open')); } catch (e) {}
              }
            }).catch(function () {});
          }
        } catch (e) {}
        return result;
      };
    }

    /* Move-to-drop (delegated): queue the item, then zero the cart
       line — the queue add is optimistic so the pick shows instantly
       in the UP NEXT section above. */
    this.root.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-hgn-side-cart-move-to-drop]');
      if (!btn || btn.disabled) return;
      var dqMv = window.HGN && window.HGN.dropQueue;
      if (!dqMv || typeof dqMv.addItem !== 'function') return;
      btn.disabled = true;
      btn.textContent = 'Moving\u2026';
      dqMv.addItem({
        variantId: btn.getAttribute('data-variant-id'),
        title: btn.getAttribute('data-title'),
        handle: btn.getAttribute('data-handle'),
        image: btn.getAttribute('data-image'),
        tier: btn.getAttribute('data-tier')
      }).then(function (res) {
        if (!res || !res.ok) {
          btn.disabled = false;
          btn.textContent = res && res.reason === 'duplicate' ? 'Already in your Nail Drop'
            : res && res.reason === 'wide-fit-pref' ? 'Outside your Wide Fit preference'
            : 'Couldn\u2019t move \u2014 try again';
          return;
        }
        return fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(btn.getAttribute('data-line'), 10), quantity: 0 }) /* _lineIndex is 1-based */
        });
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = 'Couldn\u2019t move \u2014 try again';
      });
    });

    /* Close button + scrim + escape. */
    $$('[data-hgn-side-cart-close]', this.root).forEach(function (btn) {
      btn.addEventListener('click', function () { self.close(); });
    });
    if (this.scrimEl) this.scrimEl.addEventListener('click', function () { self.close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.isOpen) self.close();
    });

    /* Outside-click auto-close. The header (z-index 10000) paints above
       the scrim (z-index 1100), so clicks on header / sticky elements
       never reach the scrim's click handler. Document-level pointerdown
       in capture phase catches them — close if the target is outside
       the panel. Cart-icon triggers (`[data-hgn-cart-trigger]`) are
       skipped so a click on the header cart icon while the cart is open
       doesn't close-then-reopen and flicker. */
    document.addEventListener('pointerdown', function (e) {
      if (!self.isOpen) return;
      if (!self.panel) return;
      if (self.panel.contains(e.target)) return;
      if (e.target.closest && e.target.closest('[data-hgn-cart-trigger]')) return;
      /* Skip clicks inside any modal that lives at document.body
         level (conflict modal, finish-kit modal, bundle-remove
         modal, focus modal, off-confirm modal). They're outside the
         panel structurally but the shopper is still inside the cart
         flow — closing on their click would feel like a bug. The
         `role="dialog"` selector catches anything that opts into
         modal semantics. */
      if (e.target.closest && e.target.closest('[role="dialog"]')) return;
      if (e.target.closest && e.target.closest('[data-hgn-np-conflict]')) return;
      self.close();
    }, true);

    /* Checkout button — intercept clicks so we can mint the
       consolidated cart discount before redirecting. */
    if (this.checkoutBtn) {
      this.checkoutBtn.addEventListener('click', function (e) {
        e.preventDefault();
        self._handleCheckout();
      });
    }

    /* Piggyback toggle (§11) — flips the hgn_piggyback cart attribute;
       the naildrop worker does the rest at orders-paid. */
    if (this.piggybackToggleEl) {
      this.piggybackToggleEl.addEventListener('click', function () {
        var btn = self.piggybackToggleEl;
        var on = String(((self.cart || {}).attributes || {}).hgn_piggyback || '') === '1';
        btn.disabled = true;
        fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: { hgn_piggyback: on ? '' : '1' } })
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            self.cart = cart;
            btn.disabled = false;
            self._renderPiggyback();
          })
          .catch(function () { btn.disabled = false; });
      });
    }

    /* Nail Points concertina toggle. */
    if (this.beansToggleEl && this.beansBodyEl) {
      this.beansToggleEl.addEventListener('click', function () {
        var open = self.beansToggleEl.getAttribute('aria-expanded') === 'true';
        self.beansToggleEl.setAttribute('aria-expanded', open ? 'false' : 'true');
        self.beansBodyEl.hidden = open;
      });
    }

    /* Nail Points apply / cancel CTA — clicks branch on the
       button's data action attribute (set by `_renderBeans`
       depending on whether a redemption is currently active). */
    if (this.beansCtaEl) {
      this.beansCtaEl.addEventListener('click', function () {
        if (self.beansCtaEl.disabled) return;
        var action = self.beansCtaEl.dataset.hgnBeansAction;
        if (action === 'redeem') self._handleBeansRedeem();
        else if (action === 'cancel') self._handleBeansCancel();
      });
    }

    /* Ad-hoc disclosure toggle + Apply / Remove wiring. */
    if (this.adhocToggleEl && this.adhocBodyEl) {
      this.adhocToggleEl.addEventListener('click', function () {
        var open = self.adhocToggleEl.getAttribute('aria-expanded') === 'true';
        self.adhocToggleEl.setAttribute('aria-expanded', open ? 'false' : 'true');
        self.adhocBodyEl.hidden = open;
      });
    }
    if (this.adhocApplyEl) {
      this.adhocApplyEl.addEventListener('click', function () {
        if (self.adhocApplyEl.disabled) return;
        self._handleAdHocApply();
      });
    }
    if (this.adhocInputEl) {
      this.adhocInputEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (!self.adhocApplyEl || self.adhocApplyEl.disabled) return;
          self._handleAdHocApply();
        }
      });
      /* Hide inline error as soon as the shopper starts editing. */
      this.adhocInputEl.addEventListener('input', function () {
        if (self.adhocErrorEl) {
          self.adhocErrorEl.hidden = true;
          self.adhocErrorEl.textContent = '';
        }
      });
    }
    if (this.adhocCancelEl) {
      this.adhocCancelEl.addEventListener('click', function () {
        self._handleAdHocCancel();
      });
    }

    /* Delegated qty / remove inside items list. */
    if (this.itemsEl) {
      this.itemsEl.addEventListener('click', function (e) {
        var target = e.target.closest('[data-hgn-side-cart-action]');
        if (!target) return;
        e.preventDefault();
        var action = target.getAttribute('data-hgn-side-cart-action');
        var line = parseInt(target.getAttribute('data-hgn-side-cart-line'), 10);
        var current = parseInt(target.getAttribute('data-hgn-side-cart-qty'), 10) || 0;
        if (action === 'inc') self._mutate(line, current + 1);
        else if (action === 'dec') self._mutate(line, Math.max(0, current - 1));
        else if (action === 'remove') self._mutate(line, 0);
        else if (action === 'remove-bundle') {
          var bundleId = target.getAttribute('data-hgn-side-cart-bundle');
          self._removeBundle(bundleId);
        } else if (action === 'toggle-bundle') {
          var card = target.closest('[data-hgn-side-cart-bundle-card]');
          if (!card) return;
          var open = card.classList.toggle('is-open');
          target.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
      });
    }
  };

  HGNSideCart.prototype.open = function () {
    if (this.isOpen) return;
    /* A re-open is a fresh run at checkout — drop any armed
       "continue without discount" verdict (audit A1). */
    this._checkoutMintFailed = false;
    if (this._clearCheckoutNote) this._clearCheckoutNote();
    this.isOpen = true;
    /* Remember what opened the drawer so focus can go back to it on close. */
    var opener = document.activeElement;
    this._opener = (opener && opener !== document.body && !this.panel.contains(opener)) ? opener : null;
    this.root.hidden = false;
    /* Force reflow so the transform transitions instead of snapping. */
    void this.panel.offsetWidth;
    this.root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add(BODY_OPEN_CLASS);
    var before = cartLineQtys(this.cart);
    this.refresh();
    this._settleOnOpen(before);
    /* Move focus into the panel for a11y. */
    setTimeout(function () { try { this.panel.focus(); } catch (e) {} }.bind(this), 50);
  };

  HGNSideCart.prototype.close = function () {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove(BODY_OPEN_CLASS);
    this._settleToken = (this._settleToken || 0) + 1;
    this.panel.removeAttribute('data-hgn-sc-settling');
    this.panel.removeAttribute('data-hgn-sc-revealed');
    /* Focus goes back to whatever opened the drawer (unless the shopper has
       already moved it somewhere else on the page). */
    var a = document.activeElement;
    var opener = this._opener;
    this._opener = null;
    if ((!a || a === document.body || this.panel.contains(a)) && opener && opener.isConnected && opener.getClientRects().length) {
      try { opener.focus({ preventScroll: true }); } catch (e) {}
    }
    /* Wait for transition before hiding so the slide-out animates. */
    setTimeout(function () {
      if (!this.isOpen) this.root.hidden = true;
    }.bind(this), 320);
  };

  /* One paint on open: the panel slides in at once but its contents stay
     hidden (CSS on data-hgn-sc-settling) until the refreshed cart has
     rendered, the attach row and offer card have resolved for this basket,
     a kit or free gift being added has landed, the visible images have
     loaded, and nothing has changed for 120 ms — capped at 1.2 s, stretched
     to at most 6 s while a kit or the gift lands. Then the line just added
     is scrolled into view and the contents fade in. */
  HGNSideCart.prototype._settleOnOpen = function (before) {
    var self = this;
    var panel = this.panel;
    if (!panel) return;
    var token = (this._settleToken = (this._settleToken || 0) + 1);
    var t0 = Date.now();
    var rendersAtOpen = renderCount;
    var lastMut = t0;
    panel.removeAttribute('data-hgn-sc-revealed');
    panel.setAttribute('data-hgn-sc-settling', '');
    var mo = null;
    try {
      mo = new MutationObserver(function () { lastMut = Date.now(); });
      mo.observe(panel, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
    } catch (e) {}
    function done(capped) {
      if (mo) { try { mo.disconnect(); } catch (e) {} }
      if (token !== self._settleToken) return;
      try { window.HGN = window.HGN || {}; window.HGN.sideCartSettle = { ms: Date.now() - t0, capped: !!capped }; } catch (e) {}
      var el = null;
      try { el = justAddedEl(self, before); if (el) scrollIntoBody(self, el); } catch (e) {}
      panel.removeAttribute('data-hgn-sc-settling');
      if (el) keepInView(self, el, token);
      panel.setAttribute('data-hgn-sc-revealed', '');
      setTimeout(function () { if (token === self._settleToken) panel.removeAttribute('data-hgn-sc-revealed'); }, 400);
    }
    var capAt = t0 + SETTLE_CAP_MS;
    (function poll() {
      if (token !== self._settleToken) return;
      if (!self.isOpen) { if (mo) { try { mo.disconnect(); } catch (e) {} } panel.removeAttribute('data-hgn-sc-settling'); return; }
      var now = Date.now();
      var fetching = !!self._fetchInflight || !!self._refreshAgain;
      var rendered = renderCount > rendersAtOpen || (!fetching && now - t0 > 300);
      var kit = kitLanding(self);
      /* The drawer adds the free gift itself once the basket crosses its line
         (a kit landing often does); the offer card redraws after it. */
      var gift = !!self._giftInflight;
      if (kit || gift) capAt = Math.min(t0 + KIT_SETTLE_CAP_MS, Math.max(capAt, now + 800));
      var waiting = fetching || !rendered || kit || gift || pairPending(self) || !!self._attachPending || (now - lastMut) < SETTLE_QUIET_MS || imagesPending(self);
      if (!waiting || now >= capAt) {
        var capped = waiting;
        requestAnimationFrame(function () { requestAnimationFrame(function () { done(capped); }); });
        return;
      }
      setTimeout(poll, 40);
    })();
  };

  /* Tab and Shift+Tab cycle inside the open panel (a body-level dialog —
     kit remove, conflict, finish-kit — keeps its own focus). Opening
     "Have a code?" scrolls its input into view: the panel opens inside the
     scrolling body, below the lines, where the sticky foot can cover it. */
  HGNSideCart.prototype._bindPanelFocus = function () {
    var self = this;
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !self.isOpen || !self.panel) return;
      var panel = self.panel;
      var a = document.activeElement;
      if (a && a !== document.body && !panel.contains(a) && a.closest && a.closest('[role="dialog"]')) return;
      var list = focusables(panel);
      if (!list.length) { e.preventDefault(); try { panel.focus(); } catch (x) {} return; }
      var first = list[0], last = list[list.length - 1];
      if (!panel.contains(a) || a === panel) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
      if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    }, true);
    if (this.adhocToggleEl) {
      this.adhocToggleEl.addEventListener('click', function () {
        setTimeout(function () {
          if (self.adhocToggleEl.getAttribute('aria-expanded') !== 'true') return;
          requestAnimationFrame(function () { scrollIntoBody(self, self.adhocEl, 12); });
        }, 0);
      });
    }
  };

  HGNSideCart.prototype.refresh = function () {
    var self = this;
    if (this._fetchInflight) {
      /* Coalesce, don't swallow. A fetch that's already mid-flight was
         dispatched BEFORE whatever change triggered this refresh (e.g.
         an add completing while the drawer-open fetch is airborne), so
         its response may be stale. Returning it as-is synced the badge
         to pre-change state and dropped the update entirely — the cause
         of the header count lagging until the next interaction. Queue
         exactly one follow-up fetch to run when the current one settles. */
      this._refreshAgain = true;
      return this._fetchInflight;
    }
    this._fetchInflight = fetchCart()
      .then(function (cart) {
        self._fetchInflight = null;
        /* Always hide the spinner — even if the fetch returned null
           (rate limit / parse fail). Without this, a single bad
           response leaves the side cart stuck on the loading state. */
        if (self.loadingEl) self.loadingEl.hidden = true;
        if (!cart) { self._maybeRefreshAgain(); return; }
        self.cart = cart;
        if (cart.item_count > 0) rememberPresentmentCurrency(cart.currency);
        self._render();
        self._syncHeaderBadge();
        /* 2026-09-27: also with the drawer closed when the code came by
           link (email /discount/POPUP-… or ?hgn_voucher=) — it must be
           adopted before ANY checkout route, incl. the /cart page. */
        if (self.isOpen || self._linkedWelcomeCode(cart)) self._maybeAutoApplyWelcome();
        if (self._welcomeRepairDesc()) self._repairWelcomeIntent();
        self._maybeAutoApplyFromQuery();
        self._maybeAutoAttachKit5();
        document.dispatchEvent(new CustomEvent('hgn:cart:change', { detail: { cart: cart } }));
        self._maybeRefreshAgain();
      })
      .catch(function () {
        self._fetchInflight = null;
        if (self.loadingEl) self.loadingEl.hidden = true;
        self._maybeRefreshAgain();
      });
    return this._fetchInflight;
  };

  /* Runs the queued follow-up refresh (see the coalescing guard in
     refresh()) once the in-flight fetch has fully settled. */
  HGNSideCart.prototype._maybeRefreshAgain = function () {
    if (!this._refreshAgain) return;
    this._refreshAgain = false;
    this.refresh();
  };

  HGNSideCart.prototype._mutate = function (line, qty) {
    var self = this;
    /* Capture the cart line key BEFORE the mutation — once Shopify
       removes the line, it's gone from the cart object. We need the
       key so that, if the line was a kit-transfer line, we can prune
       the matching pick from kit memory after the remove succeeds. */
    var doomedKey = null;
    if (qty === 0 && self.cart && Array.isArray(self.cart.items)) {
      var item = self.cart.items[line - 1];
      if (item && item.key) doomedKey = item.key;
    }
    return changeLine(line, qty).then(function (cart) {
      if (!cart) return;
      self.cart = cart;
      if (cart.item_count > 0) rememberPresentmentCurrency(cart.currency);
      self._render();
      self._syncHeaderBadge();
      if (doomedKey && window.HGN && window.HGN.kitProgress &&
          typeof window.HGN.kitProgress.pruneManifestForLineKey === 'function') {
        window.HGN.kitProgress.pruneManifestForLineKey(doomedKey);
      }
      document.dispatchEvent(new CustomEvent('hgn:cart:change', { detail: { cart: cart } }));
    });
  };

  /* Bundle remove — snapshot, ask via a three-action modal, execute:
       - Cancel: no-op
       - Move designs to cart: drop the bundle, re-add the picks as
         standalone retail lines. Accessories go (they were
         free-with-kit; re-pick if wanted).
       - Delete kit: drop the bundle, clear localStorage, no restore.
     Move + Delete also reset focus and flip build mode off when no
     other tier has picks (mirrors `autoFinalise`). The legacy
     auto-restore + pop-kit-bar behaviour is gone — it caused the "side
     cart goes blank" bug (`_render` ran mid-restoration, racing the
     empty-CTA gate against the kit-list re-render). */
  HGNSideCart.prototype._removeBundle = function (bundleId) {
    if (!bundleId || !this.cart) return;
    var snapshot = this._snapshotBundleForRemoval(bundleId);
    if (!snapshot) return;
    var self = this;
    return this._showBundleRemovePrompt(snapshot).then(function (decision) {
      if (decision === 'cancel') return;
      return self._executeBundleRemove(snapshot, { addPicksToCart: decision === 'move' });
    });
  };

  /* Pre-mutation snapshot: collects everything we need to (a) render
     the modal copy and (b) execute either branch without re-reading
     from `this.cart` (which will have changed by the time the
     execute step runs). */
  HGNSideCart.prototype._snapshotBundleForRemoval = function (bundleId) {
    var items = this.cart.items.filter(function (it) { return readBundleId(it) === bundleId; });
    if (!items.length) return null;
    var firstProps = (items[0] && items[0].properties) || {};
    var bundleType = firstProps._bundle_type || '';
    var label = firstProps['Bundle'] || firstProps._bundle_label || firstProps['_bundle_label'] || 'Starter Kit';
    var bundleDiscountCode = firstProps._discount_code || firstProps['_discount_code'] || null;
    var tier = null;
    if (/^classic-starter-kit/.test(bundleType)) tier = 'classic';
    else if (/^gels-starter-kit/.test(bundleType)) tier = 'gels';
    else if (/^press-ons-starter-kit/.test(bundleType)) tier = 'press-ons';

    /* Per-bundle savings — actual-price basis (2026-07-10): the
       real sum of the bundle's line prices minus the kit target,
       GBP-inverted because the modal renders via formatGbpCents.
       Returns 0 for legacy bundles without the target prop
       (acceptable per "don't worry about existing carts"). */
    var gbpPaidCents = readBundleTargetGbpCents(items[0]);
    /* One-unit basis — mirrors bundleSavingsPresentmentCents (B1). */
    var retailPresentmentCents = items.reduce(function (sum, it) {
      return sum + lineOneUnitRetailCents(it);
    }, 0);
    /* Same target preference as bundleSavingsPresentmentCents so the
       "you'll lose £X" warning can't quote a different saving. */
    var targetPresentmentCents = readBundleTargetPresentmentCents(items[0]);
    if (targetPresentmentCents == null && gbpPaidCents != null) {
      targetPresentmentCents = gbpCentsToActiveCents(gbpPaidCents);
    }
    var savingsGbpCents = targetPresentmentCents != null
      ? presentmentToGbpCents(Math.max(0, retailPresentmentCents - targetPresentmentCents))
      : 0;

    /* Partition lines into designs vs accessories so the Move path
       knows which lines to re-add. Accessory handles come from the
       merchant-configured accessory slots. */
    var accessoriesData = (tier && window.HGN_KIT_ACCESSORIES && window.HGN_KIT_ACCESSORIES[tier]) || {};
    var accessoryHandles = {};
    Object.keys(accessoriesData).forEach(function (slot) {
      (accessoriesData[slot] || []).forEach(function (opt) {
        if (opt && opt.handle) accessoryHandles[opt.handle] = true;
      });
    });

    var doomedKeys = [];
    var designItems = [];
    items.forEach(function (it) {
      if (it.key) doomedKeys.push(it.key);
      var handle = it.handle || '';
      if (!accessoryHandles[handle]) designItems.push(it);
    });

    return {
      bundleId:           bundleId,
      bundleItems:        items,
      designItems:        designItems,
      doomedKeys:         doomedKeys,
      bundleDiscountCode: bundleDiscountCode,
      tier:               tier,
      label:              label,
      savingsGbpCents:    savingsGbpCents,
      currency:           this.cart.currency
    };
  };

  /* Three-action confirm modal. Reuses the finish-kit modal chrome
     (`.hgn-finish-kit-modal__panel` etc.) plus a triple-button foot
     variant + destructive button style added to the section's
     stylesheet. Resolves with 'cancel' / 'move' / 'delete'. Scrim
     + Escape both resolve as 'cancel' so a miss-tap on the scrim
     doesn't accidentally finish the removal. */
  HGNSideCart.prototype._showBundleRemovePrompt = function (snapshot) {
    return new Promise(function (resolve) {
      var existing = document.querySelector('[data-hgn-bundle-remove-modal]');
      if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

      var savingsLine = '';
      if (snapshot.savingsGbpCents > 0) {
        savingsLine = 'You\u2019ll lose <strong>' +
          escapeHtml(formatGbpCents(snapshot.savingsGbpCents)) +
          ' off</strong>. ';
      }

      var modal = document.createElement('div');
      modal.className = 'hgn-finish-kit-modal';
      modal.setAttribute('data-hgn-bundle-remove-modal', '');
      modal.innerHTML =
        '<div class="hgn-finish-kit-modal__scrim" data-hgn-bundle-remove-cancel-scrim></div>' +
        '<div class="hgn-finish-kit-modal__panel" role="dialog" aria-modal="true" aria-labelledby="hgn-bundle-remove-title">' +
          '<header class="hgn-finish-kit-modal__head">' +
            '<p class="hgn-finish-kit-modal__eyebrow">Hold on</p>' +
            '<h2 class="hgn-finish-kit-modal__title" id="hgn-bundle-remove-title">' +
              'Remove your ' + escapeHtml(snapshot.label) + '?' +
            '</h2>' +
            '<p class="hgn-finish-kit-modal__copy">' +
              savingsLine + 'Keep your design picks in the cart at full price, or delete the kit completely.' +
            '</p>' +
          '</header>' +
          '<div class="hgn-finish-kit-modal__foot hgn-finish-kit-modal__foot--triple">' +
            '<button type="button" class="hgn-finish-kit-modal__cancel" data-hgn-bundle-remove-cancel-btn>Cancel</button>' +
            '<button type="button" class="hgn-finish-kit-modal__confirm hgn-finish-kit-modal__confirm--destructive" data-hgn-bundle-remove-delete>Delete kit</button>' +
            '<button type="button" class="hgn-finish-kit-modal__confirm" data-hgn-bundle-remove-move>Move designs to cart</button>' +
          '</div>' +
        '</div>';

      document.body.appendChild(modal);

      function done(decision) {
        if (modal.parentNode) modal.parentNode.removeChild(modal);
        document.removeEventListener('keydown', onKey);
        resolve(decision);
      }
      function onKey(e) { if (e.key === 'Escape') done('cancel'); }

      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-hgn-bundle-remove-cancel-scrim]')) { done('cancel'); return; }
        if (e.target.closest('[data-hgn-bundle-remove-cancel-btn]'))   { done('cancel'); return; }
        if (e.target.closest('[data-hgn-bundle-remove-move]'))          { done('move');   return; }
        if (e.target.closest('[data-hgn-bundle-remove-delete]'))        { done('delete'); return; }
      });
      document.addEventListener('keydown', onKey);
    });
  };

  /* Execute the chosen branch:
       opts.addPicksToCart === true  → Move (bundle out, picks back as
                                       standalone retail items).
       opts.addPicksToCart === false → Delete (bundle out, no re-add).
     Both paths share: cart mutation, manifest pruning, discount
     revocation, kit + focus + buildMode reset. */
  HGNSideCart.prototype._executeBundleRemove = function (snapshot, opts) {
    opts = opts || {};
    var self = this;

    var updates = {};
    snapshot.bundleItems.forEach(function (it) { updates[it.key] = 0; });

    /* Reset kit state BEFORE the cart mutation lands. If we wait
       until after, `_render` runs while kitProgress still has
       activeKit + items pointing at this tier, and the
       `kitInProgress` guard hides the "Your bag is empty" CTA — the
       blank-state bug. Clearing first means the gate evaluates to
       false and the empty CTA paints correctly. */
    var kp = (window.HGN && window.HGN.kitProgress) || null;
    if (kp && snapshot.tier) {
      try { if (typeof kp.clearKit === 'function') kp.clearKit(snapshot.tier); } catch (e) {}
      try { if (typeof kp.setFocus === 'function') kp.setFocus(null); } catch (e) {}
    }

    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(safeCartJson)
      .then(function (cart) {
        if (!cart) return null;
        if (!opts.addPicksToCart) return cart;
        /* Move path — re-add design picks as standalone retail line
           items. Skip anything without a variant_id (defensive — bundle
           lines should always carry one). Accessories deliberately
           dropped: they were free-with-kit, not items the shopper
           was buying at retail. */
        var items = (snapshot.designItems || [])
          .filter(function (it) { return it.variant_id; })
          .map(function (it)    { return { id: parseInt(it.variant_id, 10), quantity: 1 }; });
        if (!items.length) return cart;
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(safeCartJson).then(function (added) { return added || cart; });
      })
      .then(function (cart) {
        if (!cart) return;
        self.cart = cart;
        self._render();
        self._syncHeaderBadge();

        if (snapshot.doomedKeys.length && kp &&
            typeof kp.pruneManifestForLineKey === 'function') {
          snapshot.doomedKeys.forEach(kp.pruneManifestForLineKey);
        }

        document.dispatchEvent(new CustomEvent('hgn:cart:change', { detail: { cart: cart } }));

        if (snapshot.bundleDiscountCode) {
          fetch('https://holygrailnail.co/api/bundle/destroy-discount', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'omit',
            body: JSON.stringify({ code: snapshot.bundleDiscountCode })
          }).catch(function () {});
        }

        /* Auto-off build mode when no tier has picks left — same
           pattern `autoFinalise` uses. Keeps the shopper's storefront
           ATC behaviour normal once they've chosen to abandon a kit. */
        if (kp) {
          try {
            var s = kp.read();
            var anyOther = ['classic', 'gels', 'press-ons'].some(function (t) {
              return s.kits[t] && s.kits[t].items && s.kits[t].items.length > 0;
            });
            if (!anyOther && typeof kp.setKitBuildMode === 'function' &&
                kp.getKitBuildMode() === 'on') {
              kp.setKitBuildMode('off', { skipMigration: true, source: 'bundle-removed' });
            }
          } catch (e) {}
        }
      });
  };

  /* Fetch the customer's Beans (Nail Points) balance via the
     worker. Cached on `this.beansBalance`. Skipped for guests
     (no customer email) — the renderer falls back to the
     "sign in" state instead. */
  HGNSideCart.prototype._fetchBeansBalance = function () {
    var email = window.HGN_CUSTOMER_EMAIL;
    if (!email || typeof email !== 'string') {
      this.beansBalance = { hasAccount: false, isGuest: true };
      return Promise.resolve();
    }
    if (this._beansFetchInflight) return Promise.resolve();
    this._beansFetchInflight = true;
    var self = this;
    return fetch('https://holygrailnail.co/api/beans/balance', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'omit',
      body: JSON.stringify({ email: email })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        self._beansFetchInflight = false;
        if (data && data.ok) {
          self.beansBalance = {
            hasAccount: !!data.hasAccount,
            beans:      parseInt(data.beans, 10) || 0,
            gbpValue:   parseFloat(data.gbpValue) || 0,
            isGuest:    false
          };
        } else {
          self.beansBalance = { hasAccount: false, isGuest: false };
        }
        /* Re-render so the panel paints with the new state. */
        if (self.cart) self._render();
      })
      .catch(function (err) {
        self._beansFetchInflight = false;
        if (window && window.console) {
          console.warn('[hgn-side-cart] beans balance fetch failed:', err);
        }
        self.beansBalance = { hasAccount: false, isGuest: false };
      });
  };

  /* Helpers — find an active NAILPOINTS-* code on the cart (or
     null if none) + read the debit-id stashed in cart attributes
     so we know which Beans debit to cancel. The debit-id is
     written to `cart.attributes._hgn_nailpoints_debit_id` at
     redemption time and cleared on cancel. */
  HGNSideCart.prototype._findNailPointsCode = function () {
    if (!this.cart) return null;
    return (this.cart.discount_codes || []).find(function (d) {
      /* Match BOTH the intended `NAILPOINTS-*` prefix and the legacy
         `BEANS-*` prefix the worker is currently minting. The worker
         should be updated to mint with `NAILPOINTS-*`; until then,
         this matches both so the side cart recognises the code. */
      return d && d.code && (/^NAILPOINTS-/i.test(d.code) || /^BEANS-/i.test(d.code));
    }) || null;
  };
  HGNSideCart.prototype._readNailPointsDebitId = function () {
    if (!this.cart || !this.cart.attributes) return null;
    return this.cart.attributes._hgn_nailpoints_debit_id ||
           this.cart.attributes['_hgn_nailpoints_debit_id'] ||
           null;
  };

  /* Render the Nail Points concertina from cart state + cached
     balance. Three states:
       1. ACTIVE — NAILPOINTS-* on the cart and applicable: summary
          "£X off applied", body "Cancel & get points back".
       2. STALE — code on the cart but past Shopify's 1h TTL:
          silently auto-cancel (refund + scrub), re-render as idle.
       3. IDLE — summary "N points · £X" if redeemable + apply button;
          otherwise the earn message and a bare points count.
     Hidden entirely for guests and while the balance is loading. */
  HGNSideCart.prototype._renderBeans = function () {
    if (!this.beansEl || !this.beansMessageEl) return;
    /* Suppress the Nail Points panel entirely when an ad-hoc code is
       applied \u2014 the two are mutually exclusive at checkout, so showing
       both UIs side-by-side is misleading. Shopper removes the ad-hoc
       to apply Nail Points. */
    if (this._isAdHocActive()) {
      this.beansEl.hidden = true;
      return;
    }
    var b = this.beansBalance;
    if (!b || b.isGuest) {
      /* No data yet, or guest \u2014 keep the panel hidden entirely. */
      this.beansEl.hidden = true;
      return;
    }

    var intent = this._getDiscountIntent();
    var activeCode = this._findNailPointsCode();
    var currency = this.cart && this.cart.currency;

    /* STALE \u2014 a code was minted at a prior Checkout-click but
       Shopify has marked it `applicable: false` (the 1h discount TTL
       elapsed before checkout completed). Refund + scrub + clear all
       attributes silently. The auto-cancel triggers a refresh which
       re-enters this render in the idle/intent-cleared state. */
    if (activeCode && activeCode.applicable === false) {
      this._autoCancelStaleRedemption();
      this.beansEl.hidden = true;
      return;
    }

    /* ORPHAN \u2014 code attribute lingers but intent is null (e.g.
       tab closed mid-Checkout-click flow). Auto-refund + clear; same
       refresh path as stale. */
    if (intent !== 'nailpoints' &&
        (this._getMintedNailPointsCode() || this._readNailPointsDebitId() ||
         this._findNailPointsCode()) &&
        !this._orphanCancelInflight) {
      this._autoCancelOrphanNailPoints();
      this.beansEl.hidden = true;
      return;
    }

    /* ACTIVE intent \u2014 show the applied state + cancel CTA. The
       displayed amount comes from the intent attribute (set at apply
       time), not from a server-minted code (which won\u2019t exist
       until Checkout-click). */
    if (intent === 'nailpoints') {
      var amountGbp = this._getNailPointsAmountGbp();
      /* Pre-mint, show what the mint will actually send: the intent
         clamped to the current cart (the shopper may have removed items
         since Apply). Once a code exists its value is fixed. */
      if (!this._getMintedNailPointsCode()) {
        amountGbp = Math.min(amountGbp, this._maxRedeemGbp());
      }
      /* GBP → presentment cents before formatting (audit B5.3): a £5
         redemption used to render as "€5.00" on EUR carts while the
         savings row said €5.75. */
      var amountCents = gbpCentsToActiveCents(Math.round(amountGbp * 100));
      this.beansEl.hidden = false;
      if (this.beansSummaryEl) {
        this.beansSummaryEl.textContent = amountCents > 0
          ? formatMoney(amountCents, currency) + ' applied'
          : 'Applied';
      }
      this.beansMessageEl.innerHTML = amountCents > 0
        ? '<strong>' + formatMoney(amountCents, currency) + ' off</strong> applied via your Nail Points \u2014 your points are debited at checkout.'
        : '<strong>Nail Points discount applied</strong> \u2014 your points are debited at checkout.';
      if (this.beansCtaEl && this.beansCtaLabelEl) {
        this.beansCtaLabelEl.textContent = 'Cancel & get points back';
        this.beansCtaEl.hidden = false;
        this.beansCtaEl.disabled = false;
        this.beansCtaEl.dataset.hgnBeansAction = 'cancel';
        this.beansCtaEl.classList.add('hgn-side-cart__beans-cta--cancel');
      }
      return;
    }

    /* IDLE \u2014 no intent set. */
    if (!b.hasAccount || !b.beans || b.gbpValue < 1) {
      /* Logged in but no redeemable points \u2014 concertina trigger
         shows the points count (or generic if 0) + body shows the
         earn message. < \u00a31 means we\u2019d round to 0 anyway. */
      this.beansEl.hidden = false;
      if (this.beansSummaryEl) {
        this.beansSummaryEl.textContent = b.beans
          ? b.beans + ' points'
          : 'Earn at checkout';
      }
      this.beansMessageEl.innerHTML = b.beans
        ? 'You have <strong>' + b.beans + '</strong> Nail Points. Earn more with every order to unlock money off.'
        : 'Earn <strong>Nail Points</strong> with every order \u2014 redeem for money off at checkout.';
      if (this.beansCtaEl) {
        this.beansCtaEl.hidden = true;
        this.beansCtaEl.classList.remove('hgn-side-cart__beans-cta--cancel');
      }
      return;
    }

    /* IDLE with redeemable points. Offer the CLAMPED amount, never the
       raw balance \u2014 a code worth more than the cart cannot apply at
       checkout (its minimum-subtotal rule), so promising it is a lie. */
    var wholeGbp = this._maxRedeemGbp();
    var balanceGbp = Math.floor(b.gbpValue);
    if (wholeGbp < 1) {
      /* Cart too small to redeem anything: say so instead of hiding
         the points or offering an unusable discount. */
      this.beansEl.hidden = false;
      if (this.beansSummaryEl) {
        this.beansSummaryEl.textContent = b.beans + ' points';
      }
      this.beansMessageEl.innerHTML =
        'You have <strong>' + b.beans + ' points</strong> (' +
        formatMoney(gbpCentsToActiveCents(balanceGbp * 100), currency) +
        ') \u2014 add a little more to your cart to redeem them.';
      if (this.beansCtaEl) {
        this.beansCtaEl.hidden = true;
        this.beansCtaEl.classList.remove('hgn-side-cart__beans-cta--cancel');
      }
      return;
    }
    this.beansEl.hidden = false;
    if (this.beansSummaryEl) {
      this.beansSummaryEl.textContent = b.beans + ' points \u00b7 ' + formatMoney(gbpCentsToActiveCents(wholeGbp * 100), currency);
    }
    this.beansMessageEl.innerHTML = wholeGbp < balanceGbp
      ? ('You have <strong>' + b.beans + ' points</strong> \u2014 redeem <strong>' +
         formatMoney(gbpCentsToActiveCents(wholeGbp * 100), currency) + ' off</strong> this cart (the rest stays in your balance). Replaces other cart discounts.')
      : ('You have <strong>' + b.beans + ' points</strong> \u2014 redeem for <strong>' +
         formatMoney(gbpCentsToActiveCents(wholeGbp * 100), currency) + ' off</strong>. Replaces other cart discounts.');
    if (this.beansCtaEl && this.beansCtaLabelEl) {
      this.beansCtaLabelEl.textContent = 'Apply ' + formatMoney(gbpCentsToActiveCents(wholeGbp * 100), currency) + ' off';
      this.beansCtaEl.hidden = false;
      this.beansCtaEl.disabled = false;
      this.beansCtaEl.dataset.hgnBeansAction = 'redeem';
      this.beansCtaEl.classList.remove('hgn-side-cart__beans-cta--cancel');
    }
  };

  /* Apply button entry point. With the deferred-mint architecture
     this just persists the shopper's intent on cart attributes; the
     side cart re-renders to show the Nail Points discount instead of
     the kit/gift one. The NAILPOINTS-* code is minted at Checkout-
     click, not here. If kit lines or a gift line are present, opens
     the conflict modal first so the shopper can confirm the swap. */
  HGNSideCart.prototype._handleBeansRedeem = function () {
    if (!this.beansCtaEl) return;
    var b = this.beansBalance;
    if (!b || !b.hasAccount || b.gbpValue < 1) return;
    /* Clamped to the cart subtotal — the stored intent must always be
       an amount the minted code can actually deliver at checkout. */
    var wholeGbp = this._maxRedeemGbp();
    if (wholeGbp < 1) return;
    var self = this;

    function applyIntent() {
      var btn = self.beansCtaEl;
      var label = self.beansCtaLabelEl;
      if (btn) btn.disabled = true;
      if (label) label.textContent = 'Applying\u2026';
      /* If an ad-hoc intent is currently live, clear it first (with
         its post-checkout release + BASKET-* destroy) so we don't
         double-stack a competing discount path. NP wins per
         Principle 2 \u2014 nothing combines with Nail Points. */
      var clearAd = self._isAdHocActive() ? self._clearAdHocState() : Promise.resolve(null);
      clearAd
        .catch(function () {})
        .then(function () { return self._setNailPointsIntent(wholeGbp); })
        .catch(function (err) {
          if (window && window.console) {
            console.warn('[hgn-side-cart] set Nail Points intent failed:', err);
          }
        })
        .then(function () { return self.refresh(); });
    }

    if (this._hasKitOrGiftConflict() || this._isAdHocActive()) {
      this._openConflictModal({
        loss:     this._computeConflictLoss(),
        currency: this.cart && this.cart.currency,
        onCancel: function () { /* No-op \u2014 apply was never started. */ },
        onConfirm: applyIntent
      });
      return;
    }

    applyIntent();
  };

  /* Cancel button on the Nail Points panel. Hand off to
     `_clearNailPointsState`, which refunds via /api/beans/cancel if a
     code has already been minted (Scenario B from the architecture
     doc: shopper clicked Checkout, came back, decided to use kit/gift
     instead), scrubs any NAILPOINTS-* code from the cart, and clears
     all NP cart attributes.

     After the refresh lands, schedule a delayed second refresh ~600ms
     later. This gives the free-gift orchestrator a clean re-evaluation
     pass once `_giftInflight` has cleared \u2014 needed because the
     apply-side `_removeGiftLine` might still be in flight when Cancel
     fires, causing the immediate post-cancel render's orchestrator
     call to short-circuit on the inflight lock. */
  HGNSideCart.prototype._handleBeansCancel = function () {
    var btn = this.beansCtaEl;
    if (btn) btn.disabled = true;
    var label = this.beansCtaLabelEl;
    if (label) label.textContent = 'Cancelling\u2026';
    var self = this;
    this._clearNailPointsState()
      .catch(function () {})
      .then(function () { return self.refresh(); })
      .then(function () {
        if (btn) btn.disabled = false;
        /* DON'T restore the label here \u2014 `_renderBeans` (run inside
           refresh()) already painted the correct idle-state label
           ("Apply \u00a3X off" or earn-state copy). Restoring whatever the
           label said when the click landed would clobber that. */
        setTimeout(function () { self.refresh(); }, 600);
      });
  };

  /* Auto-cancel a STALE redemption \u2014 a NAILPOINTS-* code is on the
     cart but Shopify has marked it `applicable: false` (the 1h discount
     TTL elapsed before the shopper finished checkout). Same call as the
     user-initiated cancel: refund + scrub + clear all attributes.
     Idempotent via `_staleCancelInflight` so a render storm doesn't
     fire multiple cancels for the same orphan. */
  HGNSideCart.prototype._autoCancelStaleRedemption = function () {
    if (this._staleCancelInflight) return;
    this._staleCancelInflight = true;
    var self = this;
    this._clearNailPointsState()
      .catch(function () {})
      .then(function () { return self.refresh(); })
      .then(function () { self._staleCancelInflight = false; });
  };

  /* Remove any NAILPOINTS-* discount codes from the cart while
     preserving everything else (BASKET-* etc.). Same pattern as
     `clearStaleBasketCodes` — Shopify's AJAX cart API has no
     surgical "remove one code" call, so we clear all + re-apply
     the survivors. Also clears the cart attributes that drove
     the active-redemption render. */
  HGNSideCart.prototype._stripNailPointsCode = function () {
    if (!this.cart) return Promise.resolve();
    var codes = (this.cart.discount_codes || []);
    /* Match BOTH the intended NAILPOINTS-* prefix and the legacy
       BEANS-* prefix the worker is currently minting. Either should
       be scrubbed on cancel; non-NP codes (welcome promos etc.) are
       preserved. */
    function isNpCode(d) {
      return d && d.code && (/^NAILPOINTS-/i.test(d.code) || /^BEANS-/i.test(d.code));
    }
    var hasNailPoints = codes.some(isNpCode);
    var preserved = codes
      .filter(function (d) { return d && d.code && !isNpCode(d); })
      .map(function (d) { return d.code; });

    var self = this;
    /* Clear attributes regardless — even if there's no code (orphan
       case), we want the stale debit-id off the cart. */
    var clearAttrs = fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        attributes: {
          _hgn_nailpoints_debit_id: '',
          _hgn_nailpoints_amount: ''
        }
      })
    }).catch(function () {});

    if (!hasNailPoints) {
      /* Nothing to scrub on the discount side — just clear attrs +
         refresh. */
      return clearAttrs.then(function () {
        if (self.beansBalance) self.beansBalance.activeAmount = null;
        return Promise.all([self.refresh(), self._fetchBeansBalance()]);
      });
    }

    return clearAttrs.then(function () {
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: '' })
      });
    }).then(function () {
      if (preserved.length === 0) return null;
      return preserved.reduce(function (p, code) {
        return p.then(function () {
          return fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: code })
          });
        });
      }, Promise.resolve());
    }).then(function () {
      if (self.beansBalance) self.beansBalance.activeAmount = null;
      return Promise.all([self.refresh(), self._fetchBeansBalance()]);
    }).catch(function (err) {
      if (window && window.console) {
        console.warn('[hgn-side-cart] strip NailPoints code failed:', err);
      }
    });
  };

  /* ───────── Nail Points × Kit / Free Gift conflict (deferred-mint) ─────────
     NAILPOINTS is mutually exclusive with the BASKET-* discount that
     funds kit savings + free gifts — but neither is minted until
     Checkout-click, so apply / cancel is a pure UI-state flip backed
     by cart attributes: the drawer renders from INTENT, never from
     codes actually on the cart. The gift orchestrator drops the gift
     line when intent flips on (`_isNailPointsActive`) and re-adds it
     when it flips off and the qualifying subtotal still clears.

     Cart attributes: _hgn_discount_intent ("nailpoints" | absent) —
     the SINGLE signal driving every render branch;
     _hgn_nailpoints_amount_gbp (string GBP); _hgn_nailpoints_code and
     _hgn_nailpoints_debit_id, set only after a Checkout-click mint and
     cleared by (a) checkout completion, (b) cancel into the kit/gift
     path (refund via /api/beans/cancel), or (c)
     `_autoCancelOrphanNailPoints` when intent is null but the code
     attr lingers (tab-close mid-flow). */

  HGNSideCart.prototype._getDiscountIntent = function () {
    if (!this.cart || !this.cart.attributes) return null;
    var v = this.cart.attributes._hgn_discount_intent ||
            this.cart.attributes['_hgn_discount_intent'];
    if (v === 'nailpoints' || v === 'adhoc') return v;
    return null;
  };
  HGNSideCart.prototype._getNailPointsAmountGbp = function () {
    if (!this.cart || !this.cart.attributes) return 0;
    var raw = this.cart.attributes._hgn_nailpoints_amount_gbp ||
              this.cart.attributes['_hgn_nailpoints_amount_gbp'];
    var n = parseFloat(raw);
    return isFinite(n) && n > 0 ? n : 0;
  };
  HGNSideCart.prototype._getMintedNailPointsCode = function () {
    if (!this.cart || !this.cart.attributes) return null;
    return this.cart.attributes._hgn_nailpoints_code ||
           this.cart.attributes['_hgn_nailpoints_code'] || null;
  };

  /* Set the apply intent. Worker is NOT called — render re-paints
     with NP savings on the next refresh. */
  /* The most a redemption may be worth RIGHT NOW: the smaller of the
     points balance and the cart's item subtotal, floored to whole GBP.
     The minted NAILPOINTS-* code carries a Shopify minimum-subtotal
     requirement equal to its own value, so a code larger than the cart
     silently fails to apply at checkout (Claire Spoor, 17 Aug: "£25.00
     applied" on a £17.99 cart → checkout at full price, five times).
     Clamping here keeps every minted code ≤ the cart it's minted for.
     Subtotal is presentment cents → GBP via the live FX rate. */
  HGNSideCart.prototype._maxRedeemGbp = function () {
    var subCents = this.cart && this.cart.items_subtotal_price ? this.cart.items_subtotal_price : 0;
    var rate = fxRate() || 1;
    var cartGbp = Math.floor(subCents / (rate * 100));
    var b = this.beansBalance;
    var balGbp = (b && isFinite(b.gbpValue)) ? Math.floor(b.gbpValue) : Infinity;
    return Math.max(0, Math.min(cartGbp, balGbp));
  };

  HGNSideCart.prototype._setNailPointsIntent = function (amountGbp) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        attributes: {
          _hgn_discount_intent:       'nailpoints',
          _hgn_nailpoints_amount_gbp: String(amountGbp || 0)
        }
      })
    });
  };

  /* Persist a freshly-minted code + debit ID after a Checkout-click
     /api/beans/redeem so a back-from-checkout re-checkout reuses the
     code instead of re-debiting. */
  HGNSideCart.prototype._setMintedNailPoints = function (code, debitId, amountGbp) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        attributes: {
          _hgn_nailpoints_code:     String(code || ''),
          _hgn_nailpoints_debit_id: String(debitId || ''),
          _hgn_nailpoints_amount:   String(amountGbp || 0)
        }
      })
    });
  };

  /* Clear ALL Nail Points state — intent + amount + (if a code has
     been minted) refund the points via /api/beans/cancel + scrub the
     NAILPOINTS-* code from the cart. Used by:
       • the Cancel button on the Nail Points panel
       • orphan auto-cancel on init (code attr present, intent null)

     Order: refund (worker) → scrub code (cart AJAX) → clear all NP
     cart attributes → resolve. On refund failure we still clear
     locally so the shopper isn't stranded — the orphan debit goes to
     ops via Beans logs. */
  HGNSideCart.prototype._clearNailPointsState = function () {
    var self = this;
    var code  = this._getMintedNailPointsCode();
    var debit = this._readNailPointsDebitId();

    function callCancel() {
      if (!debit) return Promise.resolve(null);
      return fetch('https://holygrailnail.co/api/beans/cancel', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        body: JSON.stringify({ debitId: debit })
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (window && window.console) {
            if (data && data.ok) {
              console.info('[hgn-side-cart] Nail Points refunded on intent-clear:', data.pointsRefunded);
            } else {
              console.warn('[hgn-side-cart] Nail Points cancel returned non-ok on intent-clear:', data);
            }
          }
        })
        .catch(function (err) {
          if (window && window.console) {
            console.warn('[hgn-side-cart] Nail Points cancel error on intent-clear:', err);
          }
        });
    }

    function clearAttrs() {
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          attributes: {
            _hgn_discount_intent:        '',
            _hgn_nailpoints_amount_gbp:  '',
            _hgn_nailpoints_code:        '',
            _hgn_nailpoints_debit_id:    '',
            _hgn_nailpoints_amount:      ''
          }
        })
      }).catch(function () {});
    }

    return callCancel()
      .then(function () {
        /* Strip on CART TRUTH, not just the minted-code attribute. A
           stale NAILPOINTS/BEANS code with already-cleared attributes
           used to skip the strip here — the code survived, the stale
           branch re-fired on every render, and the cancel→refresh
           cycle looped forever, hammering /cart until rate-limited
           (audit B5.2). */
        var hasCartCode = !!self._findNailPointsCode();
        if (!code && !hasCartCode) return null;
        return self._stripNailPointsCode();
      })
      .then(clearAttrs);
  };

  /* Loss preview for the conflict modal — bundle savings + gift
     retail computed DIRECTLY off the cart's groups (not via
     `_computeTotalSavings`, which now returns 0 when intent is
     already nailpoints). Keeps the modal's figures honest if the
     modal is somehow re-triggered after intent has been set.

     Bundle + gift figures are GBP pence (canonical, formatLive-
     localized when rendered). Ad-hoc figures stay in presentment
     cents because they're derived from the cart's presentment-
     currency subtotals — both formats end up in the buyer's
     currency when rendered, just via different conversion paths. */
  HGNSideCart.prototype._computeConflictLoss = function () {
    var zero = { bundleGbpCents: 0, giftGbpCents: 0, adhocCents: 0, bundleLabel: '', giftLabel: '', adhocLabel: '', hasBundle: false, hasGift: false, hasAdHoc: false };
    if (!this.cart) return zero;
    var groups = groupCartLines((this.cart.items || []).slice());
    /* Actual-price basis (2026-07-10) — same math as
       `_computeTotalSavings`, GBP-inverted because the modal
       renders these via formatGbpCents. */
    var bundlePresentmentCents = 0;
    (groups.bundles || []).forEach(function (b) {
      bundlePresentmentCents += bundleSavingsPresentmentCents(b);
    });
    var bundleGbpCents = presentmentToGbpCents(bundlePresentmentCents);
    var giftPresentmentCents = 0;
    (groups.gifts || []).forEach(function (g) {
      giftPresentmentCents += giftRetailPresentmentCents(g);
    });
    var giftGbpCents = presentmentToGbpCents(giftPresentmentCents);
    var savedBundles = (groups.bundles || []).filter(function (b) {
      return b.gbpPaidCents != null;
    });
    var bundleLabel = '';
    if (savedBundles.length === 1) bundleLabel = savedBundles[0].label || 'Starter Kit';
    else if (savedBundles.length > 1) bundleLabel = savedBundles.length + ' Starter Kits';
    var giftLabel = '';
    if (groups.gifts && groups.gifts.length > 0) {
      var g = groups.gifts[0];
      giftLabel = g.product_title || g.title || 'Free gift';
    }
    /* Ad-hoc loss — when NP is applied on top of an active ad-hoc,
       the ad-hoc gets scrubbed. Include its savings preview in the
       conflict list so the shopper sees the full picture. */
    var adhocCents = 0;
    var adhocLabel = '';
    if (this._isAdHocActive() && this._getAdHocClass() === 'order') {
      var st = this._adHocCartState();
      adhocCents = this._computeAdHocPreviewCents({
        discountClass: 'order',
        valueType: this._getAdHocValueType(),
        value:     this._getAdHocValue()
      }, st.nonKitNonGiftSubtotalCents);
      adhocLabel = this._getAdHocCode() || '';
    }
    return {
      bundleGbpCents: bundleGbpCents,
      giftGbpCents:   giftGbpCents,
      adhocCents:     adhocCents,
      bundleLabel:    bundleLabel,
      giftLabel:      giftLabel,
      adhocLabel:     adhocLabel,
      hasBundle:      savedBundles.length > 0,
      hasGift:        !!giftLabel,
      hasAdHoc:       adhocCents > 0 || !!adhocLabel
    };
  };

  HGNSideCart.prototype._hasKitOrGiftConflict = function () {
    var loss = this._computeConflictLoss();
    return loss.hasBundle || loss.hasGift;
  };

  /* Orphan auto-cancel — if a code attr is present but intent is
     null (tab close mid-flow, or some external removal), refund the
     debit + scrub the code. Idempotent via `_orphanCancelInflight`. */
  HGNSideCart.prototype._autoCancelOrphanNailPoints = function () {
    if (this._orphanCancelInflight) return;
    if (this._getDiscountIntent() === 'nailpoints') return;
    if (!this._getMintedNailPointsCode() && !this._readNailPointsDebitId() &&
        !this._findNailPointsCode()) return;
    this._orphanCancelInflight = true;
    var self = this;
    this._clearNailPointsState().catch(function () {}).then(function () {
      self._orphanCancelInflight = false;
      return self.refresh();
    });
  };

  /* DELETED 2026-05-12 — snapshot / strip / restore machinery.
     The deferred-mint architecture eliminated the need to mutate
     kit / gift cart lines on apply; intent is now a pure attribute
     flip and the side cart re-renders accordingly. Recovery from
     mid-flow interruption is handled by `_autoCancelOrphanNailPoints`
     (above) — no snapshot to restore. */


  /* ─────────── Ad-hoc code (shopper-supplied) helpers ───────────
     Companion to the Nail Points helpers above. Same deferred-mint
     model: Apply writes cart attributes; the combined `BASKET-*` is
     minted at Checkout-click. See `redesigned/SIDE-CART.md` §16 for
     the full state machine + routing matrix. */

  HGNSideCart.prototype._getAdHocCode = function () {
    if (!this.cart || !this.cart.attributes) return null;
    return this.cart.attributes._hgn_adhoc_code ||
           this.cart.attributes['_hgn_adhoc_code'] || null;
  };
  HGNSideCart.prototype._getAdHocClass = function () {
    if (!this.cart || !this.cart.attributes) return null;
    var v = this.cart.attributes._hgn_adhoc_class ||
            this.cart.attributes['_hgn_adhoc_class'] || null;
    return (v === 'order' || v === 'product' || v === 'shipping') ? v : null;
  };
  HGNSideCart.prototype._getAdHocValueType = function () {
    if (!this.cart || !this.cart.attributes) return null;
    var v = this.cart.attributes._hgn_adhoc_value_type ||
            this.cart.attributes['_hgn_adhoc_value_type'] || null;
    return (v === 'percentage' || v === 'fixed-amount') ? v : null;
  };
  HGNSideCart.prototype._getAdHocValue = function () {
    if (!this.cart || !this.cart.attributes) return 0;
    var raw = this.cart.attributes._hgn_adhoc_value ||
              this.cart.attributes['_hgn_adhoc_value'];
    var n = parseFloat(raw);
    return isFinite(n) ? n : 0;
  };
  HGNSideCart.prototype._isAdHocActive = function () {
    if (!this.cart || !this.cart.attributes) return false;
    var v = this.cart.attributes._hgn_discount_intent ||
            this.cart.attributes['_hgn_discount_intent'];
    return v === 'adhoc';
  };

  /* Write ad-hoc intent + descriptor to cart attributes. The
     descriptor lets us re-compute the previewed savings + drive the
     checkout-click branch without re-hitting /api/discount/inspect
     on every render. */
  HGNSideCart.prototype._setAdHocIntent = function (descriptor) {
    descriptor = descriptor || {};
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        attributes: {
          _hgn_discount_intent:    'adhoc',
          _hgn_adhoc_code:         String(descriptor.code || ''),
          _hgn_adhoc_class:        String(descriptor.discountClass || ''),
          _hgn_adhoc_value_type:   String(descriptor.valueType || ''),
          _hgn_adhoc_value:        String(descriptor.value == null ? '' : descriptor.value)
        }
      })
    });
  };

  /* Clear ALL ad-hoc state. Mirror of `_clearNailPointsState`:
       1. If a combined BASKET-* was minted on a prior Checkout-click
          (the shopper went to checkout and bounced back), invalidate
          it via `/api/cart-discount/destroy` AND release the
          customer-tag / guest-KV usage marker so the shopper can
          re-apply later.
       2. Scrub any BASKET-* code from cart.
       3. Clear all `_hgn_adhoc_*` + intent cart attributes. */
  HGNSideCart.prototype._clearAdHocState = function () {
    var self = this;
    /* Removed or refused — never repair it back (see _welcomeRepairDesc). */
    try { sessionStorage.removeItem('hgn-welcome-desc'); } catch (e) {}
    var adHocCode = this._getAdHocCode();
    var mintedBasket = this._findBasketCode();

    function releaseUsageMarker() {
      if (!adHocCode) return Promise.resolve(null);
      return fetch('https://holygrailnail.co/api/discount/release', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        body: JSON.stringify({
          adHocCode: adHocCode,
          customerId: window.HGN_CUSTOMER_ID || '',
          email: window.HGN_CUSTOMER_EMAIL || ''
        })
      }).catch(function () { /* Best-effort; not fatal. */ });
    }
    function clearAttrs() {
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          attributes: {
            _hgn_discount_intent:   '',
            _hgn_adhoc_code:        '',
            _hgn_adhoc_class:       '',
            _hgn_adhoc_value_type:  '',
            _hgn_adhoc_value:       '',
            /* kit5 fold rides the same clear — Remove resets everything. */
            _hgn_kit5_token:        '',
            _hgn_kit5_currency:     '',
            _hgn_kit5_amount_cents: ''
          }
        })
      }).catch(function () {});
    }

    return releaseUsageMarker()
      .then(function () {
        if (!mintedBasket) return null;
        return clearStaleBasketCodes(self.cart);
      })
      .then(clearAttrs);
  };

  /* Helper — scan `cart.discount_codes` for a `BASKET-*` we minted.
     Used by `_clearAdHocState` to decide whether to call destroy. */
  HGNSideCart.prototype._findBasketCode = function () {
    if (!this.cart || !Array.isArray(this.cart.discount_codes)) return null;
    for (var i = 0; i < this.cart.discount_codes.length; i++) {
      var d = this.cart.discount_codes[i];
      if (d && d.code && /^BASKET-/i.test(d.code)) return d.code;
    }
    return null;
  };

  /* Cart-state helpers for the apply-router. "Kit lines" = any line
     with `_bundle_id`. "Non-kit subtotal" = `items_subtotal_price` −
     sum of bundled-line `final_line_price`. "Gift line" = the line
     flagged via `_gift_line` (free-gift orchestrator's marker). */
  HGNSideCart.prototype._adHocCartState = function () {
    var cart = this.cart || { items: [], items_subtotal_price: 0 };
    var items = Array.isArray(cart.items) ? cart.items : [];
    var subtotalCents = cart.items_subtotal_price || 0;
    var kitCents = 0;
    var kitLines = 0;
    var giftRetailCents = 0;
    var giftLines = 0;
    var nonKitLines = 0;
    items.forEach(function (it) {
      var p = it && it.properties ? it.properties : {};
      var isGift = !!(p._gift_line || p['_gift_line']);
      var bundleId = p._bundle_id || p['_bundle_id'];
      if (isGift) {
        giftRetailCents += it.original_line_price != null ? it.original_line_price : (it.line_price || 0);
        giftLines += 1;
        return;
      }
      if (bundleId) {
        kitCents += it.final_line_price != null ? it.final_line_price : (it.line_price || 0);
        kitLines += 1;
        return;
      }
      nonKitLines += 1;
    });
    var nonKitNonGiftSubtotalCents = Math.max(0, subtotalCents - kitCents - giftRetailCents);
    return {
      subtotalCents:               subtotalCents,
      kitCents:                    kitCents,
      kitLines:                    kitLines,
      giftRetailCents:             giftRetailCents,
      giftLines:                   giftLines,
      nonKitLines:                 nonKitLines,
      nonKitNonGiftSubtotalCents:  nonKitNonGiftSubtotalCents,
      hasKit:                      kitLines > 0,
      hasGift:                     giftLines > 0,
      hasNonKitItems:              nonKitLines > 0,
      isKitOnly:                   kitLines > 0 && nonKitLines === 0
    };
  };

  /* Any Nail Drop line blocks welcome auto-apply: the dummy
     subscription SKU carries a selling plan, and Drop-grouped lines
     carry `_bundle_type: 'nail-drop'` (NAILDROP-BUILD conventions).
     Checked alongside kit/gift so the Drop system owns its own
     discount story from day one. */
  HGNSideCart.prototype._hasDropLine = function () {
    var items = (this.cart && Array.isArray(this.cart.items)) ? this.cart.items : [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it) continue;
      if (it.selling_plan_allocation) return true;
      var p = it.properties || {};
      if ((p._bundle_type || p['_bundle_type']) === 'nail-drop') return true;
    }
    return false;
  };

  /* ─────── Welcome-code auto-apply (popup bridge) ───────
     A shopper holding an active popup welcome code shouldn't have to
     copy-paste it into the voucher slot — apply it for them, via the
     exact same inspect + intent path as a typed code.

     STRICTLY the clean-cart case. Silently do nothing when there are
     kit or gift lines (§16.2.3 refuses order codes on kit carts), Nail
     Drop lines (_hasDropLine), or any intent already set (NP/ad-hoc),
     a minted BASKET-*, or Shopify-side discounts already showing (a
     cookied /discount link) — first come, first served.
     One attempt per code per session; refusals (already redeemed,
     deactivated…) stay invisible — the shopper never asked, so never
     sees an error — and leave the code pre-filled as a soft prompt. */
  /* A POPUP code that arrived by link: in Shopify's session
     (cart.discount_codes — the welcome emails' /discount/CODE buttons) or
     on the URL / sessionStorage (?hgn_voucher=). `only === 'session'`
     checks just the first. Returns the code or null. */
  HGNSideCart.prototype._linkedWelcomeCode = function (cart, only) {
    try {
      var codes = (cart && cart.discount_codes) || [];
      for (var i = 0; i < codes.length; i++) {
        var c = codes[i] && codes[i].code;
        if (c && /^POPUP-[A-Z0-9]{4,8}$/i.test(c)) return String(c).toUpperCase();
      }
      if (only === 'session') return null;
      if (/[?&](?:hgn_voucher|discount)=POPUP-/i.test(String(window.location.search || ''))) return 'url';
      try { if (sessionStorage.getItem('hgn-welcome-url')) return 'url'; } catch (e) {}
    } catch (e) {}
    return null;
  };

  /* The adopted welcome code's descriptor when the basket has LOST it
     (intent attrs gone, no other intent, no kit, nothing in flight) — the
     caller re-writes it. At most twice per page. Null otherwise. */
  HGNSideCart.prototype._welcomeRepairDesc = function () {
    try {
      if (this._adHocApplyInflight || this._welcomeRepairInflight) return null;
      if ((this._welcomeRepairs || 0) >= 2) return null;
      var raw = null;
      try { raw = sessionStorage.getItem('hgn-welcome-desc'); } catch (e) { raw = null; }
      if (!raw) return null;
      var desc = JSON.parse(raw);
      if (!desc || !desc.code) return null;
      var cart = this.cart;
      if (!cart || !Array.isArray(cart.items) || !cart.items.length) return null;
      if (this._getDiscountIntent() !== null) return null;
      if (this._adHocCartState().hasKit) return null;
      return desc;
    } catch (e) { return null; }
  };
  HGNSideCart.prototype._repairWelcomeIntent = function () {
    var desc = this._welcomeRepairDesc();
    if (!desc) return Promise.resolve(false);
    var self = this;
    this._welcomeRepairs = (this._welcomeRepairs || 0) + 1;
    this._welcomeRepairInflight = true;
    return this._setAdHocIntent(desc)
      .then(function () { self._welcomeRepairInflight = false; return self.refresh(); })
      .then(function () { return true; })
      .catch(function () { self._welcomeRepairInflight = false; return false; });
  };

  HGNSideCart.prototype._maybeAutoApplyWelcome = function () {
    try {
      if (this._welcomeAutoTried) return;
      var held = null;
      /* Popup bridge (same device as sign-up) — drawer-open only, as before. */
      if (this.isOpen && window.HGNPopup && typeof window.HGNPopup.activeCode === 'function') {
        held = window.HGNPopup.activeCode();
      }
      /* 2026-09-27: a POPUP code the welcome emails applied by LINK
         (holygrailnail.com/discount/{{ person.popup_discount_code }}) sits
         in Shopify's session, not in the drawer. Left there it clashes at
         checkout with the free gift's BASKET-* (POPUP codes don't combine)
         and the gift is charged (Help Scout #15323 / #15357). Adopt it into
         the ad-hoc flow so it folds into the one BASKET-*. */
      var sessionCode = null;
      if (!held || !held.code) {
        sessionCode = this._linkedWelcomeCode(this.cart, 'session');
        if (sessionCode) held = { code: sessionCode };
      }
      /* 2026-09-27: a popup code can also arrive on an email link —
         `?hgn_voucher=POPUP-XXXXXX` (same param the KIT5 bridge reads).
         That's the shopper on another device from the one they signed
         up on, who otherwise types the code into Shopify's checkout box,
         where it can't combine with the free gift's BASKET-* and the gift
         is charged (Help Scout #15323 / #15357). Kept in sessionStorage
         so it survives navigating away from the landing page. */
      if (!held || !held.code) {
        var urlCode = null;
        try {
          /* `?discount=POPUP-…` too: the flow emails (wave-2 cart/checkout/
             browse, the rebuilt welcome) put that on product + collection
             links, but Shopify only honours ?discount= on /checkout URLs —
             on a storefront page it applied nothing (verified 27 Sep). */
          var um = /[?&](?:hgn_voucher|discount)=(POPUP-[A-Za-z0-9]{4,8})(?:[&#]|$)/i.exec(String(window.location.search || ''));
          if (um) {
            urlCode = um[1].toUpperCase();
            try { sessionStorage.setItem('hgn-welcome-url', urlCode); } catch (e) {}
          } else {
            try { urlCode = sessionStorage.getItem('hgn-welcome-url'); } catch (e) {}
          }
        } catch (e) { urlCode = null; }
        if (urlCode) held = { code: urlCode };
      }
      if (!held || !held.code || held.code.indexOf('POPUP-') !== 0) return;
      var seenKey = 'hgn-welcome-auto';
      try { if (sessionStorage.getItem(seenKey) === held.code) return; } catch (e) {}
      var cart = this.cart;
      if (!cart || !Array.isArray(cart.items) || !cart.items.length) return;
      /* A session-applied POPUP code IS the cart's discount — don't let it
         block its own adoption. */
      if (!sessionCode && (cart.total_discount || 0) > 0) return;
      var state = this._adHocCartState();
      /* 2026-09-27: a free-gift cart is no longer skipped — the gift
         branch of _routeAdHocApply folds code + gift into one BASKET-*
         at Checkout, and in silent mode it steps aside (code pre-filled,
         no modal) when the code would knock the gift out. Kits still
         skip: codes don't apply to Starter Kits. */
      if (state.hasKit) return;
      if (this._hasDropLine()) return;
      if (this._getDiscountIntent() !== null) return;
      if (this._findBasketCode()) return;
      this._welcomeAutoTried = true;
      try { sessionStorage.setItem(seenKey, held.code); } catch (e) {}
      this._adHocSilent = true;
      /* _handleAdHocApply clears session codes before inspecting; if the
         inspect can't be reached, put a link-applied code back. */
      this._adHocRestoreCode = sessionCode || null;
      this._welcomeAdopting = held.code;
      this._handleAdHocApply(held.code);
    } catch (e) {
      this._adHocSilent = false;
      if (window && window.console) {
        console.warn('[hgn-side-cart] welcome auto-apply skipped:', e && e.message ? e.message : e);
      }
    }
  };

  /* Apply previewed savings for an inspected order-class ad-hoc
     against a given non-kit-non-gift subtotal. Mirror of the
     worker's compute logic in `/api/cart-discount/create-with-adhoc`
     so the side cart can show "You'll save £Y" before checkout-
     click without a second worker call. */
  HGNSideCart.prototype._computeAdHocPreviewCents = function (descriptor, subtotalCents) {
    if (!descriptor || descriptor.discountClass !== 'order') return 0;
    var v = descriptor.value;
    if (typeof v !== 'number' || !isFinite(v)) return 0;
    if (descriptor.valueType === 'percentage') {
      return Math.round(subtotalCents * v);
    }
    if (descriptor.valueType === 'fixed-amount') {
      /* Fixed-amount codes are minted in shop currency (GBP). Convert
         to presentment cents before capping against the presentment
         subtotal — treating £10 as €10.00 both under-previewed AND,
         because the mint path FX-inverts this figure back to GBP,
         under-minted by exactly the FX rate (audit B5.5). */
      return Math.min(subtotalCents, gbpCentsToActiveCents(Math.round(v * 100)));
    }
    return 0;
  };

  /* Surface an inline error in the ad-hoc panel + bounce focus
     back to the input. Called from the apply flow on every bad
     code / worker failure / refusal. */
  HGNSideCart.prototype._showAdHocError = function (message) {
    /* Welcome auto-apply path: the shopper didn't type anything, so a
       refusal must stay invisible. The attempted code stays pre-filled
       in the input (soft prompt), the error copy is dropped. */
    if (this._adHocSilent) {
      this._adHocSilent = false;
      this._finishAdHocApplyButton();
      return;
    }
    if (this.adhocErrorEl) {
      this.adhocErrorEl.textContent = message || 'Couldn’t apply that code.';
      this.adhocErrorEl.hidden = false;
    }
    if (this.adhocInputEl) {
      try { this.adhocInputEl.focus(); } catch (e) {}
    }
  };
  HGNSideCart.prototype._clearAdHocError = function () {
    if (this.adhocErrorEl) {
      this.adhocErrorEl.hidden = true;
      this.adhocErrorEl.textContent = '';
    }
  };

  /* ─────── Apply flow ───────
     1. Read the code from the input + sanity check.
     2. Hit /api/discount/inspect.
     3. Route per the matrix in SIDE-CART.md §16.3:
        - product/shipping → straight-through (no conflict modal).
        - order + kit-only cart → refuse (inline error).
        - order + NP intent → conflict modal "lose NP credit".
        - order + kit + non-kit items → inform modal.
        - order + gift, no kit → check threshold cross.
        - default → straight-through.
     4. On confirm/straight-through, write attrs via _setAdHocIntent. */
  HGNSideCart.prototype._handleAdHocApply = function (codeOverride) {
    var self = this;
    this._clearAdHocError();
    var input = this.adhocInputEl;
    /* `codeOverride` is the cart-page bridge path —
       window.HGN.sideCart.applyAdHoc(code) routes here without
       requiring the side cart's input to be in scope. Falls back to
       the drawer's input when called from the in-drawer Apply button. */
    var raw = '';
    if (typeof codeOverride === 'string' && codeOverride) {
      raw = codeOverride.trim().toUpperCase();
      if (input) input.value = raw;
    } else {
      if (!input) return;
      raw = String(input.value || '').trim().toUpperCase();
    }
    if (!raw) {
      this._showAdHocError('Enter a code to apply.');
      return;
    }
    /* Reserved-prefix guard (mirrors the worker's check). */
    if (raw.indexOf('BASKET-') === 0 || raw.indexOf('NAILPOINTS-') === 0) {
      this._showAdHocError('That code isn’t valid here.');
      return;
    }
    /* KIT5 fold tokens (KIT5-FOLD.md) route to the popup worker, not the
       discount inspector — they're HGN-internal; Shopify never sees them. */
    if (/^KIT5-[A-Z0-9]{6}$/.test(raw)) {
      this._handleKit5Apply(raw);
      return;
    }
    if (this.adhocApplyEl) {
      this.adhocApplyEl.disabled = true;
      this.adhocApplyEl.textContent = 'Checking…';
    }
    if (input) input.disabled = true;
    /* 2026-09-27: _proceedToCheckout waits on this — an auto-adopted
       email-link code is cleared from Shopify's session before the
       inspect, so a checkout tap mid-apply would otherwise lose it.
       Cleared in _finishAdHocApplyButton, which every path ends in. */
    this._adHocApplyInflight = true;

    /* Session hygiene — wipe any stale Shopify-applied codes (e.g.
       a /discount/FREECLASSICWRAP cookied from a prior browse or
       a previous test run) BEFORE we inspect/apply. Without this
       a stale cookie can apply line-level discounts to cart lines
       that the shopper hasn't asked for, polluting `items_subtotal_price`
       and breaking the "You save" maths. Best-effort; we proceed
       even if the clear fetch fails (the apply itself doesn't
       depend on the cart being clean — only the visible maths does). */
    clearAllCartDiscountCodes().then(function () {
      return fetch('https://holygrailnail.co/api/discount/inspect', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'omit',
      body: JSON.stringify({
        code: raw,
        customerId: window.HGN_CUSTOMER_ID || '',
        email: window.HGN_CUSTOMER_EMAIL || ''
      })
    })
      .then(function (r) {
        return r.json().then(function (body) { return { ok: r.ok, body: body }; });
      })
      .then(function (res) {
        /* The inspect answered — a link-applied code is now either adopted
           or genuinely refused; nothing to restore. */
        self._adHocRestoreCode = null;
        var body = res.body || {};
        if (!res.ok || !body.ok) {
          /* Map worker reason codes to shopper-facing copy. */
          var reason = body.reason || '';
          var msg = 'Couldn’t apply that code.';
          if (reason === 'not-found')        msg = ((window.HGN_COPY || {}).code_unknown || 'We don’t recognise that code.');
          /* 2026-09-27: inspect also returns Shopify's status — an
             expired code says so, rather than "not active right now". */
          else if (reason === 'not-active' && body.status === 'EXPIRED') msg = 'Sorry, that code has expired.';
          else if (reason === 'not-active')  msg = 'That code isn’t active right now.';
          else if (reason === 'usage-exhausted') msg = 'That code’s use limit has been reached.';
          else if (reason === 'reserved-prefix') msg = 'That code isn’t valid here.';
          else if (reason === 'unsupported-shape') msg = 'That code isn’t supported in cart.';
          self._showAdHocError(msg);
          self._finishAdHocApplyButton();
          return;
        }
        if (body.alreadyUsedByCustomer) {
          self._showAdHocError('You’ve already used that code.');
          self._finishAdHocApplyButton();
          return;
        }
        self._routeAdHocApply(body);
      })
      .catch(function (err) {
        if (window && window.console) {
          console.warn('[hgn-side-cart] adhoc inspect failed:', err && err.message ? err.message : err);
        }
        /* 2026-09-27: the apply cleared Shopify's session codes first — a
           code the shopper brought by email link goes back, untouched. */
        var restore = self._adHocRestoreCode;
        self._adHocRestoreCode = null;
        if (restore) {
          fetch('/cart/update.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: restore })
          }).catch(function () {});
        }
        self._showAdHocError('Couldn’t reach the discount service. Try again.');
        self._finishAdHocApplyButton();
      });
    });
  };
  HGNSideCart.prototype._finishAdHocApplyButton = function () {
    this._adHocApplyInflight = false;
    if (this.adhocApplyEl) {
      this.adhocApplyEl.disabled = false;
      this.adhocApplyEl.textContent = 'Apply';
    }
    if (this.adhocInputEl) this.adhocInputEl.disabled = false;
  };

  /* Route an inspected ad-hoc per the §16.3 matrix. */
  HGNSideCart.prototype._routeAdHocApply = function (desc) {
    var self = this;
    var state = this._adHocCartState();
    var npIntent = this._getDiscountIntent() === 'nailpoints';

    /* product / shipping → straight-through. No competing BASKET to
       worry about; Shopify handles combinability natively at
       checkout. NP conflict still applies (Principle 2). */
    if (desc.discountClass === 'product' || desc.discountClass === 'shipping') {
      if (npIntent) {
        this._openAdHocConflictModal({
          source: 'np',
          descriptor: desc,
          state: state,
          onConfirm: function () { self._writeAdHocAttrsAndFinish(desc, /* clearNp */ true); },
          onCancel:  function () { self._finishAdHocApplyButton(); }
        });
        return;
      }
      this._writeAdHocAttrsAndFinish(desc, /* clearNp */ false);
      return;
    }

    /* Below here desc.discountClass === 'order'. */
    if (state.isKitOnly) {
      /* Kit savings come back as GBP pence → render via formatGbpCents
         so a USD shopper sees the message in dollars. The hypothetical
         ad-hoc preview stays in presentment cents (derived from cart
         subtotal); both end up in the buyer's currency. */
      var kitSavingsGbpCents = this._kitSavingsGbpCents();
      var currency = (this.cart && this.cart.currency) || 'GBP';
      var hypothetical = 0;
      if (desc.valueType === 'percentage' && typeof desc.value === 'number') {
        hypothetical = Math.round((state.subtotalCents || 0) * desc.value);
      } else if (desc.valueType === 'fixed-amount' && typeof desc.value === 'number') {
        hypothetical = Math.min(state.subtotalCents || 0, Math.round(desc.value * 100));
      }
      var msg = 'Sorry, that code doesn’t work with your Starter Kit';
      if (kitSavingsGbpCents > 0 && hypothetical > 0) {
        msg += ' — and you’re STILL saving ' +
               formatGbpCents(kitSavingsGbpCents) +
               ' (' + (desc.code || 'this code') + ' would only get you ' +
               formatMoney(hypothetical, currency) + ' off).';
      } else if (kitSavingsGbpCents > 0) {
        msg += ' (and you’re saving ' + formatGbpCents(kitSavingsGbpCents) + ' by having a Starter Kit).';
      } else {
        msg += '.';
      }
      this._showAdHocError(msg);
      this._finishAdHocApplyButton();
      return;
    }

    if (npIntent) {
      this._openAdHocConflictModal({
        source: 'np',
        descriptor: desc,
        state: state,
        onConfirm: function () { self._writeAdHocAttrsAndFinish(desc, /* clearNp */ true); },
        onCancel:  function () { self._finishAdHocApplyButton(); }
      });
      return;
    }

    /* Order + kit + non-kit items — inform modal "kit stays, code
       applies to non-kit". */
    if (state.hasKit && state.hasNonKitItems) {
      this._openAdHocConflictModal({
        source: 'kit',
        descriptor: desc,
        state: state,
        onConfirm: function () { self._writeAdHocAttrsAndFinish(desc, /* clearNp */ false); },
        onCancel:  function () { self._finishAdHocApplyButton(); }
      });
      return;
    }

    /* Order + gift (no kit, no other items) — check threshold cross. */
    if (state.hasGift) {
      if (this._giftWouldFallAfterAdHocApply(desc)) {
        /* Welcome auto-apply (silent): never pop a "lose your gift"
           modal the shopper didn't ask for. Leave the code pre-filled
           as a soft prompt — tapping Apply brings the modal. */
        if (this._adHocSilent) {
          this._adHocSilent = false;
          if (this.adhocInputEl && desc.code) this.adhocInputEl.value = desc.code;
          this._finishAdHocApplyButton();
          return;
        }
        this._openAdHocConflictModal({
          source: 'gift-loss',
          descriptor: desc,
          state: state,
          onConfirm: function () { self._writeAdHocAttrsAndFinish(desc, /* clearNp */ false); },
          onCancel:  function () { self._finishAdHocApplyButton(); }
        });
        return;
      }
      /* Gift survives — straight-through; checkout-click will mint
         the combined BASKET. */
      this._writeAdHocAttrsAndFinish(desc, /* clearNp */ false);
      return;
    }

    /* Order, no kit, no gift, no NP — straight-through. */
    this._writeAdHocAttrsAndFinish(desc, /* clearNp */ false);
  };

  /* Common tail for every "happy path" branch of the router.
     Optionally clears NP state first, then writes ad-hoc attrs,
     then refreshes the side cart. */
  HGNSideCart.prototype._writeAdHocAttrsAndFinish = function (descriptor, clearNp) {
    var self = this;
    /* Auto-applied welcome code reached the success path — drop the
       silent flag so any LATER manual apply errors surface normally. */
    this._adHocSilent = false;
    var pre = clearNp ? this._clearNailPointsState() : Promise.resolve(null);
    return pre
      .catch(function () { /* best-effort */ })
      .then(function () { return self._setAdHocIntent(descriptor); })
      .then(function () {
        /* Auto-adopted welcome code: remember it for the session so
           _welcomeRepairDesc can put it back if another script's cart
           write clobbers the attributes (seen ~1 in 3 on page load). */
        if (self._welcomeAdopting && descriptor && descriptor.code === self._welcomeAdopting) {
          try { sessionStorage.setItem('hgn-welcome-desc', JSON.stringify(descriptor)); } catch (e) {}
        }
        self._welcomeAdopting = null;
        return self.refresh();
      })
      .then(function () {
        self._finishAdHocApplyButton();
        if (self.adhocInputEl) self.adhocInputEl.value = '';
        self._clearAdHocError();
        /* Keep the panel disclosure open so the applied state is
           visible immediately. */
        if (self.adhocToggleEl) self.adhocToggleEl.setAttribute('aria-expanded', 'true');
        if (self.adhocBodyEl)   self.adhocBodyEl.hidden = false;
      })
      .catch(function (err) {
        if (window && window.console) {
          console.warn('[hgn-side-cart] adhoc apply attr-write failed:', err);
        }
        self._showAdHocError('Couldn’t apply that code. Try again.');
        self._finishAdHocApplyButton();
      });
  };

  /* Cancel flow — fires on the Remove link in the applied state. */
  HGNSideCart.prototype._handleAdHocCancel = function () {
    var self = this;
    if (this.adhocCancelEl) this.adhocCancelEl.disabled = true;
    this._clearAdHocState()
      .catch(function () {})
      .then(function () { return self.refresh(); })
      .then(function () {
        if (self.adhocCancelEl) self.adhocCancelEl.disabled = false;
        /* Deferred second refresh — matches the NP cancel pattern.
           Gives the gift orchestrator a clean pass once intent has
           cleared (relevant if applying ad-hoc had dropped the
           gift via threshold-cross). */
        setTimeout(function () { self.refresh(); }, 600);
      });
  };

  /* Kit savings (GBP pence) — used to populate the "you're saving
     £X by having a Starter Kit" tail of the kit-only refusal message.
     Returns GBP pence so callers can localize via formatGbpCents. */
  /* ─── KIT5 fold (KIT5-FOLD.md) ─────────────────────────────────────
     The KIT5-* voucher is an HGN-internal token: validated + consumed at
     the popup worker, folded into the BASKET-* mint as extra GBP pence at
     Checkout-click. Shopify never sees the token itself; a real free-
     shipping companion code rides the redirect only when the folded total
     dips under the market's threshold. */

  HGNSideCart.prototype._getKit5Token = function () {
    var attrs = (this.cart && this.cart.attributes) || {};
    var v = String(attrs._hgn_kit5_token || attrs['_hgn_kit5_token'] || '');
    return /^KIT5-[A-Z0-9]{6}$/.test(v) ? v : '';
  };

  HGNSideCart.prototype._getKit5AmountLocalCents = function () {
    var attrs = (this.cart && this.cart.attributes) || {};
    var v = parseInt(attrs._hgn_kit5_amount_cents || attrs['_hgn_kit5_amount_cents'] || '', 10);
    return isFinite(v) && v > 0 ? v : 0;
  };

  HGNSideCart.prototype._getKit5Currency = function () {
    var attrs = (this.cart && this.cart.attributes) || {};
    var v = String(attrs._hgn_kit5_currency || attrs['_hgn_kit5_currency'] || '').toUpperCase();
    return /^[A-Z]{3}$/.test(v) ? v : '';
  };

  /* Frozen local amount → GBP pence for the BASKET fold (mirrors
     presentmentToGbpCents, keyed by the token's FROZEN currency rather
     than the active one — the promise survives a market switch). */
  HGNSideCart.prototype._kit5FoldGbpCents = function () {
    var cents = this._getKit5AmountLocalCents();
    if (!cents) return 0;
    var cur = this._getKit5Currency() || 'GBP';
    if (cur === 'GBP') return Math.min(cents, 2000);
    var k = cur.toLowerCase();
    var rate = (window.HGN && window.HGN.fxRates && window.HGN.fxRates[k]) || FX_FALLBACK_RATES[k] || 0;
    if (!rate) return 0;
    /* Guard: whatever the config says, never fold more than £20. */
    return Math.max(0, Math.min(Math.round(cents / rate), 2000));
  };

  HGNSideCart.prototype._setKit5Intent = function (token, currency, amountCents) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        attributes: {
          _hgn_kit5_token:        String(token || ''),
          _hgn_kit5_currency:     String(currency || ''),
          _hgn_kit5_amount_cents: String(amountCents || '')
        }
      })
    });
  };

  HGNSideCart.prototype._clearKit5State = function () {
    return this._setKit5Intent('', '', '');
  };

  HGNSideCart.prototype._handleKit5Apply = function (raw) {
    var self = this;
    var state = this._adHocCartState();
    if (!state.hasKit) {
      this._showAdHocError('That code gives extra savings on a Starter Kit — build your kit first.');
      return;
    }
    if (this._getDiscountIntent() === 'nailpoints') {
      this._showAdHocError('That code can’t be combined with Nail Points — remove them first.');
      return;
    }
    if (this.adhocApplyEl) {
      this.adhocApplyEl.disabled = true;
      this.adhocApplyEl.textContent = 'Checking…';
    }
    if (this.adhocInputEl) this.adhocInputEl.disabled = true;
    fetch('https://popup.holygrailnail.co/api/kit5/validate?code=' + encodeURIComponent(raw), {
      method: 'GET',
      credentials: 'omit'
    })
      .then(function (r) { return r.json(); })
      .then(function (body) {
        if (!body || !body.valid) {
          var reason = (body && body.reason) || '';
          self._showAdHocError(reason === 'expired'
            ? 'That code has expired.'
            : 'That code isn’t valid — check the email it arrived in?');
          self._finishAdHocApplyButton();
          return;
        }
        /* Freeze what was promised: the token's own currency/amount,
           amounts-map GBP as the legacy fallback. */
        var cur = String(body.currency || 'GBP').toUpperCase();
        var amt = Number(body.amount);
        if (!isFinite(amt) || amt <= 0) {
          cur = 'GBP';
          amt = Number((body.amounts || {}).GBP) || 5;
        }
        self._writeKit5AttrsAndFinish(raw, cur, Math.round(amt * 100));
      })
      .catch(function () {
        self._showAdHocError('Couldn’t check that code. Try again.');
        self._finishAdHocApplyButton();
      });
  };

  HGNSideCart.prototype._writeKit5AttrsAndFinish = function (token, currency, amountCents) {
    var self = this;
    this._adHocSilent = false;
    return this._setKit5Intent(token, currency, amountCents)
      .then(function () { return self.refresh(); })
      .then(function () {
        self._finishAdHocApplyButton();
        if (self.adhocInputEl) self.adhocInputEl.value = '';
        self._clearAdHocError();
        if (self.adhocToggleEl) self.adhocToggleEl.setAttribute('aria-expanded', 'true');
        if (self.adhocBodyEl)   self.adhocBodyEl.hidden = false;
      })
      .catch(function (err) {
        if (window && window.console) {
          console.warn('[hgn-side-cart] kit5 apply attr-write failed:', err);
        }
        self._showAdHocError('Couldn’t apply that code. Try again.');
        self._finishAdHocApplyButton();
      });
  };

  /* Dual-offer auto-attach (POPUP-KIT-OFFER.md): a kit in the basket +
     an unused signup-paired kit5 held by this device → attach it without
     the shopper typing anything. On MIXED baskets, best-offer-wins:
     if the held POPUP 20% would save more on the non-kit portion, the
     kit5 stays un-attached and the POPUP code is pre-filled as a soft
     prompt instead (applying an order code needs the consent modal, so
     it is never silently auto-applied on mixed baskets). */
  HGNSideCart.prototype._maybeAutoAttachKit5 = function () {
    var self = this;
    try {
      if (this._kit5HeldTried) return;
      if (!this.cart) return;
      if (this._getKit5Token()) return;
      if (this._getDiscountIntent() === 'nailpoints') return;
      /* Kit in the CART or ready kit in the BUILDER both qualify — the
         drawer is the storefront, so the held £5 must attach + show in
         the virtual-kit state too, not first at Shopify checkout. */
      var state = this._adHocCartState();
      if (!state.hasKit &&
          !(this._findUnfinalisedReadyKit && this._findUnfinalisedReadyKit())) return;
      var did = '';
      try { did = localStorage.getItem('hgn:did') || ''; } catch (e) {}
      if (!did) return;
      this._kit5HeldTried = true;
      fetch('https://popup.holygrailnail.co/api/kit5/held?did=' + encodeURIComponent(did), {
        method: 'GET',
        credentials: 'omit'
      })
        .then(function (r) { return r.json(); })
        .then(function (body) {
          if (!body || !body.held || !body.code) return;
          var amountCents = Math.round((Number(body.amount) || 5) * 100);
          var cur = String(body.currency || 'GBP').toUpperCase();
          /* Held-token value in GBP pence (same math as _kit5FoldGbpCents). */
          var heldGbpCents;
          if (cur === 'GBP') {
            heldGbpCents = Math.min(amountCents, 2000);
          } else {
            var rate = (window.HGN && window.HGN.fxRates && window.HGN.fxRates[cur.toLowerCase()]) ||
              FX_FALLBACK_RATES[cur.toLowerCase()] || 0;
            heldGbpCents = rate ? Math.max(0, Math.min(Math.round(amountCents / rate), 2000)) : 0;
          }
          if (!heldGbpCents) return;

          /* Best-offer-wins on mixed baskets: compare against the held
             POPUP code's preview on the non-kit portion. */
          var st = self._adHocCartState();
          var nonKitCents = st.nonKitNonGiftSubtotalCents || 0;
          if (nonKitCents > 0 && window.HGNPopup && typeof window.HGNPopup.activeCode === 'function') {
            var heldPopup = null;
            try { heldPopup = window.HGNPopup.activeCode(); } catch (e) {}
            if (heldPopup && heldPopup.code && heldPopup.code.indexOf('POPUP-') === 0) {
              var pctMatch = /([0-9]{1,2})%/.exec(String(heldPopup.label || ''));
              var pct = pctMatch ? (parseInt(pctMatch[1], 10) / 100) : 0.2;
              var popupPreviewCents = Math.round(nonKitCents * pct);
              var kit5DisplayCents = gbpCentsToActiveCents(heldGbpCents);
              if (popupPreviewCents > kit5DisplayCents) {
                /* POPUP wins — soft prompt only (consent modal territory). */
                if (self.adhocInputEl && !self.adhocInputEl.value) {
                  self.adhocInputEl.value = heldPopup.code;
                }
                return;
              }
            }
          }

          /* kit5 wins (or kit-only basket): attach silently; the applied
             chip renders via the existing kit5 branch in _renderAdHoc. */
          self._setKit5Intent(body.code, cur, amountCents)
            .then(function () { return self.refresh(); })
            .catch(function () {});
        })
        .catch(function () {});
    } catch (e) { /* never touch cart UX */ }
  };

  /* ?hgn_voucher=KIT5-XXXXXX — email CTA lands with the code in the URL;
     pre-fill + silently apply once per session (KIT5-FOLD.md step 2). If
     there's no kit in the basket yet the attempt stays invisible and the
     code sits pre-filled in the input as a soft prompt. */
  HGNSideCart.prototype._maybeAutoApplyFromQuery = function () {
    try {
      if (this._kit5QueryTried) return;
      /* 2026-09-27: the email kit link lands on the kit page with an EMPTY
         basket — the old one-shot read tried then, got "build your kit
         first" (swallowed) and marked the code tried, so it never applied.
         Now the code is kept for the session (sessionStorage) and applied
         on the first refresh that has a kit in the basket. */
      var code = null;
      var m = /[?&]hgn_voucher=(KIT5-[A-Za-z0-9]{6})(?:[&#]|$)/i.exec(String(window.location.search || ''));
      if (m) {
        code = m[1].toUpperCase();
        try { sessionStorage.setItem('hgn-kit5-url', code); } catch (e) {}
      } else {
        try { code = sessionStorage.getItem('hgn-kit5-url'); } catch (e) {}
      }
      if (!code) { this._kit5QueryTried = true; return; }
      try { if (sessionStorage.getItem('hgn-kit5-auto') === code) { this._kit5QueryTried = true; return; } } catch (e) {}
      if (this._getKit5Token()) { this._kit5QueryTried = true; return; }
      if (!this._adHocCartState().hasKit) return; // wait for the kit
      this._kit5QueryTried = true;
      try { sessionStorage.setItem('hgn-kit5-auto', code); } catch (e) {}
      if (this.adhocInputEl) this.adhocInputEl.value = code;
      this._adHocSilent = true;
      this._handleKit5Apply(code);
    } catch (e) {
      this._adHocSilent = false;
    }
  };

  HGNSideCart.prototype._kitSavingsGbpCents = function () {
    if (!this.cart) return 0;
    var groups = groupCartLines((this.cart.items || []).slice());
    var presentmentCents = 0;
    (groups.bundles || []).forEach(function (b) {
      presentmentCents += bundleSavingsPresentmentCents(b);
    });
    return presentmentToGbpCents(presentmentCents);
  };

  /* Active gift threshold in presentment cents — used to detect
     whether an ad-hoc apply would knock the cart below the gift
     threshold. Delegates to `_getGiftThresholdCents` (the same
     accessor the orchestrator uses) so the two can never disagree.
     Returns 0 when no gift is configured.

     FIXED 2026-07-10: previously read `cfg.thresholds{}` — a key
     the announcement bar never emits (it emits `gift.thresholdGbp`)
     — so this always returned 0 and the "you'll lose your free
     gift" warning modal was dead code: the orchestrator silently
     removed the gift after apply with no warning shown. */
  HGNSideCart.prototype._activeGiftThresholdCents = function () {
    var cfg = this.config && this.config.gift;
    if (!cfg || !cfg.tiers || !cfg.tiers[0]) return 0;
    return this._getGiftThresholdCents();
  };

  /* Would the free-gift orchestrator remove the gift if this ad-hoc
     were applied right now? Mirrors `_orchestrateFreeGift`'s
     qualifying-subtotal math (items_subtotal_price − bundleSavings −
     adhocSavings − giftRetail) so the modal's warning fires exactly
     when the gift will actually fall, no false positives / negatives. */
  HGNSideCart.prototype._giftWouldFallAfterAdHocApply = function (desc) {
    var state = this._adHocCartState();
    if (!state.hasGift) return false;
    var bundleCents = this._lastBundleSavingsCents || 0;
    var preview = this._computeAdHocPreviewCents(desc, state.nonKitNonGiftSubtotalCents);
    var giftRetail = state.giftRetailCents || 0;
    var qualSubtotal = (state.subtotalCents || 0) - bundleCents - preview - giftRetail;
    var threshold = this._activeGiftThresholdCents();
    return threshold > 0 && qualSubtotal < threshold;
  };

  /* ─────── Ad-hoc conflict / inform modal ───────
     Lazy-created at document.body, separate DOM from the NP
     conflict modal so the copy slots match each source's flow
     ('np' / 'kit' / 'gift-loss'). Shares the same CSS as the NP
     modal so visual treatment stays consistent. */
  HGNSideCart.prototype._ensureAdHocModal = function () {
    if (this._adhocModalEl) return this._adhocModalEl;
    var wrap = document.createElement('div');
    wrap.className = 'hgn-side-cart__np-conflict';
    wrap.setAttribute('data-hgn-adhoc-modal', '');
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-labelledby', 'hgn-adhoc-modal-title');
    wrap.hidden = true;
    wrap.innerHTML =
      '<div class="hgn-side-cart__np-conflict-backdrop" data-hgn-adhoc-modal-backdrop></div>' +
      '<div class="hgn-side-cart__np-conflict-panel">' +
        '<button type="button" class="hgn-side-cart__np-conflict-close" data-hgn-adhoc-modal-close aria-label="Close">×</button>' +
        '<p class="hgn-side-cart__np-conflict-eyebrow" data-hgn-adhoc-modal-eyebrow>Heads up</p>' +
        '<h2 id="hgn-adhoc-modal-title" class="hgn-side-cart__np-conflict-title" data-hgn-adhoc-modal-title></h2>' +
        '<p class="hgn-side-cart__np-conflict-sub" data-hgn-adhoc-modal-body></p>' +
        '<div class="hgn-side-cart__np-conflict-actions">' +
          '<button type="button" class="hgn-side-cart__np-conflict-cancel" data-hgn-adhoc-modal-cancel>Cancel</button>' +
          '<button type="button" class="hgn-side-cart__np-conflict-confirm" data-hgn-adhoc-modal-confirm>Apply</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(wrap);
    this._adhocModalEl = wrap;
    return wrap;
  };
  HGNSideCart.prototype._openAdHocConflictModal = function (opts) {
    opts = opts || {};
    var modal = this._ensureAdHocModal();
    var titleEl = modal.querySelector('[data-hgn-adhoc-modal-title]');
    var bodyEl  = modal.querySelector('[data-hgn-adhoc-modal-body]');
    var confirmBtn = modal.querySelector('[data-hgn-adhoc-modal-confirm]');
    var cancelBtn  = modal.querySelector('[data-hgn-adhoc-modal-cancel]');
    var closeBtn   = modal.querySelector('[data-hgn-adhoc-modal-close]');
    var backdrop   = modal.querySelector('[data-hgn-adhoc-modal-backdrop]');
    var desc = opts.descriptor || {};
    var state = opts.state || {};
    var currency = (this.cart && this.cart.currency) || 'GBP';
    var code = escapeHtmlForModal(desc.code || 'code');

    var title = '';
    var body  = '';
    if (opts.source === 'np') {
      var npGbp = this._getNailPointsAmountGbp();
      var npCents = Math.round((npGbp || 0) * 100);
      title = 'Applying ' + code + ' will remove your Nail Points credit';
      body  = 'You’ll lose your <strong>' + formatMoney(npCents, currency) +
              '</strong> Nail Points credit. Continue?';
    } else if (opts.source === 'kit') {
      var preview = this._computeAdHocPreviewCents(desc, state.nonKitNonGiftSubtotalCents || 0);
      title = 'That code doesn’t work with a Starter Kit';
      body  = '…but it will save you <strong>' + formatMoney(preview, currency) +
              '</strong> ' + ((window.HGN_COPY || {}).code_rest || 'off the rest of your basket. Your kit savings stay.');
      if (state.hasGift) {
        if (this._giftWouldFallAfterAdHocApply(desc)) {
          body += ' You’ll also lose the <strong>' + formatMoney(state.giftRetailCents, currency) +
                  '</strong> free gift (your cart drops below the threshold).';
        } else if (state.giftRetailCents > 0) {
          body += ' Your free gift stays.';
        }
      }
    } else if (opts.source === 'gift-loss') {
      var preview2 = this._computeAdHocPreviewCents(desc, state.nonKitNonGiftSubtotalCents || 0);
      title = 'Applying ' + code + ' drops your cart below the free-gift threshold';
      body  = 'You’ll save <strong>' + formatMoney(preview2, currency) +
              '</strong> with the code, but lose the <strong>' +
              formatMoney(state.giftRetailCents, currency) + '</strong> free gift.';
    } else {
      title = 'Apply ' + code + '?';
      body  = '';
    }
    if (titleEl) titleEl.textContent = title.replace(/<[^>]+>/g, '');
    if (bodyEl)  bodyEl.innerHTML = body;

    function close() {
      modal.hidden = true;
      document.removeEventListener('keydown', onKey);
      confirmBtn.removeEventListener('click', onConfirm);
      cancelBtn.removeEventListener('click', onCancel);
      closeBtn.removeEventListener('click', onCancel);
      backdrop.removeEventListener('click', onCancel);
    }
    function onConfirm() {
      close();
      if (typeof opts.onConfirm === 'function') opts.onConfirm();
    }
    function onCancel() {
      close();
      if (typeof opts.onCancel === 'function') opts.onCancel();
    }
    function onKey(e) {
      if (e.key === 'Escape') onCancel();
    }
    confirmBtn.addEventListener('click', onConfirm);
    cancelBtn.addEventListener('click', onCancel);
    closeBtn.addEventListener('click', onCancel);
    backdrop.addEventListener('click', onCancel);
    document.addEventListener('keydown', onKey);
    modal.hidden = false;
    setTimeout(function () { try { cancelBtn.focus(); } catch (e) {} }, 0);
  };

  /* Render the ad-hoc panel state. Mirrors `_renderBeans` shape:
     paints idle vs applied + summary chip on the disclosure header.
     Idempotent — runs every refresh. */
  HGNSideCart.prototype._renderAdHoc = function () {
    if (!this.adhocEl) return;
    /* Empty cart still shows the kit5 chip when a token is attached —
       the virtual-kit basket includes its £5, so the chip must say why. */
    if (!this.cart || (!this.cart.item_count && !this._getKit5Token())) {
      this.adhocEl.hidden = true;
      return;
    }
    /* Suppress when NP intent is active — only one discount UI
       visible at a time. Shopper cancels NP first to enter a code. */
    if (this._getDiscountIntent() === 'nailpoints') {
      this.adhocEl.hidden = true;
      return;
    }
    this.adhocEl.hidden = false;
    /* KIT5 fold active → dedicated chip in the applied state (one
       voucher surface at a time; Remove clears it like any code). */
    var k5Token = this._getKit5Token();
    if (k5Token) {
      if (this.adhocIdleEl)    this.adhocIdleEl.hidden    = true;
      if (this.adhocAppliedEl) this.adhocAppliedEl.hidden = false;
      if (this.adhocBadgeEl)   this.adhocBadgeEl.textContent = k5Token;
      if (this.adhocSummaryEl) this.adhocSummaryEl.textContent = 'Extra kit savings applied';
      if (this.adhocLabelEl)   this.adhocLabelEl.textContent = 'Discount code';
      if (this.adhocNoteEl) {
        this.adhocNoteEl.textContent = 'An extra ' +
          formatMoney(this._getKit5AmountLocalCents(), this._getKit5Currency() || 'GBP') +
          ' off your Starter Kit — applied at checkout.';
      }
      return;
    }
    /* Matt 2026-07-24: shared/legacy welcome codes + popup codes don't apply to Nail
       Drop boxes (member pricing is the discount) — say so up front
       whenever a drop draft or subscription is in play, instead of
       letting the code silently not-work at checkout. */
    try {
      var noteEl = this.root.querySelector('[data-hgn-side-cart-adhoc-dropnote]');
      var dqN = window.HGN && window.HGN.dropQueue;
      var smN = window.HGN && window.HGN.shopMode;
      var dropLive = !!(smN && typeof smN.isDropAvailable === 'function' && smN.isDropAvailable());
      var dropActive = dropLive && dqN && ((typeof dqN.queueLength === 'function' && dqN.queueLength() > 0) ||
        (typeof dqN.getSubscriber === 'function' && dqN.getSubscriber()));
      if (dropActive && !noteEl) {
        noteEl = document.createElement('p');
        noteEl.setAttribute('data-hgn-side-cart-adhoc-dropnote', '');
        noteEl.style.cssText = 'margin:6px 0 0;font-size:11.5px;color:var(--hgn-text-muted,#6f655c);';
        noteEl.textContent = 'Discount codes apply to one-off items only — Nail Drop boxes are already member-priced.';
        this.adhocEl.appendChild(noteEl);
      } else if (noteEl) {
        noteEl.hidden = !dropActive;
      }
    } catch (e) {}

    var active = this._isAdHocActive();
    var code = this._getAdHocCode();

    if (active && code) {
      if (this.adhocIdleEl)    this.adhocIdleEl.hidden    = true;
      if (this.adhocAppliedEl) this.adhocAppliedEl.hidden = false;
      if (this.adhocBadgeEl)   this.adhocBadgeEl.textContent = code;
      if (this.adhocSummaryEl) this.adhocSummaryEl.textContent = code + ' applied';
      if (this.adhocLabelEl)   this.adhocLabelEl.textContent = 'Discount code';

      var note = '';
      var cls = this._getAdHocClass();
      if (cls === 'order') {
        var state = this._adHocCartState();
        var desc = {
          discountClass: cls,
          valueType: this._getAdHocValueType(),
          value: this._getAdHocValue()
        };
        var previewCents = this._computeAdHocPreviewCents(desc, state.nonKitNonGiftSubtotalCents);
        if (previewCents > 0) {
          note = 'Saves about ' + formatMoney(previewCents, (this.cart && this.cart.currency) || 'GBP') +
                 ' — final amount confirmed at checkout.';
        } else {
          note = 'Final discount confirmed at checkout.';
        }
      } else {
        note = 'Final discount confirmed at checkout.';
      }
      if (this.adhocNoteEl) this.adhocNoteEl.textContent = note;
    } else {
      if (this.adhocIdleEl)    this.adhocIdleEl.hidden    = false;
      if (this.adhocAppliedEl) this.adhocAppliedEl.hidden = true;
      if (this.adhocSummaryEl) this.adhocSummaryEl.textContent = '';
      if (this.adhocLabelEl)   this.adhocLabelEl.textContent = 'Have a code?';
    }
  };

  /* Conflict modal — lazy-created on first open, lives at document.body
     so its z-index sits above the side cart drawer. Reused across
     subsequent opens (idempotent). Caller passes:
       - loss:     output of _computeConflictLoss
       - currency: ISO code for money formatting
       - onConfirm: invoked AFTER the modal closes if shopper approves
       - onCancel:  invoked AFTER the modal closes if shopper backs out
                    (also fired on backdrop, close-X, and Escape). */
  HGNSideCart.prototype._ensureConflictModal = function () {
    if (this._conflictModalEl) return this._conflictModalEl;
    var wrap = document.createElement('div');
    wrap.className = 'hgn-side-cart__np-conflict';
    wrap.setAttribute('data-hgn-np-conflict', '');
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-labelledby', 'hgn-np-conflict-title');
    wrap.hidden = true;
    wrap.innerHTML =
      '<div class="hgn-side-cart__np-conflict-backdrop" data-hgn-np-conflict-backdrop></div>' +
      '<div class="hgn-side-cart__np-conflict-panel">' +
        '<button type="button" class="hgn-side-cart__np-conflict-close" data-hgn-np-conflict-close aria-label="Close">×</button>' +
        '<p class="hgn-side-cart__np-conflict-eyebrow">Heads up</p>' +
        '<h2 id="hgn-np-conflict-title" class="hgn-side-cart__np-conflict-title">Redeeming Nail Points removes other savings</h2>' +
        '<p class="hgn-side-cart__np-conflict-sub" data-hgn-np-conflict-sub>You’ll lose:</p>' +
        '<ul class="hgn-side-cart__np-conflict-list" data-hgn-np-conflict-list></ul>' +
        '<p class="hgn-side-cart__np-conflict-note">Your items stay in the cart at full price. Cancel the redemption at any time to restore your savings.</p>' +
        '<div class="hgn-side-cart__np-conflict-actions">' +
          '<button type="button" class="hgn-side-cart__np-conflict-cancel" data-hgn-np-conflict-cancel>Keep my savings</button>' +
          '<button type="button" class="hgn-side-cart__np-conflict-confirm" data-hgn-np-conflict-confirm>Apply Nail Points anyway</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(wrap);
    this._conflictModalEl = wrap;
    return wrap;
  };

  HGNSideCart.prototype._openConflictModal = function (opts) {
    opts = opts || {};
    var modal = this._ensureConflictModal();
    var listEl = modal.querySelector('[data-hgn-np-conflict-list]');
    var currency = opts.currency || (this.cart && this.cart.currency) || 'GBP';
    var loss = opts.loss || { bundleGbpCents: 0, giftGbpCents: 0, hasBundle: false, hasGift: false };

    /* Populate the loss list. Each row: label on the left, retail
       amount on the right. Only render rows the shopper actually
       has — single-kit OR single-gift modal still works.

       Kit + gift values are GBP pence (canonical) → formatGbpCents
       routes them through formatLive for the active currency.
       Ad-hoc value stays in presentment cents (derived from cart
       subtotals). */
    var rows = '';
    if (loss.hasBundle && loss.bundleGbpCents > 0) {
      var bLabel = loss.bundleLabel ? loss.bundleLabel + ' savings' : 'Starter Kit savings';
      rows += '<li><span>' + escapeHtmlForModal(bLabel) + '</span><strong>' +
        formatGbpCents(loss.bundleGbpCents) + '</strong></li>';
    }
    if (loss.hasGift && loss.giftGbpCents > 0) {
      var gLabel = loss.giftLabel ? ('Free gift — ' + loss.giftLabel) : 'Free gift';
      rows += '<li><span>' + escapeHtmlForModal(gLabel) + '</span><strong>' +
        formatGbpCents(loss.giftGbpCents) + '</strong></li>';
    }
    if (loss.hasAdHoc && loss.adhocCents > 0) {
      var aLabel = loss.adhocLabel ? ('Discount code — ' + loss.adhocLabel) : 'Discount code';
      rows += '<li><span>' + escapeHtmlForModal(aLabel) + '</span><strong>' +
        formatMoney(loss.adhocCents, currency) + '</strong></li>';
    }
    listEl.innerHTML = rows;

    var self = this;
    var confirmBtn = modal.querySelector('[data-hgn-np-conflict-confirm]');
    var cancelBtn  = modal.querySelector('[data-hgn-np-conflict-cancel]');
    var closeBtn   = modal.querySelector('[data-hgn-np-conflict-close]');
    var backdrop   = modal.querySelector('[data-hgn-np-conflict-backdrop]');

    function close() {
      modal.hidden = true;
      document.removeEventListener('keydown', onKey);
      confirmBtn.removeEventListener('click', onConfirm);
      cancelBtn.removeEventListener('click', onCancel);
      closeBtn.removeEventListener('click', onCancel);
      backdrop.removeEventListener('click', onCancel);
    }
    function onConfirm() {
      close();
      if (typeof opts.onConfirm === 'function') opts.onConfirm();
    }
    function onCancel() {
      close();
      if (typeof opts.onCancel === 'function') opts.onCancel();
    }
    function onKey(e) {
      if (e.key === 'Escape') onCancel();
    }

    confirmBtn.addEventListener('click', onConfirm);
    cancelBtn.addEventListener('click', onCancel);
    closeBtn.addEventListener('click', onCancel);
    backdrop.addEventListener('click', onCancel);
    document.addEventListener('keydown', onKey);

    modal.hidden = false;
    /* Focus the cancel ("Keep my savings") button by default — the
       safer of the two paths if the shopper hits enter without
       reading. */
    setTimeout(function () { try { cancelBtn.focus(); } catch (e) {} }, 0);
  };

  /* Lightweight HTML escaper for the modal's user-facing labels — the
     wider helpers in this file live inside other IIFE scopes. */
  function escapeHtmlForModal(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  HGNSideCart.prototype._syncHeaderBadge = function () {
    var count = (this.cart && this.cart.item_count) || 0;
    /* Header badge — keeps the cart icon's count in sync regardless of
       whether the drawer is open. The header markup ships
       `[data-hgn-cart-count]` on a <span> with a `[hidden]` attribute
       toggled by zero. */
    $$('[data-hgn-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
      el.hidden = count === 0;
    });
  };

  /* Piggyback offer (§11) — subscriber-only, drop-available-only.
     Paints the toggle state from the cart attribute; the row lives in
     the foot, so it inherits the foot's empty-cart hiding for free.
     Dates are descriptive (~), never a delivery commitment. */
  HGNSideCart.prototype._renderPiggyback = function () {
    var wrap = this.piggybackEl;
    if (!wrap) return;
    var sub = null;
    var show = false;
    try {
      var dq = window.HGN && window.HGN.dropQueue;
      var sm = window.HGN && window.HGN.shopMode;
      sub = dq && typeof dq.getSubscriber === 'function' ? dq.getSubscriber() : null;
      show = !!(sub && sm && typeof sm.isDropAvailable === 'function' && sm.isDropAvailable() &&
                this.cart && this.cart.item_count > 0);
    } catch (e) { show = false; }
    wrap.hidden = !show;
    if (!show) {
      /* Empty cart with the flag still set — scrub it so a later,
         unrelated order can't ride by accident. Only on a definitively
         empty cart (never on transient hydration states, where sub is
         momentarily null but items exist). */
      try {
        if (this.cart && this.cart.item_count === 0 &&
            String((this.cart.attributes || {}).hgn_piggyback || '') === '1' &&
            !this._piggybackScrubbed) {
          this._piggybackScrubbed = true;
          this.cart.attributes.hgn_piggyback = '';
          fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: { hgn_piggyback: '' } })
          }).catch(function () {});
        }
      } catch (e3) {}
      return;
    }
    this._piggybackScrubbed = false;
    var on = String(((this.cart || {}).attributes || {}).hgn_piggyback || '') === '1';
    var btn = this.piggybackToggleEl;
    if (btn) {
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-on', on);
    }
    var subEl = wrap.querySelector('[data-hgn-side-cart-piggyback-sub]');
    if (subEl) {
      var when = '';
      try {
        var next = sub && (sub.nextExpectedAt || sub.next_expected_at);
        if (next) {
          var d = new Date(next);
          if (!isNaN(d.getTime())) {
            when = ' (~' + d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }) + ')';
          }
        }
      } catch (e2) {}
      subEl.textContent = on
        ? 'On — this order ships inside your next box' + when + '. Delivery free.'
        : 'Free delivery — ships inside your next box' + when;
    }
  };

  HGNSideCart.prototype._render = function () {
    if (!this.cart) return;
    var cart = this.cart;
    renderCount++;
    /* After every wrapper's render has run (siblings add rows and the kit
       list): flag the empty bag for CSS (no code box or referral entry
       there) and name the image-only links. */
    if (!this._afterRenderQueued) {
      var selfAR = this;
      this._afterRenderQueued = true;
      Promise.resolve().then(function () {
        selfAR._afterRenderQueued = false;
        try {
          if (selfAR.root && selfAR.emptyEl) {
            if (!selfAR.emptyEl.hidden) selfAR.root.setAttribute('data-hgn-sc-empty', '');
            else selfAR.root.removeAttribute('data-hgn-sc-empty');
          }
          labelThumbs(selfAR.root);
        } catch (e) {}
      });
    }
    this._renderPiggyback();

    /* Loading shroud — only on first render. */
    if (this.loadingEl) this.loadingEl.hidden = true;

    /* Detect kit-in-progress: build mode on AND any tier has picks.
       When true, the side cart's chrome should stay visible even on
       an "empty" cart (because the kit IS the cart's intent — picks
       are in localStorage, not yet line items). */
    var kitInProgress = false;
    try {
      var kp = window.HGN && window.HGN.kitProgress;
      if (kp) {
        var s = kp.read();
        if (s.activeKit && s.kits[s.activeKit] && s.kits[s.activeKit].items.length > 0) {
          kitInProgress = true;
        }
      }
    } catch (e) {}
    /* Audit D1: saved Nail Drop picks are progress too — shouting
       "Your bag is empty" directly under a shopper's UP NEXT list
       read as failure to the auditors. Same guard as kitInProgress. */
    var dropInProgress = false;
    try {
      var dqEmpty = window.HGN && window.HGN.dropQueue;
      if (dqEmpty && typeof dqEmpty.queueLength === 'function' && dqEmpty.queueLength() > 0 &&
          window.HGN.shopMode && typeof window.HGN.shopMode.isDropAvailable === 'function' &&
          window.HGN.shopMode.isDropAvailable()) {
        dropInProgress = true;
      }
    } catch (e) {}
    kitInProgress = kitInProgress || dropInProgress;

    if (!cart.item_count && !kitInProgress) {
      /* Truly empty — hide everything, show the empty CTA. Drop the
         cart-reservation timer so the next add starts a fresh 15 min. */
      this._virtualKitMeterCents = 0;
      this.itemsEl.hidden = true;
      if (this.cartSectionEl) this.cartSectionEl.hidden = true;
      this.footEl.hidden = true;
      this.progressEl.hidden = true;
      if (this.beansEl) this.beansEl.hidden = true;
      if (this.upsellEl) { this.upsellEl.hidden = true; this.upsellEl.innerHTML = ''; }
      this.emptyEl.hidden = false;
      if (this._renderEmptyKitCta) this._renderEmptyKitCta();
      /* Foot is hidden here anyway; reset so a later render can't
         inherit a swapped-out checkout row. */
      if (this._renderMidBuildFoot) this._renderMidBuildFoot(false);
      if (window.HGN && window.HGN.cartTimer) window.HGN.cartTimer.clear();
      return;
    }

    if (!cart.item_count && kitInProgress) {
      /* Empty cart but kit picks exist — render chrome (progress,
         foot, beans) at zero so the side cart looks like a normal
         cart. The kit-build section above is rendered by the sibling
         IIFE; this branch just ensures the chrome around it doesn't
         vanish. Items-list + cart-section + upsell stay hidden
         because there are no actual cart line items. */
      this.itemsEl.hidden = true;
      if (this.cartSectionEl) this.cartSectionEl.hidden = true;
      if (this.upsellEl) { this.upsellEl.hidden = true; this.upsellEl.innerHTML = ''; }
      this.emptyEl.hidden = true;
      /* Audit-2 T6 HIGH: a DROP-ONLY draft (no kit picks) was renting
         the kit chrome — £39.99 shipping meter over "free shipping
         every time", urgency title, and a live CHECKOUT that dead-ends
         on a £0.00 cart. Drop-only = the drop section IS the drawer;
         no meter, no foot, no checkout. Kit picks still get the
         chrome (their checkout path runs the finish-kit interstitial). */
      if (dropInProgress && !cart.item_count) {
        var kitReallyInProgress = false;
        try {
          var kpChk = window.HGN && window.HGN.kitProgress;
          if (kpChk) {
            var kpSt = kpChk.read();
            kitReallyInProgress = !!(kpSt.activeKit && kpSt.kits[kpSt.activeKit] && kpSt.kits[kpSt.activeKit].items.length > 0);
          }
        } catch (e) {}
        if (!kitReallyInProgress) {
          this.footEl.hidden = true;
          this.progressEl.hidden = true;
          if (this.beansEl) this.beansEl.hidden = true;
          return;
        }
      }
      this.footEl.hidden = false;
      this.progressEl.hidden = false;
      if (this.beansEl) this.beansEl.hidden = false;
      this._lastSavingsCents = 0;
      this._lastBundleSavingsCents = 0;
      this._lastAdHocSavingsCents  = 0;
      /* Virtual kit basket — a ready kit renders as the de-facto
         basket: subtotal = kit price, savings = kit saving (+ gift
         retail once earned), meter fed the kit's value via
         _virtualKitMeterCents (read by _renderProgress). A kit still
         below minimum keeps the zeroed foot. */
      var vk = this._virtualKitBasket();
      this._virtualKitMeterCents = vk ? vk.kitPriceCents : 0;
      if (vk) {
        if (this.subtotalEl) this.subtotalEl.textContent = formatMoney(vk.kitPriceCents, vk.isoCode);
        if (this.savingsEl) {
          if (vk.savingsCents > 0 && this.savingsValueEl) {
            this.savingsValueEl.textContent = formatMoney(vk.savingsCents, vk.isoCode);
            this.savingsEl.hidden = false;
          } else {
            this.savingsEl.hidden = true;
          }
        }
      } else {
        if (this.subtotalEl) this.subtotalEl.textContent = formatMoney(0, cart.currency);
        if (this.savingsEl) this.savingsEl.hidden = true;
      }
      /* Foot button doubles as the kit CTA on empty carts — see
         _emptyKitFootState / _handleCheckout. */
      this._syncCheckoutLabel();
      /* `vk` null = kit still below minimum, nothing purchasable, so
         the checkout row stands down. A ready kit keeps the full foot —
         that IS one-tap kit checkout's basket. */
      if (this._renderMidBuildFoot) this._renderMidBuildFoot(!vk);
      this._renderProgress();
      this._renderBeans();
      this._renderAdHoc();
      this._orchestrateFreeGift();
      /* Kit picks exist but nothing is in the cart yet — no "first
         add" has happened, so there's no reservation to run. */
      if (window.HGN && window.HGN.cartTimer) window.HGN.cartTimer.clear();
      return;
    }
    this.emptyEl.hidden = true;
    this.footEl.hidden = false;
    /* Cart has real lines — virtual kit basket no longer applies
       (the meter reads real subtotals again) and the plain
       "Checkout" copy returns if an empty-cart render swapped it. */
    this._virtualKitMeterCents = 0;
    this._syncCheckoutLabel();
    /* Real lines exist → real subtotal → checkout row always returns,
       even if the shopper is ALSO mid-build on a kit. */
    if (this._renderMidBuildFoot) this._renderMidBuildFoot(false);
    if (this.beansEl) this.beansEl.hidden = false;
    /* Cart has line items — start the 15-min reservation countdown.
       Idempotent: a reservation already running is left untouched, so
       subsequent adds don't reset the clock. */
    if (window.HGN && window.HGN.cartTimer) window.HGN.cartTimer.ensureStarted();

    /* Group bundle lines + render. Standalone lines render as flat
       rows after the bundle cards. */
    var groups = groupCartLines(cart.items);

    /* Mint-at-checkout pricing model — nothing is applied to the
       cart yet, so we compute what the shopper WILL pay client-side:
       bundle savings (Σ retail − target) + gift retail = totalSavings.
       Subtotal = items_subtotal_price MINUS that, bypassing
       cart.total_price (which only reflects already-applied
       discounts — none yet).

       Intent override: Nail Points suspends the kit + gift discount
       paths, so a bundle stops being a bundle — its items deconstruct
       into `groups.standalones` and render as individual retail rows.
       The `_bundle_id` line properties stay intact, so flipping intent
       back to default reconstructs the bundles on the next render. */
    var intent = this._getDiscountIntent();
    if (intent === 'nailpoints' && groups.bundles && groups.bundles.length) {
      groups.bundles.forEach(function (b) {
        (b.items || []).forEach(function (it) { groups.standalones.push(it); });
      });
      groups.bundles = [];
    }
    var savings = this._computeTotalSavings(groups);
    /* `_lastSavingsCents` (presentment cents) drives the displayed-
       subtotal math + the cart-page bridge. `_lastSavingsGbpCents`
       (GBP pence) is the canonical value handed to the worker at
       checkout-click — Shopify converts the GBP discount back to
       presentment currency, completing the loop. */
    this._lastSavingsCents    = savings.totalCents;
    this._lastSavingsGbpCents = savings.totalGbpCents;
    /* Stashed for `_orchestrateFreeGift` + `_renderProgress` so they
       can compare the gift threshold against the DISCOUNTED
       qualifying subtotal — not items_subtotal_price (which is
       retail). Without this, a £39.99 Classic kit (retail ~£60)
       would falsely cross the £50 gift threshold and unlock a gift
       the shopper hasn't actually earned. Stored in presentment
       cents (same unit as items_subtotal_price).

       `_lastAdHocSavingsCents` holds ONLY the synthetic ad-hoc
       preview (order class). Shopify-applied product/shipping
       discounts are already baked out of `items_subtotal_price`, so
       subtracting them again here would double-count and flip
       qualifies-for-gift false when the gift would actually stay. */
    this._lastBundleSavingsCents = savings.bundlePresentmentCents;
    this._lastAdHocSavingsCents  = savings.adhocPreviewCents || 0;
    var rawSubtotal = cart.items_subtotal_price || 0;
    /* Synthetic savings only — what Shopify hasn't yet applied to
       the cart's line subtotals. Shopify-applied product/shipping
       discounts are already in items_subtotal_price (baked OUT of
       it), so we mustn't subtract those again here. */
    var syntheticSavingsCents =
      (savings.bundlePresentmentCents || 0) +
      (savings.giftPresentmentCents   || 0) +
      (savings.npPresentmentCents     || 0) +
      (savings.adhocPreviewCents      || 0);
    /* KIT5 fold — presentment display value round-trips through the GBP
       fold figure so the badge, subtotal and mint all reconcile. */
    var kit5DisplayCents = gbpCentsToActiveCents(this._kit5FoldGbpCents());
    syntheticSavingsCents += kit5DisplayCents;
    var displayedSubtotal = Math.max(0, rawSubtotal - syntheticSavingsCents);
    /* Cached for the cart-page bridge — the redesigned cart page
       reads this via `window.HGN.sideCart.displayedSubtotalCents()`
       so its summary "Subtotal" reflects the same discounted figure
       this drawer shows, without re-implementing the synthetic-
       savings math. */
    this._lastDisplayedSubtotalCents = displayedSubtotal;
    this.subtotalEl.textContent = formatMoney(displayedSubtotal, cart.currency);
    if (this.savingsEl) {
      /* "You save" — presentment cents, formatted EXACTLY via
         formatMoney (no formatLive friendly rounding: this figure
         sits next to the Subtotal row and must reconcile with it —
         a "$30" badge above a subtotal that moved by $32.41 reads
         as a bug). savings.totalCents already carries every active
         contributor: kit + gift under default intent, the NP amount
         under nailpoints intent, plus ad-hoc preview/applied. */
      var displaySavingsCents = (savings.totalCents || 0) + kit5DisplayCents;
      if (displaySavingsCents > 0 && this.savingsValueEl) {
        this.savingsValueEl.textContent = formatMoney(displaySavingsCents, cart.currency);
        this.savingsEl.hidden = false;
      } else {
        this.savingsEl.hidden = true;
      }
    }
    /* Ad-hoc per-line context — when intent is 'adhoc' and the code
       is order-class, compute a per-line discount so standalone
       lines display "retail → discounted" (mirroring the gift-line
       strikethrough pattern). Kit lines + gift line are handled
       separately and don't carry the ad-hoc discount. */
    var adhocCtx = null;
    if (this._getDiscountIntent() === 'adhoc' && this._getAdHocClass() === 'order') {
      var adState = this._adHocCartState();
      var valueType = this._getAdHocValueType();
      var value = this._getAdHocValue();
      if (valueType === 'percentage' && value > 0) {
        adhocCtx = { kind: 'percentage', pct: value };
      } else if (valueType === 'fixed-amount' && value > 0) {
        /* GBP → presentment before capping (audit B5.5, same as
           _computeAdHocPreviewCents). */
        var totalAdHocCents = Math.min(adState.nonKitNonGiftSubtotalCents, gbpCentsToActiveCents(Math.round(value * 100)));
        adhocCtx = {
          kind: 'fixed',
          totalCents: totalAdHocCents,
          basisCents: adState.nonKitNonGiftSubtotalCents
        };
      }
    }
    var html = '';
    /* kit5 fold shows ON the kit card (Matt, 2026-08-13): it's "extra
       KIT savings", so the card's paid price must match what checkout
       charges for the kit. Applied to the first saved card only — the
       fold is a single order-level amount, never per-bundle. */
    var kit5CardCents = kit5DisplayCents;
    groups.bundles.forEach(function (bundle) {
      html += renderBundleCard(bundle, kit5CardCents);
      if (bundle.gbpPaidCents != null) kit5CardCents = 0;
    });
    groups.standalones.forEach(function (item) {
      html += renderLineItem(item, adhocCtx);
    });
    /* Gifts render LAST so they read as a reward on top of the cart,
       not buried among standard line items. Special template:
       terracotta accent, FREE pill, no qty controls, no remove
       (auto-managed by the orchestrator). */
    groups.gifts.forEach(function (item) {
      html += renderGiftLine(item);
    });
    this.itemsEl.innerHTML = html;
    /* Saved-kit collages ride the same innerHTML; hydrate them once they
       are in the DOM (guarded per root by the runtime — a no-op re-run). */
    try {
      if (window.HGN && typeof window.HGN.kitCollageHydrate === 'function' && this.itemsEl.querySelector('[data-hgn-bundle-collage]')) window.HGN.kitCollageHydrate(this.itemsEl);
    } catch (e) {}
    this.itemsEl.hidden = false;
    if (this.cartSectionEl) {
      this.cartSectionEl.hidden = false;
      if (this.cartCountEl) {
        var totalLines = (groups.bundles || []).length +
                         (groups.standalones || []).length +
                         (groups.gifts || []).length;
        this.cartCountEl.textContent = String(cart.item_count || totalLines);
      }
    }

    /* Kick off auto-cycle on any bundle thumbs that just painted. */
    this._startBundleCycles();

    /* Progress bar — milestones + reactive copy. */
    this._renderProgress();

    /* Stale-discount sweep — legacy: hunted orphan STARTERKIT- codes
       on the cart from the pre-mint-at-checkout flow. With consolidated
       cart discount this is mostly dead code, but kept for one-off
       carts that still carry an old kit code from before the rollout. */
    this._renderStaleDiscount();

    /* Kit upsell — render the CTL panel when conditions are met. Runs
       BEFORE the gift orchestrator so the panel is up-to-date when the
       gift add/remove flickers a re-render. */
    this._renderUpsell(groups);

    /* Pending upsell dedupe — if the shopper accepted the upsell and
       the kit-builder has now successfully added a bundle to the cart,
       remove the standalone duplicates that we snapshotted at click. */
    this._reconcilePendingUpsell();

    /* Nail Points panel — render the worker-mediated redeem UI.
       Reads `this.beansBalance` (populated by `_fetchBeansBalance`
       on side-cart open). */
    this._renderBeans();
    /* Ad-hoc code panel — disclosure-collapsed by default; expands
       to input + Apply, or to the applied-state row when an ad-hoc
       intent is live on the cart. */
    this._renderAdHoc();

    /* Free-gift orchestration — auto-add when subtotal crosses
       threshold, auto-remove when it drops or Nail Points redemption
       turns on (mutual exclusion). Runs after render so the latest
       cart state drives the decision. */
    this._orchestrateFreeGift();
  };

  /* ───────── Kit upsell ─────────
     Single-tier suggestion: if the shopper has 1+ wraps/gels/press-ons
     in cart at retail (not already bundled) AND the cart subtotal is
     below the admin-set AOV gate, render a card prompting them to
     turn the cart into a Starter Kit at the kit price.

     Click → snapshot the eligible line keys + items, prefill
     kitProgress, open the kit-bar drawer. They pick the remainder (3
     wraps in cart → kit needs 5 → pick 2) and Send to Cart; the bundle
     lines land alongside the originals and `_reconcilePendingUpsell`
     removes the standalone duplicates so nothing is double-charged.
     Bail out and the pending state self-expires after 10 minutes with
     the cart untouched (nothing was ever moved). */
  HGNSideCart.prototype._renderUpsell = function (groups) {
    if (!this.upsellEl) return;
    var cfg = (this.config && this.config.upsell) || {};
    if (!cfg.enabled) {
      this.upsellEl.hidden = true;
      this.upsellEl.innerHTML = '';
      return;
    }

    /* Active-build suppression — when build mode is on AND the shopper
       has picks in any tier, the kit-build section above is already
       doing the kit pitch. The upsell card on top of that reads as
       redundant noise (or worse, contradicts the in-progress kit by
       suggesting a different tier). Hide it until the kit is finalised
       or build mode flips off. */
    try {
      var kp = window.HGN && window.HGN.kitProgress;
      if (kp && typeof kp.getKitBuildMode === 'function' &&
          kp.getKitBuildMode() === 'on') {
        var totalPicks = (typeof kp.totalKitPicks === 'function')
          ? kp.totalKitPicks()
          : 0;
        if (totalPicks > 0) {
          this.upsellEl.hidden = true;
          this.upsellEl.innerHTML = '';
          return;
        }
      }
    } catch (e) {}

    /* 5-minute snooze: if the shopper just dismissed the card, don't
       re-render it on every cart update. localStorage so the snooze
       survives a page reload but not a new session. */
    try {
      var dismissedAt = parseInt(localStorage.getItem('hgn_upsell_dismissed_at'), 10);
      if (isFinite(dismissedAt) && Date.now() - dismissedAt < 5 * 60 * 1000) {
        this.upsellEl.hidden = true;
        this.upsellEl.innerHTML = '';
        return;
      }
    } catch (e) {}

    /* Audit D1: one contextual pitch at a time — while the shopper is
       actively filling a Nail Drop (queue non-empty), the drop section
       owns the drawer's upsell voice and the kit pitch stands down. */
    try {
      var dqUp = window.HGN && window.HGN.dropQueue;
      if (dqUp && typeof dqUp.queueLength === 'function' && dqUp.queueLength() > 0 &&
          window.HGN.shopMode && typeof window.HGN.shopMode.isDropAvailable === 'function' &&
          window.HGN.shopMode.isDropAvailable()) {
        this.upsellEl.hidden = true;
        this.upsellEl.innerHTML = '';
        return;
      }
    } catch (e) {}
    var match = this._findUpsellCandidate(groups);
    if (!match) {
      this.upsellEl.hidden = true;
      this.upsellEl.innerHTML = '';
      return;
    }

    var tierLabel = ({
      classic:     'Classic Starter Kit',
      gels:        'Gel Starter Kit',
      'press-ons': 'Press-On Starter Kit'
    })[match.tier] || 'Starter Kit';

    var needed = match.minimum - match.itemCount;
    var itemNoun = needed === 1
      ? (match.tier === 'press-ons' ? 'press-on' : (match.tier === 'gels' ? 'gel' : 'wrap'))
      : (match.tier === 'press-ons' ? 'press-ons' : (match.tier === 'gels' ? 'gels' : 'wraps'));

    var savingHtml = match.savingCents > 0
      ? '<p class="hgn-side-cart__upsell-saving">Save ' + formatMoney(match.savingCents, this.cart.currency) + '</p>'
      : '';

    this.upsellEl.innerHTML =
      '<button type="button" class="hgn-side-cart__upsell-dismiss" data-hgn-side-cart-upsell-dismiss aria-label="Dismiss for 5 minutes">' +
        '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
          '<path d="m6 6 12 12M18 6 6 18" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>' +
        '</svg>' +
      '</button>' +
      '<p class="hgn-side-cart__upsell-eyebrow">Better together</p>' +
      '<p class="hgn-side-cart__upsell-title">Turn these into a <strong>' + escapeHtml(tierLabel) + '</strong></p>' +
      '<p class="hgn-side-cart__upsell-sub">Add ' + needed + ' more ' + itemNoun + ' + accessories — pay <strong>' + formatMoney(match.kitPriceCents, this.cart.currency) + '</strong> for the lot.</p>' +
      savingHtml +
      '<button type="button" class="hgn-side-cart__upsell-cta" data-hgn-side-cart-upsell-cta data-hgn-upsell-tier="' + escapeAttr(match.tier) + '">Build the kit</button>';
    this.upsellEl.hidden = false;

    /* Wire click handler (delegated re-bind on every render — cheap
       and avoids stale closures over old groups data). */
    var self = this;
    var btn = $('[data-hgn-side-cart-upsell-cta]', this.upsellEl);
    if (btn) {
      btn.addEventListener('click', function () {
        self._handleUpsellClick(match);
      });
    }
    var dismissBtn = $('[data-hgn-side-cart-upsell-dismiss]', this.upsellEl);
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        try { localStorage.setItem('hgn_upsell_dismissed_at', String(Date.now())); } catch (err) {}
        self.upsellEl.hidden = true;
        self.upsellEl.innerHTML = '';
      });
    }
  };

  /* Walk the cart, score per-tier, return the candidate to upsell or
     null if no eligible tier exists. */
  HGNSideCart.prototype._findUpsellCandidate = function (groups) {
    var H = window.HGN || {};
    var minimums = H.STARTER_KIT_MINIMUMS || { classic: 5, gels: 3, 'press-ons': 3 };
    var prices = window.HGN_KIT_BUNDLE_PRICES || {};
    var cfg = (this.config && this.config.upsell) || {};
    var aovGateGbp = cfg.aovGateGbp || 30;
    var aovGateCents = Math.round(this._convertThreshold(aovGateGbp) * 100);

    /* AOV gate: above this, the shopper is already a strong order —
       don't interrupt. Compares against the discounted subtotal (same
       view the shopper sees). */
    var rawSubtotal = (this.cart && this.cart.items_subtotal_price) || 0;
    var displayedSubtotal = Math.max(0, rawSubtotal - (this._lastBundleSavingsCents || 0));
    if (displayedSubtotal >= aovGateCents) return null;

    /* Group standalone items by tier. Skip non-kit-eligible (no
       tier returned by tierFromProductType — accessories etc.).
       Also skip multi-packs ("Pack of N") — they're already
       pre-discounted at the bundle level so an upsell suggesting
       a kit on top would double-dip the saving. "Matching Tips &
       Toes" sets are skipped for the same reason they can't be a
       kit pick — curated multi-design pairings, not ingredients. */
    if (typeof H.tierFromProductType !== 'function') return null;
    var byTier = { classic: [], gels: [], 'press-ons': [] };
    (groups.standalones || []).forEach(function (it) {
      var tier = H.tierFromProductType(it.product_type);
      if (!tier || !byTier[tier]) return;
      var titleLc = String(it.title || it.product_title || '').toLowerCase();
      if (titleLc.indexOf('pack') !== -1) return;
      if (titleLc.indexOf('matching tips') !== -1) return;
      byTier[tier].push(it);
    });

    /* Skip any tier already represented as a bundle in the cart —
       no point upselling a kit they've already got. */
    var bundleTiers = {};
    (groups.bundles || []).forEach(function (b) {
      var firstProps = (b.items[0] && b.items[0].properties) || {};
      var bt = String(firstProps._bundle_type || '');
      if (/^classic-starter-kit/.test(bt)) bundleTiers.classic = true;
      else if (/^gels-starter-kit/.test(bt)) bundleTiers.gels = true;
      else if (/^press-ons-starter-kit/.test(bt)) bundleTiers['press-ons'] = true;
    });

    /* Pick the dominant tier with at least 1 item AND below its
       minimum (above minimum, the shopper could just hit Send-to-Kit
       directly from the kit-bar — no upsell needed). Skips tiers
       the merchant has switched off for this market. */
    var kp = window.HGN && window.HGN.kitProgress;
    var enabledFn = (kp && typeof kp.isTierEnabled === 'function') ? kp.isTierEnabled : null;
    var winner = null;
    Object.keys(byTier).forEach(function (tier) {
      if (enabledFn && !enabledFn(tier)) return;
      if (bundleTiers[tier]) return;
      var items = byTier[tier];
      if (items.length === 0) return;
      var minimum = minimums[tier];
      if (!minimum || items.length >= minimum) return;
      if (!winner || items.length > winner.itemCount) {
        winner = {
          tier:        tier,
          items:       items,
          itemCount:   items.length,
          minimum:     minimum
        };
      }
    });
    if (!winner) return null;

    /* Compute saving: current retail of the eligible items vs the
       proportional kit price. Kit price assumed to be evenly split
       across the minimum number of items, so saving is approximate
       but directionally honest. */
    /* One unit per line — a qty-3 line is still ONE kit pick, so its
       extra units can't count toward the "you'd save" estimate (B1). */
    var itemRetailCents = winner.items.reduce(function (sum, it) {
      return sum + lineOneUnitRetailCents(it);
    }, 0);
    var kitPriceGbp = prices[winner.tier] || 0;
    /* Convert the GBP kit price to presentment cents — it's compared
       against (and rendered next to) presentment line-price sums.
       The previous `kitPriceGbp * 100` treated GBP pence as
       presentment cents, overstating the saving on non-GBP markets. */
    var kitPriceCents = gbpToActiveCents(kitPriceGbp);
    /* Per-market LOCAL sticker (M4): when the announcement bar
       broadcast a fixed local kit price for this market AND it's in
       the active presentment currency, that sticker IS the
       presentment price — use it verbatim instead of floating the
       GBP price through FX. GBP + unconfigured currencies keep the
       conversion above unchanged. */
    var localKit = (window.HGN_KIT_BUNDLE_PRICES_LOCAL || {})[winner.tier];
    if (localKit && typeof localKit.amount === 'number' && isFinite(localKit.amount) &&
        localKit.amount > 0 && String(localKit.currency || '').toLowerCase() === activeKey()) {
      kitPriceCents = Math.round(localKit.amount * 100);
    }
    /* "If they were paying full retail for X items + accessories,
       what's the saving against the kit?" — approximate but useful. */
    var savingCents = Math.max(0, itemRetailCents - kitPriceCents);

    winner.kitPriceCents = kitPriceCents;
    winner.savingCents   = savingCents;
    return winner;
  };

  /* Snapshot the eligible cart lines + prefill kitProgress + open the
     kit-bar drawer. The original cart lines stay intact; we'll dedupe
     them post-send-to-cart in `_reconcilePendingUpsell`. */
  HGNSideCart.prototype._handleUpsellClick = function (match) {
    var H = window.HGN || {};
    if (!H.kitProgress || typeof H.kitProgress.addItem !== 'function') {
      if (window && window.console) {
        console.warn('[hgn-side-cart] kitProgress not ready, upsell click ignored');
      }
      return;
    }

    /* Snapshot for post-send dedupe. Capture the line `key` (Shopify's
       opaque cart line identifier — survives re-fetches and is what
       /cart/change.js wants). */
    this._pendingUpsell = {
      tier:         match.tier,
      cartLineKeys: match.items.map(function (it) { return it.key; }),
      expiresAt:    Date.now() + 10 * 60 * 1000  // 10 min self-expiry
    };

    /* Wipe any in-progress kit picks for this tier so the prefill
       starts clean. */
    if (typeof H.kitProgress.clearKit === 'function') {
      H.kitProgress.clearKit(match.tier);
    }

    /* Prefill — same shape as the bundle-restore flow in `_removeBundle`. */
    match.items.forEach(function (it) {
      H.kitProgress.addItem(match.tier, {
        id:     String(it.product_id),
        handle: it.handle || '',
        title:  it.product_title || it.title,
        image:  it.image || null,
        price:  formatMoney(it.original_price || it.price)
      });
    });
    if (typeof H.kitProgress.setActiveKit === 'function') {
      H.kitProgress.setActiveKit(match.tier);
    }

    /* Flip kit build mode ON with the matched tier as the focus.
       Passing `focus: match.tier` bypasses the focus picker modal —
       the upsell already knows which kit the shopper is building.
       Awaiting the promise so we don't dispatch the drawer-open event
       before kitProgress has finished initialising build mode. */
    var self = this;
    function openDrawerAfterClose() {
      self.close();
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent('hgn:kit:open-drawer'));
      }, 250);
      /* Audit W5 (2026-07-23): entering kit mode moves eligible cart
         lines into the kit build — safe (mode-off restores them), but
         the standalone auditor read the silent count drop as losing
         their item. Say what happened and that it's reversible. */
      try {
        var note = document.createElement('div');
        note.setAttribute('role', 'status');
        note.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:10050;background:#0f0d0b;color:#f6f2ec;padding:12px 20px;border-radius:10px;font-size:13px;max-width:min(92vw,480px);text-align:center;box-shadow:0 10px 34px rgba(15,13,11,.35);';
        note.textContent = ((window.HGN_COPY || {}).kit_mode_moved || 'Your items moved into this Starter Kit — switch kit mode off any time to send them back to your bag.');
        document.body.appendChild(note);
        setTimeout(function () {
          note.style.transition = 'opacity .4s ease';
          note.style.opacity = '0';
          setTimeout(function () { if (note.parentNode) note.parentNode.removeChild(note); }, 450);
        }, 6500);
      } catch (e) {}
    }
    if (typeof H.kitProgress.setKitBuildMode === 'function') {
      var modeResult = H.kitProgress.setKitBuildMode('on', {
        source: 'side-cart-upsell',
        focus: match.tier
      });
      if (modeResult && typeof modeResult.then === 'function') {
        modeResult.then(openDrawerAfterClose).catch(openDrawerAfterClose);
      } else {
        openDrawerAfterClose();
      }
    } else {
      openDrawerAfterClose();
    }

    /* Fire-and-forget Complete-the-Look fetch. Aggregates per-product
       CTL metafields from the cart items and dispatches
       `hgn:kit:suggestions` for the kit-bar drawer to render as a
       horizontal-scroll suggestion strip. If the fetch fails, the
       kit drawer just opens without suggestions — no UX block. */
    var handles = match.items
      .map(function (it) { return it.handle; })
      .filter(Boolean);
    if (handles.length === 0) return;

    if (window && window.console) {
      console.info('[hgn-side-cart] CTL fetch', { handles: handles, tier: match.tier });
    }
    /* Forward per-market warehouse flags so the worker drops items
       this market can't fulfil. SSoT is window.HGN_WAREHOUSES (set
       by hgn-announcement.liquid); legacy pages without the global
       set default to both-enabled, matching the worker's back-compat
       default. */
    var __ctlWh = (typeof window !== 'undefined' && window.HGN_WAREHOUSES) || {};
    fetch('https://holygrailnail.co/api/complete-the-look', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'omit',
      body: JSON.stringify({
        productHandles: handles,
        tier:           match.tier,
        warehouses:     { airbox: __ctlWh.airbox !== false, portless: __ctlWh.portless !== false }
      })
    })
      .then(function (r) {
        if (!r.ok) {
          return r.text().then(function (body) {
            throw new Error('CTL ' + r.status + ': ' + body.slice(0, 200));
          });
        }
        return r.json();
      })
      .then(function (data) {
        if (window && window.console) {
          console.info('[hgn-side-cart] CTL response', data);
        }
        if (!data || !data.ok || !Array.isArray(data.recommendations) || data.recommendations.length === 0) {
          if (window && window.console) {
            console.warn('[hgn-side-cart] CTL returned no recommendations — strip will not render');
          }
          return;
        }
        document.dispatchEvent(new CustomEvent('hgn:kit:suggestions', {
          detail: { tier: match.tier, recommendations: data.recommendations }
        }));
      })
      .catch(function (err) {
        if (window && window.console) {
          console.warn('[hgn-side-cart] CTL fetch failed:', err && err.message ? err.message : err);
        }
      });
  };

  /* Called on every render. If a pending upsell exists AND a bundle
     of the matching tier has now appeared in the cart, the shopper
     successfully completed the upsell — remove the snapshotted
     standalone lines so they're not double-charged. */
  HGNSideCart.prototype._reconcilePendingUpsell = function () {
    var pending = this._pendingUpsell;
    if (!pending || !this.cart) return;

    /* Self-expire if the shopper bailed out and 10 min passed. */
    if (Date.now() > pending.expiresAt) {
      this._pendingUpsell = null;
      return;
    }

    /* Did a bundle of the matching tier just appear? */
    var bundleAppeared = (this.cart.items || []).some(function (it) {
      var p = it.properties || {};
      var bt = String(p._bundle_type || '');
      return bt.indexOf(pending.tier + '-starter-kit') === 0;
    });
    if (!bundleAppeared) return;

    /* Bundle is in cart — kill the snapshotted standalone duplicates.
       Filter to just the keys that still exist in the cart (some may
       have been removed manually; ignore those). Use a single
       /cart/update.js with an `updates` map so it's atomic. */
    var existingKeys = {};
    (this.cart.items || []).forEach(function (it) { existingKeys[it.key] = true; });
    var updates = {};
    var toRemove = pending.cartLineKeys.filter(function (k) { return existingKeys[k]; });
    if (toRemove.length === 0) {
      this._pendingUpsell = null;
      return;
    }
    toRemove.forEach(function (k) { updates[k] = 0; });

    var self = this;
    this._pendingUpsell = null; // clear immediately so we don't loop
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function () {
      if (window && window.console) {
        console.info('[hgn-side-cart] upsell completed — removed', toRemove.length, 'duplicate cart line(s)');
      }
      return self.refresh();
    }).catch(function () {});
  };

  /* Auto-cycle bundle thumbs. Each `[data-hgn-bundle-cycle]` block has
     N images stacked absolutely; we rotate `.is-active` at 1.8s
     intervals. Cycles are stored on the controller so a re-render
     stops the old timers cleanly. */
  HGNSideCart.prototype._startBundleCycles = function () {
    var self = this;
    if (this._bundleCycleTimers) {
      this._bundleCycleTimers.forEach(function (id) { clearInterval(id); });
    }
    this._bundleCycleTimers = [];
    $$('[data-hgn-bundle-cycle]', this.itemsEl).forEach(function (cycle) {
      var imgs = $$('img', cycle);
      if (imgs.length < 2) return;
      imgs[0].classList.add('is-active');
      var idx = 0;
      var id = setInterval(function () {
        imgs[idx].classList.remove('is-active');
        idx = (idx + 1) % imgs.length;
        imgs[idx].classList.add('is-active');
      }, 1800);
      self._bundleCycleTimers.push(id);
    });
  };

  /* Convert a per-market GBP threshold to the active currency. The
     announcement bar's `formatLiveCeil` does FX × Math.ceil(1 unit),
     so we get a value that when paid clears the underlying GBP rule.
     Falls back to the raw GBP figure if the FX helper isn't loaded
     yet (e.g. before the announcement bar's JS has run). */
  HGNSideCart.prototype._convertThreshold = function (gbp) {
    var H = window.HGN || {};
    /* Long-tail carts (czk dkk pln ron sek): activeCurrencyKey()
       resolves them to 'gbp', so formatLiveCeil returned the raw GBP
       figure and it was compared against a CZK/DKK subtotal — a £50
       gift threshold became 50 CZK (~£1.73). Convert with the same
       Shopify rate the mint uses (cartFxRate), rounded up to a whole
       unit so paying it always clears the GBP rule. */
    var raw = H.cartCurrencyRaw;
    if (raw && raw !== 'gbp' && FX_VALID_KEYS.indexOf(raw) === -1) {
      var r = cartFxRate();
      if (r > 1) return Math.ceil(gbp * r);
    }
    if (typeof H.formatLiveCeil === 'function' && typeof H.activeCurrencyKey === 'function') {
      try {
        var key = H.activeCurrencyKey();
        var formatted = H.formatLiveCeil(gbp, key);
        /* `formatLiveCeil` returns "£42" / "$60" — strip the currency
           symbol to get a numeric value we can multiply by 100 for cents.
           If parsing fails we just use the per-currency figure from
           config (already pre-rounded). */
        var n = parseFloat(String(formatted).replace(/[^0-9.]/g, ''));
        if (!isNaN(n)) return n;
      } catch (e) {}
    }
    return gbp;
  };

  HGNSideCart.prototype._renderProgress = function () {
    if (!this.progressEl || !this.cart) return;
    /* Same qualifying-subtotal math as `_orchestrateFreeGift` —
       items_subtotal_price minus bundle savings, ad-hoc savings,
       and the gift line's own retail (so the gift can't keep itself
       unlocked by inflating the subtotal). Without these
       subtractions the progress bar can stay `is-gift-unlocked`
       after the orchestrator has already removed the gift. */
    var giftLine = (this.cart.items || []).find(isGiftLineItem);
    var giftRetailInCart = giftLine
      ? (giftLine.original_line_price != null ? giftLine.original_line_price : (giftLine.line_price || 0))
      : 0;
    var subtotalCents = Math.max(0,
      (this.cart.items_subtotal_price || 0)
        - (this._lastBundleSavingsCents || 0)
        - (this._lastAdHocSavingsCents || 0)
        - giftRetailInCart);
    /* Virtual kit basket (empty cart + ready kit): the kit's price
       feeds the meter so free shipping + the free gift unlock BEFORE
       the one-tap checkout adds the lines. Uses the kit price — the
       same figure the free-shipping qualification guard in the kit
       pricing block compares against this market's threshold, so the
       meter and the kit's own "FREE shipping" line always agree.
       Zero whenever the cart has real lines (set per-render). */
    subtotalCents += (this._virtualKitMeterCents || 0);
    var subtotalCurrency = (this.cart.currency || 'GBP').toLowerCase();
    var cfgKey = shipThresholdKey(this.config.shipping, subtotalCurrency);
    var shipGbp  = (this.config.shipping || {})[cfgKey] || 40;
    /* Gift threshold is a single GBP value (set in the announcement
       bar's section settings). FX conversion happens below. */
    var giftGbp  = (this.config.gift && this.config.gift.thresholdGbp) || 50;
    /* Convert the GBP figure to the active currency via formatLiveCeil
       so the displayed threshold always satisfies the underlying rule. */
    var shipDisp = this._convertThreshold(shipGbp);
    var giftDisp = this._convertThreshold(giftGbp);
    var shipCents = Math.round(shipDisp * 100);
    var giftCents = Math.round(giftDisp * 100);

    /* Track max — always the gift threshold (it's higher than ship by
       design). If gift isn't configured, fall back to ship × 1.4 so
       the bar never pegs at 100% on a small basket.

       Nail Points override: when intent === "nailpoints", the shopper
       has explicitly traded away the free-gift path. Treat the gift
       as not-configured for this paint so the milestone disappears,
       the bar's max is ship × 1.4, and the copy only narrates
       shipping progress. Free shipping itself is still available. */
    var npActive = this._getDiscountIntent() === 'nailpoints';
    var giftConfigured = !npActive && (this.config.gift && this.config.gift.tiers && this.config.gift.tiers[0]);
    var maxCents = giftConfigured ? giftCents : Math.round(shipCents * 1.4);
    var progressPct = Math.min(100, Math.round((subtotalCents / maxCents) * 100));

    var shipUnlocked = subtotalCents >= shipCents;
    var giftUnlocked = giftConfigured && subtotalCents >= giftCents;

    this.progressEl.hidden = false;
    this.progressEl.style.setProperty('--hgn-shipbar-progress', progressPct + '%');
    if (this.progressFillEl) this.progressFillEl.style.width = progressPct + '%';
    this.progressEl.classList.toggle('is-ship-unlocked', shipUnlocked);
    this.progressEl.classList.toggle('is-gift-unlocked', giftUnlocked);
    /* Foot small print tracks the shipping state (Matt, 2026-08-08):
       "Shipping calculated at checkout" under an order that ships
       free reads as a hedge at the exact moment we should be
       confirming the win. Same shipUnlocked signal as the meter —
       incl. the virtual kit basket — so the two never disagree. */
    if (this.taxesEl) {
      /* Lead sentence per market (snippets/hgn-market-copy, tax_prefix):
         US/AU say duties are paid; every other market "Tax included." */
      var taxLead = ((window.HGN_COPY || {}).tax_prefix || 'Tax included.');
      this.taxesEl.innerHTML = shipUnlocked
        ? taxLead + ' <strong>Free shipping</strong> on this order.'
        : taxLead + ' <a href="/policies/shipping-policy" class="hgn-side-cart__taxes-link">Shipping</a> calculated at checkout.';
    }

    /* Position the milestone icons along the track. Shipping always
       sits at its threshold %; gift at 100% of the track when the
       gift IS the max. We don't render milestones outside the track
       (e.g. shipping > gift would be misconfiguration). */
    var shipPct = Math.min(100, Math.round((shipCents / maxCents) * 100));
    var giftPct = giftConfigured ? Math.min(100, Math.round((giftCents / maxCents) * 100)) : null;
    var shipMs = $('[data-hgn-side-cart-milestone-ship]', this.progressEl);
    var giftMs = $('[data-hgn-side-cart-milestone-gift]', this.progressEl);
    if (shipMs) shipMs.style.left = shipPct + '%';
    if (giftMs) {
      if (giftConfigured) {
        giftMs.style.left = giftPct + '%';
        giftMs.style.display = '';
      } else {
        giftMs.style.display = 'none';
      }
    }
    /* Swap in the gift product image once we have the config. The
       icon disc was a placeholder SVG before this point. */
    if (giftConfigured) this._renderGiftMilestoneIcon();

    /* Copy — three reactive states. */
    var giftTier = giftConfigured ? this.config.gift.tiers[0] : null;
    var giftName = (giftTier && giftTier.friendlyName) || (giftTier && giftTier.title) || 'Free gift';
    /* The meter's own figures, for a sibling that words the strip
       differently (the declutter arm in hgn-side-cart-attach.js): it must
       narrate exactly what this bar measures, wrappers' lent savings and
       all, so it reads them here rather than redoing the maths. */
    this._lastMeter = {
      subtotalCents: subtotalCents, shipCents: shipCents, giftCents: giftCents,
      giftConfigured: !!giftConfigured, giftName: giftName,
      shipUnlocked: shipUnlocked, giftUnlocked: !!giftUnlocked
    };
    var line;
    if (giftUnlocked) {
      line = '\u2728 Free Shipping <strong>+</strong> a Free <strong>' + escapeHtml(giftName) + '</strong> unlocked';
    } else if (shipUnlocked && giftConfigured) {
      var remainingToGift = giftCents - subtotalCents;
      line = 'Free Shipping unlocked \u2014 only <strong>' + formatMoney(remainingToGift, this.cart.currency) + '</strong> to your free <strong>' + escapeHtml(giftName) + '</strong>';
    } else if (shipUnlocked) {
      line = '\u2728 Free Shipping unlocked';
    } else {
      line = 'Only <strong>' + formatMoney((shipCents - subtotalCents), this.cart.currency) + '</strong> to Free Shipping';
    }
    if (this.progressLineEl) this.progressLineEl.innerHTML = line;
  };

  /* Detect orphaned kit discount codes — code applied, no bundle items
     left to match. Caused by removing kit items individually (instead
     of via the bundle-remove button) or testing churn. Silently
     auto-revoke: POST to the worker, refetch /cart so the application
     becomes inapplicable. No UI — the shopper just sees the correct
     prices.

     Dedup via `_revokedCodes` so we only fire one worker call per code
     per page session — otherwise every render after the refetch
     (which can briefly still show the code on cart.discount_codes
     before Shopify clears applicability) would re-fire. */
  HGNSideCart.prototype._renderStaleDiscount = function () {
    if (!this.cart) return;
    var codes = (this.cart.discount_codes || []).filter(function (d) {
      return d && d.code && /^starterkit-/i.test(d.code);
    });
    if (codes.length === 0) return;
    var hasBundle = (this.cart.items || []).some(function (it) { return readBundleId(it); });
    if (hasBundle) return;
    /* Orphaned codes — revoke each (once per session) + refetch. */
    if (!this._revokedCodes) this._revokedCodes = {};
    var self = this;
    var toRevoke = codes.filter(function (d) { return !self._revokedCodes[d.code]; });
    if (toRevoke.length === 0) return;
    toRevoke.forEach(function (d) { self._revokedCodes[d.code] = true; });
    Promise.all(toRevoke.map(function (d) {
      return fetch('https://holygrailnail.co/api/bundle/destroy-discount', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        body: JSON.stringify({ code: d.code })
      }).catch(function () { return null; });
    })).then(function () {
      /* Re-fetch so Shopify re-evaluates code applicability. The
         line items will revert to their non-discounted prices. */
      self.refresh();
    });
  };

  /* ───────── Free-gift orchestration ─────────
     The gift line is added / removed automatically as the qualifying
     subtotal crosses the threshold. It rides at full retail and is
     funded by the consolidated BASKET-* mint at Checkout-click (the
     old per-gift worker price-rule path is superseded). Mutually
     exclusive with Nail Points — a `redeemxr*` code on the cart means
     the shopper opted into points, so skip / remove the gift.

     Idempotency: `_giftInflight` blocks add/remove while a call is in
     flight (async cart — otherwise double-adds in the fetch/refetch
     gap); `_gift_line` is the SSoT for "is the gift in the cart"; and
     the qualifying subtotal nets off the gift's own retail so it
     can't keep itself unlocked. */
  HGNSideCart.prototype._orchestrateFreeGift = function () {
    var cfg = this.config && this.config.gift;
    var tier = cfg && cfg.tiers && cfg.tiers[0];
    if (!tier) return;
    if (!this.cart || this._giftInflight) return;

    var giftLine = (this.cart.items || []).find(isGiftLineItem);
    var nailPointsActive = this._isNailPointsActive();

    /* Qualifying subtotal — start from items_subtotal_price (retail),
       then subtract:
         1. bundle savings (so a £39.99 kit doesn't crosss the £50
            gift threshold on its £60 retail)
         2. the gift line's own retail (so the gift can't keep itself
            unlocked by inflating the subtotal)
       This mirrors what the shopper SEES in the side cart's "Subtotal"
       row — the threshold should track the visible total, not retail. */
    var qualSubtotal = this.cart.items_subtotal_price || 0;
    qualSubtotal -= (this._lastBundleSavingsCents || 0);
    /* Ad-hoc savings reduce the qualifying subtotal too — without
       this, applying a 20% code on a cart sitting just above the
       gift threshold would leave the gift in (qualSubtotal stays at
       retail) even though the shopper's actual cost has dropped
       below the threshold. The apply-time conflict modal already
       warns about this scenario; this orchestrator pass closes the
       loop by actually removing the gift after attrs are written. */
    qualSubtotal -= (this._lastAdHocSavingsCents || 0);
    if (giftLine) {
      qualSubtotal -= (giftLine.original_line_price != null
        ? giftLine.original_line_price
        : (giftLine.line_price || 0));
    }

    var giftCents = this._getGiftThresholdCents();
    var qualifies = qualSubtotal >= giftCents && !nailPointsActive;

    var self = this;
    if (qualifies && !giftLine) {
      this._giftInflight = true;
      this._addGiftLine().then(function () { self._giftInflight = false; });
    } else if (!qualifies && giftLine) {
      this._giftInflight = true;
      this._removeGiftLine(giftLine).then(function () { self._giftInflight = false; });
    }
    /* No third branch needed: with mint-at-checkout there's no
       discount code to reconcile against the cart. The gift line's
       presence is the sole signal that the gift is "in"; pricing is
       resolved at checkout via the consolidated cart discount. */
  };

  HGNSideCart.prototype._isNailPointsActive = function () {
    if (!this.cart) return false;
    /* Two signals, either one means Nail Points is active and the
       kit/gift discount paths are stood down:
         1. `_hgn_discount_intent === "nailpoints"` cart attribute —
            set by Apply (the deferred-mint path). The shopper's
            intent IS the active state; the code isn't minted yet.
         2. A `NAILPOINTS-*` (or legacy `BEANS-*`) discount code on
            the cart — happens after a Checkout-click has minted but
            the shopper came back without completing checkout. */
    if (this._getDiscountIntent() === 'nailpoints') return true;
    return (this.cart.discount_codes || []).some(function (d) {
      return d && d.code && (/^NAILPOINTS-/i.test(d.code) || /^BEANS-/i.test(d.code));
    });
  };

  /* Compute total savings for the cart's current state. Source of
     truth for the foot's "You save" badge and for the figure handed
     to the worker at Checkout-click to mint BASKET-*.

     Returns TWO parallel sets:
       *PresentmentCents — the NATIVE unit (2026-07-10 rewrite), from
         actual cart line prices (no FX on the retail side). Feeds the
         displayed subtotal, the badge, and the orchestrator /
         progress-bar math (all vs items_subtotal_price).
       *GbpCents — FX-inverted from those (identity on GBP carts) and
         sent to the worker, which mints in shop currency (GBP).
     Ad-hoc savings stay presentment-only (derived from subtotals).

     Contributors by intent:
       1. NAILPOINTS-* → the redemption amount ONLY; kit + gift
          savings don't contribute (no BASKET-* is minted under this
          intent — the shopper traded them away in the conflict modal).
       2. default + bundles → per bundle, Σ actual line prices −
          target (bundleSavingsPresentmentCents). Zero for legacy
          bundles with no target-price prop.
       3. default + gift lines → their actual line price. */
  HGNSideCart.prototype._computeTotalSavings = function (groups) {
    if (this._getDiscountIntent() === 'nailpoints') {
      var npGbpCents = Math.round(this._getNailPointsAmountGbp() * 100);
      var npPresentment = gbpCentsToActiveCents(npGbpCents);
      return {
        bundleGbpCents: 0, giftGbpCents: 0, npGbpCents: npGbpCents,
        bundlePresentmentCents: 0, giftPresentmentCents: 0, npPresentmentCents: npPresentment,
        adhocPreviewCents: 0, adhocAppliedCents: 0, adhocCents: 0,
        totalGbpCents: npGbpCents, totalCents: npPresentment
      };
    }
    /* Bundle + gift savings from ACTUAL cart line prices (2026-07-10
       rewrite — see bundleSavingsPresentmentCents above). Presentment
       is the native unit; GBP is derived by inversion for the mint
       payload. Previously both figures came from GBP-canonical props
       (`_bundle_retail_gbp_cents` table value, `_gift_retail_gbp_cents`
       config snapshot) which drifted from what Shopify actually
       charges — the minted discount came out short and the shopper
       overpaid vs the promised kit price. */
    var bundlePresentment = 0;
    (groups.bundles || []).forEach(function (b) {
      bundlePresentment += bundleSavingsPresentmentCents(b);
    });
    var giftPresentment = 0;
    (groups.gifts || []).forEach(function (g) {
      giftPresentment += giftRetailPresentmentCents(g);
    });
    var bundleGbp = presentmentToGbpCents(bundlePresentment);
    var giftGbp   = presentmentToGbpCents(giftPresentment);
    /* Ad-hoc savings split into two parts:
         adhocPreviewCents — synthetic preview that Shopify hasn't
         yet applied. Computed for order-class codes against the
         non-kit-non-gift subtotal. Subtracted from items_subtotal_price
         when computing the displayed total (because Shopify hasn't
         touched the cart's lines for this discount yet).
         adhocAppliedCents — Shopify's actual line-discount allocation
         for product/shipping codes that have been cookied in session
         (and so are already baked OUT of items_subtotal_price). Read
         from `cart.total_discount`. Added to the "You save" total
         for display, but NOT subtracted from displayed subtotal
         (would double-count). */
    var adhocPreview = 0;
    var adhocApplied = 0;
    if (this._getDiscountIntent() === 'adhoc') {
      var cls = this._getAdHocClass();
      if (cls === 'order') {
        var st = this._adHocCartState();
        adhocPreview = this._computeAdHocPreviewCents({
          discountClass: 'order',
          valueType:     this._getAdHocValueType(),
          value:         this._getAdHocValue()
        }, st.nonKitNonGiftSubtotalCents);
      } else if (cls === 'product' || cls === 'shipping') {
        adhocApplied = (this.cart && this.cart.total_discount) || 0;
      }
    }
    var totalAdHoc = adhocPreview + adhocApplied;
    return {
      bundleGbpCents:         bundleGbp,
      giftGbpCents:           giftGbp,
      npGbpCents:             0,
      bundlePresentmentCents: bundlePresentment,
      giftPresentmentCents:   giftPresentment,
      npPresentmentCents:     0,
      adhocPreviewCents:      adhocPreview,
      adhocAppliedCents:      adhocApplied,
      adhocCents:             totalAdHoc,
      totalGbpCents:          bundleGbp + giftGbp,
      totalCents:             bundlePresentment + giftPresentment + totalAdHoc
    };
  };

  /* ─────── Kit-checkout cluster — EXTRACTED 2026-08-08 ───────
     _findUnfinalisedReadyKit / _emptyKitFootState / _syncCheckoutLabel /
     _virtualKitBasket / _finaliseKitThenCheckout / _showFinishKitPrompt
     live in snippets/hgn-side-cart-kit-checkout.liquid (rendered at the
     bottom of this file) — this file crossed Shopify's 256 KB snippet
     limit, same extraction rationale as kit-build + drop. The sibling
     reads the bridge below and attaches to HGNSideCart.prototype while
     the document is still parsing, i.e. before DOMContentLoaded
     constructs the instance — runtime behaviour is unchanged. Put NEW
     kit-checkout methods over there, not here. */
  window.__hgnSideCartBridge = {
    HGNSideCart: HGNSideCart,
    helpers: {
      escapeHtml:       escapeHtml,
      formatMoney:      formatMoney,
      gbpToActiveCents: gbpToActiveCents,
      activeKey:        activeKey,
      isGiftLineItem:   isGiftLineItem
    }
  };

  /* Checkout-click handler. Mints the consolidated cart discount on
     the worker, then navigates to `/checkout?discount=<code>`.
     A1 (2026-08-12): an unconfirmed mint NO LONGER falls through to
     full price silently — _proceedToCheckout arms a "Continue without
     discount" acknowledgement first. Gate contract + rationale:
     hgn-side-cart-kit-checkout.liquid.

     Pre-flight: a kit tier at minimum but not finalised gets a modal
     offering to finish it (and lock the saving). Picks are NOT
     migrated to cart here — checkout-time is the wrong moment for
     surprise cart writes; kit memory stays for later. */
  HGNSideCart.prototype._handleCheckout = function () {
    if (this._checkoutInflight || this._kitCheckoutPending) return;
    var self = this;
    /* Armed full-price fallback (audit A1) — the CTA reads "Continue
       without discount", so THIS tap is the acknowledgement. Basket
       moved since? Pin mismatches → fall through, fresh attempt. */
    if (this._checkoutMintFailed) {
      this._checkoutMintFailed = false;
      this._clearCheckoutNote();
      if (this._mintFailedSig === this._cartSignature()) {
        this._proceedToCheckout({ skipMint: true });
        return;
      }
    }
    /* Empty cart + ready kit: the foot button IS the kit CTA — no
       interstitial modal, the review already happened in the build
       section above. See _emptyKitFootState for the label contract. */
    var footKit = this._emptyKitFootState();
    if (footKit) {
      if (footKit.allSet) {
        this._finaliseKitThenCheckout(footKit.tier);
      } else {
        /* A2: a bare scroll-to-build no-oped when the kit section was
           already at the top — dead CTA, gift row below the fold. The
           focus detail routes to kit-build's focusBlockingSlot. */
        try {
          document.dispatchEvent(new CustomEvent('hgn:side-cart:scroll-to-build', {
            detail: { tier: footKit.tier, focus: 'required-slot' }
          }));
        } catch (e) {}
      }
      return;
    }
    var unfinalised = this._findUnfinalisedReadyKit();
    if (unfinalised) {
      /* All-set kit alongside other cart lines: the prompt's primary
         action folds the kit in and continues to checkout in one
         motion, instead of bouncing the shopper back to an accessory
         step they've already completed. */
      try {
        if (window.HGN && typeof window.HGN.kitFinaliseState === 'function') {
          var st = window.HGN.kitFinaliseState(unfinalised.tier);
          unfinalised.allSet = !!st && st.unfilled === 0;
        }
      } catch (e) {}
      this._showFinishKitPrompt(unfinalised).then(function (decision) {
        if (decision === 'finish') {
          if (unfinalised.allSet) {
            self._finaliseKitThenCheckout(unfinalised.tier);
            return;
          }
          /* Bring the shopper back to the kit section so they can
             pick accessories. open() is a no-op if the cart is
             already open. The scroll-to-build event opens the
             relevant tier's concertina via the kit-build IIFE. */
          self.open();
          try {
            document.dispatchEvent(new CustomEvent('hgn:side-cart:scroll-to-build', {
              detail: { tier: unfinalised.tier, focus: 'required-slot' }
            }));
          } catch (e) {}
          return;
        }
        /* "Check out anyway" → proceed with the existing checkout
           flow; kit memory stays untouched in localStorage. */
        self._proceedToCheckout();
      });
      return;
    }
    this._proceedToCheckout();
  };

  /* Checkout-click — branches on the current discount intent:

       intent === "nailpoints":
         Reuse a code minted earlier this session; else /api/beans/redeem
         to debit points for a fresh NAILPOINTS-*, persist code+debitId
         on cart attributes (re-checkout reuses, never re-debits), scrub
         lingering BASKET-*, redirect. Worker failure shows a BLOCKING
         error in the Nail Points panel and does NOT proceed — losing
         points hurts more than losing a marketing discount.

       default (no intent):
         If savings > 0, scrub stale BASKET then mint via the gate
         (_mintBasketCode) and redirect to `/checkout?discount=BASKET-XXX`
         ONLY on a confirmed code; otherwise arm the acknowledgement
         CTA. Query-param form, not `/discount/X?redirect=` \u2014 MobiLoud
         kicks the /checkout leg to OS Safari, stranding the cookie. */
  HGNSideCart.prototype._proceedToCheckout = function (opts) {
    if (this._checkoutInflight) return;
    opts = opts || {};
    /* A code apply still in flight (e.g. an email-link code being
       adopted) — wait for it (max 6 s) so the mint sees its intent. */
    if (this._adHocApplyInflight && !opts._applyWaited) {
      var waiter = this;
      var t0 = Date.now();
      if (this.checkoutLabelEl) this.checkoutLabelEl.textContent = 'Applying your code\u2026';
      (function wait() {
        if (!waiter._adHocApplyInflight || Date.now() - t0 > 6000) {
          opts._applyWaited = true;
          waiter._proceedToCheckout(opts);
        } else {
          setTimeout(wait, 250);
        }
      })();
      return;
    }
    /* ...and put back an adopted email-link code a stray cart write lost. */
    if (!opts._welcomeRepaired && this._welcomeRepairDesc()) {
      opts._welcomeRepaired = true;
      var rep = this;
      this._repairWelcomeIntent().then(function () { rep._proceedToCheckout(opts); });
      return;
    }
    /* kit5Ensured hook — await the dual-offer £5 attach before any
       mint math; without it the first click races the auto-attach
       and mints without the fold. Capped at 2.5s inside
       _ensureKit5Attached so a slow popup worker can't stall. */
    if (!opts.kit5Ensured && !opts.skipMint &&
        typeof this._ensureKit5Attached === 'function') {
      if (this._kit5GateInflight) return;
      this._kit5GateInflight = true;
      var gated = this;
      this._ensureKit5Attached().then(function () {
        gated._kit5GateInflight = false;
        opts.kit5Ensured = true;
        gated._proceedToCheckout(opts);
      });
      return;
    }
    var btn = this.checkoutBtn;
    var label = this.checkoutLabelEl;
    /* GBP pence — what the worker expects. Shopify mints discounts
       in shop currency (GBP) regardless of the buyer's market;
       sending presentment cents here would create a £X discount
       when the intent was $X, which is exactly the bug the
       2026-05-18 rewrite is fixing. */
    var savingsGbpCents = this._lastSavingsGbpCents || 0;
    var intent = this._getDiscountIntent();
    var self = this;

    function setBusy(busy, text) {
      if (!btn) return;
      btn.disabled = !!busy;
      if (label) label.textContent = busy ? (text || 'Securing your discount\u2026') : 'Checkout';
    }
    /* Piggyback (§11): when the cart carries hgn_piggyback=1, mint a
       DROPSHIP-* free-shipping companion at the last moment and ride
       it on the same multi-`discount=` URL (BASKET-* codes already
       combine with shipping discounts). Failure-tolerant: no code →
       the shopper pays despatch, nothing else breaks. */
    function piggybackShipCode() {
      var on = false;
      try {
        on = String(((self.cart || {}).attributes || {}).hgn_piggyback || '') === '1';
      } catch (e) { on = false; }
      if (!on) return Promise.resolve(null);
      return fetch('https://naildrop.holygrailnail.co/api/drop/piggyback-ship', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        body: JSON.stringify({ customerId: window.HGN_CUSTOMER_ID || '' })
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { return d && d.code ? d.code : null; })
        .catch(function () { return null; });
    }

    /* KIT5 companion (KIT5-FOLD.md steps 4–5): ping /consume (since
       2026-08-12 that endpoint is read-only — real consumption + the
       POPUP twin-kill moved to the popup worker's ORDER webhook, so an
       abandoned checkout no longer burns the pair) and fetch a real
       free-shipping code ONLY when the folded total leaves the cart
       under this market's free-shipping threshold. */
    function kit5Companion() {
      var tok = self._getKit5Token();
      if (!tok || !self._kit5FoldGbpCents()) return Promise.resolve(null);
      fetch('https://popup.holygrailnail.co/api/kit5/consume', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        body: JSON.stringify({ code: tok })
      }).catch(function () {});
      var need = false;
      try {
        var key = String(((self.cart || {}).currency) || 'GBP').toLowerCase();
        /* Deliberately NOT shipThresholdKey(): this decides whether to mint
           a KIT5 free-shipping code, and mint logic stays exactly as it was
           (Matt's rule: localisation doesn't touch discount minting). */
        var cfgKey = (self.config.shipping || {})[key] != null ? key : 'gbp';
        var shipGbp = (self.config.shipping || {})[cfgKey] || 40;
        var shipCents = Math.round(self._convertThreshold(shipGbp) * 100);
        need = (self._lastDisplayedSubtotalCents || 0) < shipCents;
      } catch (e) { need = false; }
      if (!need) return Promise.resolve(null);
      return fetch('https://popup.holygrailnail.co/api/kit5/freeship', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        body: JSON.stringify({ code: tok })
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { return d && d.ok && d.code ? d.code : null; })
        .catch(function () { return null; });
    }
    /* Single exit for every checkout path. `/checkout?discount=<code>`
       instead of the old `/discount/<code>?redirect=/checkout`: the
       /discount/ redirect sets the discount in a session cookie, and
       inside MobiLoud the WebView → OS Safari handoff loses that
       cookie jar (full-price checkout even though the BASKET-* shows
       minted in admin). The `?discount=` query parameter puts the
       code in the URL itself, so it survives ANY cookie-jar swap —
       Capacitor, MobiLoud, and plain mobile web alike. Multiple
       `discount=` params are applied per each code's combinability
       settings in Admin. */
    function finalGo(codes) {
      var list = (codes || []).filter(Boolean);
      piggybackShipCode().then(function (ship) {
        if (ship) list.push(ship);
        return kit5Companion();
      }).then(function (k5ship) {
        if (k5ship) list.push(k5ship);
        /* Multi-code stacking uses ONE comma-separated discount param
           (Shopify's shareable-link format) — repeated discount= params
           only honour the last code (found live 2026-07-31: KITSHIP
           applied, BASKET dropped, items full price). */
        var qs = list.length
          ? ('discount=' + list.map(encodeURIComponent).join(','))
          : '';
        if (!qs) { window.location.href = '/checkout'; return; }
        /* Checkout warm-up (2026-09-27). About half of fresh checkouts
           opened at FULL PRICE: Shopify silently ignored `?discount=` on
           the load that CREATES the checkout session, then honoured the
           same URL on a reload (live probe, 27 Sep: US/AU/GB/CH, no
           error shown, the code minted fine). So we create the session
           first with a plain background GET /checkout, and the real
           navigation lands like that reload. Putting the code on the cart
           instead made it worse: the drop then stuck through reloads.
           Capped, so a slow warm-up can only ever cost 4 s. */
        var went = false;
        function go() {
          if (went) return;
          went = true;
          window.location.href = '/checkout?' + qs;
        }
        setTimeout(go, 4000);
        try {
          fetch('/checkout', { credentials: 'same-origin', redirect: 'follow', cache: 'no-store' })
            .catch(function () {})
            .then(go);
        } catch (e) { go(); }
      });
    }
    function goPlain() { finalGo([]); }
    function goWithCode(code) { finalGo([code]); }
    function goWithCodes(codes) { finalGo(codes); }

    /* ───── Nail Points intent ───── */
    if (intent === 'nailpoints') {
      var existingCode = this._getMintedNailPointsCode();
      if (existingCode) {
        /* Re-checkout under the same intent \u2014 reuse the already-
           minted code; do NOT re-debit. Scrub stale BASKET-* (e.g.
           shopper hit Checkout twice on different intents in the
           same session) before redirect. */
        this._checkoutInflight = true;
        setBusy(true);
        clearStaleBasketCodes(this.cart, { dropPriceParity: true })
          .then(function () { goWithCode(existingCode); })
          .catch(function () { goWithCode(existingCode); });
        return;
      }
      var email = window.HGN_CUSTOMER_EMAIL;
      /* Re-clamp at mint time: the cart may have shrunk since Apply
         (items removed between setting the intent and Checkout-click).
         The code's minimum-subtotal rule means an over-cart code would
         be silently ignored at checkout while the points debit stood. */
      var amountGbp = Math.min(this._getNailPointsAmountGbp(), this._maxRedeemGbp());
      if (!email || amountGbp <= 0) {
        /* Mis-configured intent (no email / no amount) \u2014 clear
           it and fall through to the default checkout path next tick. */
        if (window && window.console) {
          console.warn('[hgn-side-cart] NP intent set but email/amount missing \u2014 clearing + falling through');
        }
        this._clearNailPointsState().then(function () { return self.refresh(); });
        return;
      }
      this._checkoutInflight = true;
      setBusy(true);
      fetch('https://holygrailnail.co/api/beans/redeem', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'omit',
        body: JSON.stringify({ email: email, gbpAmount: amountGbp })
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (body) {
              throw new Error((body && body.error) || ('beans-' + r.status));
            }).catch(function () { throw new Error('beans-' + r.status); });
          }
          return r.json();
        })
        .then(function (data) {
          if (!data || !data.code) throw new Error(data && data.error ? data.error : 'no-code');
          if (window && window.console) {
            console.info('[hgn-side-cart] NP minted at checkout-click:', data.code, 'debit', data.debitId);
          }
          /* Persist the minted code + debit ID for back-from-checkout
             re-use + cancel-refund. */
          return self._setMintedNailPoints(data.code, data.debitId, data.gbpValue || amountGbp)
            .then(function () { return clearStaleBasketCodes(self.cart, { dropPriceParity: true }); })
            .then(function () { goWithCode(data.code); });
        })
        .catch(function (err) {
          if (window && window.console) {
            console.warn('[hgn-side-cart] NP mint at checkout failed:', err && err.message ? err.message : err);
          }
          self._checkoutInflight = false;
          setBusy(false);
          if (self.beansMessageEl) {
            self.beansMessageEl.innerHTML =
              '<strong>Couldn\u2019t apply Nail Points.</strong> Please try again, or cancel the redemption to checkout without it.';
          }
        });
      return;
    }

    /* ───── Ad-hoc intent ─────
       Three paths:
         A. Order discount AND (kit OR gift) → combined BASKET mint
            that bakes in (kit + gift + ad-hoc). Single redirect via
            /discount/BASKET.
         C. Product / shipping discount AND (kit OR gift) → BASKET mint
            for (kit + gift only). Chained redirect:
            /discount/BASKET → /discount/AD-HOC → /checkout. Shopify
            combines them at checkout (provided both are configured
            combinable). Without this, kit savings would be lost at
            checkout because Shopify can't read `_bundle_price_gbp_cents`.
         B. No kit AND no gift → straight-through /discount/AD-HOC. */
    if (intent === 'adhoc') {
      var adHocCode = this._getAdHocCode();
      if (!adHocCode) {
        if (window && window.console) {
          console.warn('[hgn-side-cart] adhoc intent set but no code — clearing + falling through');
        }
        this._clearAdHocState().then(function () { return self.refresh(); });
        return;
      }
      /* Acknowledged route (2026-09-27): the combined mint failed, the
         CTA said so, and this second tap means "my code only". The
         gift / kit saving is knowingly left behind. */
      if (opts.skipMint) {
        this._checkoutInflight = true;
        setBusy(true, 'Taking you to checkout\u2026');
        clearStaleBasketCodes(this.cart, { dropPriceParity: true })
          .then(function () { goWithCode(adHocCode); })
          .catch(function () { goWithCode(adHocCode); });
        return;
      }
      /* Re-validate the stored code at the money moment (2026-08-12
         incident): the intent descriptor is written at APPLY time and
         a code can die between apply and checkout — the dual-offer
         kill retired a shopper's POPUP mid-session and every surface
         kept promising it. One inspect round-trip here; `not-active`
         → drop the intent, tell the shopper, and let the next click
         run the default kit/gift mint cleanly. Inspect unreachable →
         benefit of the doubt (prior behaviour). The validated-code
         flag re-enters this method so the path logic below stays
         untouched — and it means the mint-failure fallbacks further
         down only ever redirect with a click-time-validated code. */
      if (this._adHocValidatedCode !== adHocCode) {
        this._checkoutInflight = true;
        setBusy(true);
        fetch('https://holygrailnail.co/api/discount/inspect', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'omit',
          body: JSON.stringify({
            code: adHocCode,
            customerId: window.HGN_CUSTOMER_ID || '',
            email: window.HGN_CUSTOMER_EMAIL || ''
          })
        })
          .then(function (r) { return r.json().catch(function () { return null; }); })
          .then(function (body) {
            self._checkoutInflight = false;
            if (body && body.ok === false) {
              setBusy(false);
              return self._clearAdHocState()
                .then(function () { return self.refresh(); })
                .then(function () {
                  self._showAdHocError('That discount code is no longer active, so we’ve removed it. Your other savings are safe — tap Checkout again to continue.');
                  if (self.adhocToggleEl) self.adhocToggleEl.setAttribute('aria-expanded', 'true');
                  if (self.adhocBodyEl)   self.adhocBodyEl.hidden = false;
                });
            }
            self._adHocValidatedCode = adHocCode;
            self._proceedToCheckout();
          })
          .catch(function () {
            self._checkoutInflight = false;
            self._adHocValidatedCode = adHocCode;
            self._proceedToCheckout();
          });
        return;
      }
      this._adHocValidatedCode = null;
      var adHocClass = this._getAdHocClass();
      var adHocState = this._adHocCartState();
      var needsBasketMint = adHocState.hasKit || adHocState.hasGift;
      var includeAdHocInBasket = adHocClass === 'order';

      if (needsBasketMint) {
        this._checkoutInflight = true;
        setBusy(true);
        /* Wipe ALL cart discount codes BEFORE the mint+redirect.
           For order-class ad-hoc the BASKET bakes the code in, so
           a stale session welcome code must be scrubbed or it'd
           double-apply. For product/shipping ad-hoc the chained
           redirect re-applies the code immediately after the
           BASKET — a stale session entry of the SAME code would
           be harmless but a stale OTHER code would still need
           scrubbing. */
        clearAllCartDiscountCodes()
          .then(function () {
            var groups = groupCartLines((self.cart.items || []).slice());
            var savings = self._computeTotalSavings(groups);
            /* order-class: BASKET total = kit + gift + ad-hoc (bakes
               the ad-hoc in; we then redirect ONLY through
               /discount/BASKET so it never enters checkout as its own
               code). product/shipping: kit + gift only — the chained
               /discount/AD-HOC redirect applies that separately.

               GBP pence everywhere (Shopify mints in shop currency).
               Ad-hoc presentment savings are FX-inverted to GBP before
               summing so the worker's £ figure converts back to about
               the right presentment amount. £1-2 drift is acceptable;
               more means the FX rates are broken anyway. */
            var adhocGbpCents = includeAdHocInBasket
              ? presentmentToGbpCents(savings.adhocCents || 0) // presentment cents → GBP pence at the cart's real rate
              : 0;
            var basketGbpTotal = (savings.bundleGbpCents || 0) +
                                 (savings.giftGbpCents   || 0) +
                                 adhocGbpCents +
                                 (self._kit5FoldGbpCents() || 0);
            if (basketGbpTotal <= 0) {
              /* Nothing to preserve — fall through to direct
                 redirect. Can happen if kit/gift contribute zero
                 (e.g. legacy bundle without GBP props). */
              return null;
            }
            var adhocMintPayload = {
              adHocCode: adHocCode,
              totalSavingsCents: basketGbpTotal,
              breakdown: {
                kitCents:   savings.bundleGbpCents || 0,
                giftCents:  savings.giftGbpCents   || 0,
                adHocCents: adhocGbpCents
              },
              customerId: window.HGN_CUSTOMER_ID || '',
              email: window.HGN_CUSTOMER_EMAIL || ''
            };
            /* A3 twin (2026-08-13): the same saving in the shopper's own
               currency, so the worker can mint a PERCENTAGE on non-GBP
               markets instead of a fixed GBP amount Shopify re-converts
               at ITS OWN rate (the drawer promised CHF 68.99, checkout
               settled CHF 67.79 — and the 2026-08-12 four-prices basket
               held a POPUP code, i.e. THIS path). The figures are the
               ones the drawer just displayed: kit + gift from actual
               line prices, the previewed ad-hoc saving, kit5 via the
               same GBP→active conversion the fold banner uses. Denominator
               mirrors the default path (`items_subtotal_price` — see
               _mintBasketCode). ORDER-class only: for product/shipping
               ad-hoc the code discounts lines at checkout BEFORE our
               order percentage applies, so the cached subtotal is the
               wrong base — that branch keeps today's fixed-GBP mint.
               Inert until the worker's ad-hoc percentage patch lands;
               GBP markets keep the fixed path regardless. */
            if (includeAdHocInBasket) {
              adhocMintPayload.presentmentCents =
                (savings.bundlePresentmentCents || 0) +
                (savings.giftPresentmentCents   || 0) +
                (savings.adhocCents             || 0) +
                gbpCentsToCartCents(self._kit5FoldGbpCents() || 0);
              adhocMintPayload.presentmentCurrency = cartCurrencyCode();
              var adhocEligibleCents = (self.cart && self.cart.items_subtotal_price) || 0;
              if (adhocEligibleCents > 0) {
                adhocMintPayload.presentmentSubtotalCents = adhocEligibleCents;
              }
            }
            return fetch('https://holygrailnail.co/api/cart-discount/create-with-adhoc', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'omit',
              body: JSON.stringify(adhocMintPayload)
            });
          })
          .then(function (r) {
            if (r == null) return null;
            return r.ok ? r.json() : r.json().then(function (b) { return { ok: false, body: b }; });
          })
          .then(function (data) {
            if (data && data.code) {
              if (window && window.console) {
                var bd = data.breakdown || {};
                console.info('[hgn-side-cart] adhoc-combined minted', data.code,
                             '(kit=' + (bd.kitCents || 0) +
                             ', gift=' + (bd.giftCents || 0) +
                             ', adhoc=' + (bd.adHocCents || 0) +
                             ', total=' + (data.totalSavingsCents || 0) +
                             ', class=' + adHocClass + ')');
              }
              if (includeAdHocInBasket) {
                /* Order-class — BASKET carries everything. Single
                   redirect; ad-hoc never enters checkout as its
                   own code. */
                goWithCode(data.code);
              } else {
                /* Product / shipping — pass BOTH codes on the
                   checkout URL. Shopify accepts repeated `discount=`
                   query parameters and applies each per its own
                   `combinesWith` settings in Admin. Replaces the
                   previous nested `/discount/CODE?redirect=...`
                   chain — same multi-code outcome, but as a single
                   URL the discount survives a WebView → OS browser
                   handoff (see goWithCode rationale above). */
                goWithCodes([data.code, adHocCode]);
              }
            } else if (data && (data.error === 'already-used-by-customer' ||
                                (data.body && data.body.error === 'already-used-by-customer'))) {
              /* Non-OK worker responses arrive wrapped as {ok:false, body}
                 (see the r.json() handler above) — checking only data.error
                 left this branch dead: shoppers were redirected to checkout
                 with a code Shopify then rejected AND the kit/gift mint was
                 skipped (audit B5.1). */
              self._checkoutInflight = false;
              setBusy(false);
              self._showAdHocError('You’ve already used that code. Remove it and try a different one.');
            } else {
              if (window && window.console) {
                console.warn('[hgn-side-cart] adhoc-combined mint returned no code:', data);
              }
              if (data === null) {
                /* Nothing to preserve (kit + gift contribute zero) —
                   the code alone is the whole saving. */
                goWithCode(adHocCode);
                return;
              }
              /* 2026-09-27 (Help Scout #15323 / #15329): no longer a
                 silent fall-back to the bare code — that charged the
                 free gift (and dropped kit savings) at checkout with
                 no word to the shopper. Same A1 contract as the
                 default path: tell them, and let the NEXT tap be the
                 acknowledgement (the skipMint branch above). */
              self._checkoutInflight = false;
              self._armCheckoutWithoutDiscount({
                reason: 'adhoc-mint', adhoc: true,
                hasKit: !!adHocState.hasKit, hasGift: !!adHocState.hasGift
              });
            }
          })
          .catch(function (err) {
            if (window && window.console) {
              console.warn('[hgn-side-cart] adhoc-combined mint failed:', err);
            }
            self._checkoutInflight = false;
            self._armCheckoutWithoutDiscount({
              reason: 'adhoc-mint-network', adhoc: true,
              hasKit: !!adHocState.hasKit, hasGift: !!adHocState.hasGift
            });
          });
        return;
      }
      /* Path B — direct redirect via /discount/CODE. Shopify enforces
         combinability + one-use-per-customer natively at checkout. */
      this._checkoutInflight = true;
      setBusy(true);
      clearStaleBasketCodes(this.cart, { dropPriceParity: true })
        .then(function () { goWithCode(adHocCode); })
        .catch(function () { goWithCode(adHocCode); });
      return;
    }

    /* ───── Default (kit / gift) intent ───── */
    /* KIT5 fold (KIT5-FOLD.md): the frozen token amount joins the
       BASKET mint figure as GBP pence. */
    savingsGbpCents += this._kit5FoldGbpCents();
    if (savingsGbpCents <= 0 || opts.skipMint) {
      /* skipMint = the acknowledged full-price route (audit A1): the
         only way savings-on-the-table reach /checkout bare, always
         after an explicit second tap. No-savings path unchanged. */
      if (opts.skipMint) {
        this._checkoutInflight = true;
        setBusy(true, 'Taking you to checkout\u2026');
      }
      clearStaleBasketCodes(this.cart).then(goPlain).catch(goPlain);
      return;
    }
    this._checkoutInflight = true;
    setBusy(true, 'Applying your discount\u2026');
    /* Mint gate (A1) - navigate only on a CONFIRMED code, else arm the
       acknowledgement CTA. Contract: hgn-side-cart-kit-checkout.liquid.
       The presentment pair (A3) rides along: Shopify mints a FIXED GBP
       amount and converts it at ITS OWN market rate, not ours, so a
       fixed local sticker can't be hit via GBP (CHF 68.99 settled at
       CHF 67.79, 2026-08-12). Fix is worker-side; these carry what it
       needs. Inert today. Built HERE because activeKey /
       gbpCentsToActiveCents are main-IIFE closure scope. */
    var presentment = {
      presentmentCents:    (self._lastSavingsCents || 0) + gbpCentsToCartCents(self._kit5FoldGbpCents()),
      presentmentCurrency: cartCurrencyCode()
    };
    clearStaleBasketCodes(this.cart, { dropPriceParity: true })
      .catch(function () {})
      .then(function () { return self._mintBasketCode(savingsGbpCents, presentment); })
      .then(function (res) {
        if (res && res.code) { goWithCode(res.code); return; }
        self._checkoutInflight = false;
        self._armCheckoutWithoutDiscount(res);
      })
      .catch(function (err) {
        /* The gate never rejects — this is a fault (deploy skew:
           cluster not pasted). Hand the button back; never auto-nav. */
        if (window && window.console) console.error('[hgn-side-cart] mint gate fault:', err);
        self._checkoutInflight = false;
        setBusy(false);
      });
  };

  /* Surgically remove any BASKET-* codes from the cart's
     discount_codes array. Called both pre-mint (to stop our own
     prior codes stacking) and on the no-savings path (to scrub
     stale codes from previous sessions).

     Approach: there's no Shopify AJAX endpoint to remove a SPECIFIC
     code while preserving others, so when BASKET-* codes are
     present we /cart/update.js with `discount: ''` (which clears
     ALL codes), then re-apply any non-BASKET codes that were
     present (Beans `redeemxr*`, welcome promos, etc.) via the
     /discount/CODE pattern.

     If no BASKET codes are present, no-op. Returns a Promise that
     resolves when the cart is in a known-clean state. */
  function clearStaleBasketCodes(cart, opts) {
    opts = opts || {};
    var codes = (cart && cart.discount_codes) || [];
    var basketCodes = codes.filter(function (d) { return d && /^BASKET-/i.test(d.code); });
    if (basketCodes.length === 0) return Promise.resolve();

    /* `dropPriceParity` (Matt, 2026-08-12): GSF-* codes are Google
       price-parity per-product discounts that ride into the session
       from ad landings. When the shopper is checking out with an HGN
       offer (kit mint, popup code, Nail Points) they are NOT
       preserved — mixing a stray £3.96-off-one-product code with a
       minted offer produced the four-different-prices complaint.
       With no HGN offer active they're left alone (that price is
       what the ad promised). */
    var preserved = codes
      .filter(function (d) {
        if (!d || !d.code) return false;
        if (/^BASKET-/i.test(d.code)) return false;
        if (opts.dropPriceParity && /^GSF-/i.test(d.code)) return false;
        return true;
      })
      .map(function (d) { return d.code; });

    /* Clear all codes. */
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: '' })
    }).then(function () {
      if (preserved.length === 0) return null;
      /* Re-apply preserved codes one-by-one — /cart/update.js
         only accepts a single `discount` string, so we chain. */
      return preserved.reduce(function (p, code) {
        return p.then(function () {
          return fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: code })
          });
        });
      }, Promise.resolve());
    }).catch(function (err) {
      if (window && window.console) {
        console.warn('[hgn-side-cart] clearStaleBasketCodes failed:', err);
      }
    });
  }

  /* Aggressive variant — wipes every discount code on the cart's
     session (BASKET-*, NAILPOINTS-*, legacy welcome codes, anything else). Used
     by the ad-hoc Path A flow before redirecting via /discount/BASKET
     so the ad-hoc code we baked into the combined BASKET can't also
     show up at checkout as a separate stacked discount.

     Without this, a shopper whose session previously cookied
     /discount/<code>-style links (via an email link, etc.) would end up
     with both that code + BASKET-* applied at checkout — double-discounting
     the ad-hoc value. */
  function clearAllCartDiscountCodes() {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: '' })
    }).catch(function (err) {
      if (window && window.console) {
        console.warn('[hgn-side-cart] clearAllCartDiscountCodes failed:', err);
      }
    });
  }

  HGNSideCart.prototype._getGiftThresholdCents = function () {
    var giftGbp = (this.config.gift && this.config.gift.thresholdGbp) || 50;
    var disp = this._convertThreshold(giftGbp);
    return Math.round(disp * 100);
  };

  /* Add gift line. Mint-at-checkout architecture: no worker call
     here — the gift is added at full retail with a `_gift_line`
     marker. Pricing is reconciled via the consolidated cart discount
     minted at the moment of checkout (which covers kit savings AND
     gift retail in a single order discount). */
  HGNSideCart.prototype._addGiftLine = function () {
    var tier = this.config.gift.tiers[0];
    if (!tier || !tier.variantId) return Promise.resolve();
    var self = this;
    /* `_gift_retail_gbp_cents` captures the gift product's shop-
       currency (GBP) retail at add-time so the side cart can show
       "Free Gift — worth $X" via formatLive on the same canonical
       value, no matter which market the shopper is in. Mirrors the
       `_bundle_retail_gbp_cents` pattern used for kit bundles. */
    var giftRetailGbpCents = Math.round((typeof tier.price === 'number' ? tier.price : 0) * 100);
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: tier.variantId,
          quantity: 1,
          properties: {
            '_gift_line':             '1',
            '_gift_retail_gbp_cents': String(giftRetailGbpCents),
            'Free gift':              '1'
          }
        }]
      })
    }).then(function () {
      return self.refresh();
    }).catch(function (err) {
      if (window && window.console) {
        console.warn('[hgn-side-cart] free gift add failed:', err);
      }
    });
  };

  /* Remove gift line. No worker destroy needed — with mint-at-
     checkout, no Shopify-side code was ever created for the gift.
     Uses /cart/update.js with an updates-map instead of
     /cart/change.js — change.js returned 400 in the wild on the
     Nail Points intent-flip flow (back-to-back cart writes can race
     with Shopify's session locking). Updates-map is the same pattern
     used by the bundle-remove flow and has been reliable. Falls back
     to a variant_id-keyed update if the line-key version fails. */
  HGNSideCart.prototype._removeGiftLine = function (giftLine) {
    if (!giftLine) return Promise.resolve();
    var self = this;
    var keyUpdates = {};
    keyUpdates[giftLine.key] = 0;
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: keyUpdates })
    })
      .then(function (r) {
        if (r.ok) return r.json();
        if (window && window.console) {
          console.warn('[hgn-side-cart] gift remove by line key failed (' + r.status + '), retrying by variant_id', giftLine.key, giftLine.variant_id);
        }
        var variantUpdates = {};
        variantUpdates[String(giftLine.variant_id)] = 0;
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: variantUpdates })
        }).then(function (r2) { return r2.ok ? r2.json() : null; });
      })
      .then(function () { return self.refresh(); });
  };

  /* Replace the placeholder gift SVG with the configured product
     image once it's available. Idempotent — checks for an existing
     <img> and skips if already rendered. */
  HGNSideCart.prototype._renderGiftMilestoneIcon = function () {
    var icon = $('[data-hgn-side-cart-milestone-gift-icon]', this.progressEl);
    if (!icon || !this.config.gift || !this.config.gift.tiers || !this.config.gift.tiers[0]) return;
    if (icon.querySelector('img')) return;
    var tier = this.config.gift.tiers[0];
    if (!tier.image) return;
    icon.innerHTML = '<img src="' + escapeAttr(tier.image) + '" alt="' + escapeAttr(tier.friendlyName || tier.title) + '" loading="lazy">';
  };

  /* ───────── Renderers ───────── */
  /* The kit's own picture on the saved-kit card (Matt, 2026-09-16: "use
     collage when a kit is in the cart instead of rotating images"). The
     same renderer every kit surface uses; the cart lines are shaped into
     the kit object kitCollageLiveOptions already understands — designs
     in cart order, accessories matched to their slot through the
     HGN_KIT_ACCESSORIES broadcast (variant id, then handle). No renderer
     on the page, no tier on the lines, or no design line → '' and the
     cycling thumb renders exactly as before. Skin + caption come from
     the stamped edit, so a Halloween Edit wears its own colours. */
  function bundleCollageMarkup(bundle) {
    try {
      var H = window.HGN || {};
      if (typeof H.kitCollageMarkup !== 'function' || typeof H.kitCollageLiveOptions !== 'function') return '';
      var tier = bundle.tier;
      if (!tier) return '';
      var broadcast = (window.HGN_KIT_ACCESSORIES || {})[tier] || {};
      var bySlot = {};
      Object.keys(broadcast).forEach(function (slot) {
        (broadcast[slot] || []).forEach(function (o) {
          if (!o) return;
          if (o.variantId != null) bySlot['v:' + o.variantId] = { slot: slot, o: o };
          if (o.handle) bySlot['h:' + o.handle] = { slot: slot, o: o };
        });
      });
      var items = [], accessories = {};
      bundle.items.forEach(function (it) {
        var hit = bySlot['v:' + it.variant_id] || bySlot['h:' + it.handle];
        if (hit) {
          if (!accessories[hit.slot]) accessories[hit.slot] = { id: hit.o.id, handle: it.handle || hit.o.handle || '', image: it.image || hit.o.image || null, title: it.product_title || it.title || hit.o.title || '' };
          return;
        }
        items.push({ handle: it.handle || '', image: it.image || null, title: it.product_title || it.title || '' });
      });
      if (!items.length) return '';
      var opts = H.kitCollageLiveOptions(tier, {
        kit: { items: items, accessories: accessories }, variant: 'drawer',
        skin: bundle.edit ? bundle.edit.skin : '', editLabel: bundle.edit ? bundle.edit.title : ''
      });
      return '<div class="hgn-side-cart__bundle-collage" data-hgn-bundle-collage>' + H.kitCollageMarkup(opts) + '</div>';
    } catch (e) { return ''; }
  }
  function renderBundleCard(bundle, kit5Cents) {
    var qty = bundle.items.length;
    /* Auto-carousel through every bundle image so the thumb sells the
       kit (not just whatever item Shopify returned first). All images
       are stacked absolutely; CSS animation cycles which one is
       opaque. Falls back to a single image if the bundle only has one.
       2026-09-16: the collage takes this slot whenever it can render
       (bundleCollageMarkup above); the carousel is the fallback. */
    var collage = bundleCollageMarkup(bundle);
    var images = bundle.items
      .map(function (it) { return it.image; })
      .filter(Boolean);
    var thumb;
    if (collage) {
      thumb = collage;
    } else if (images.length === 0) {
      thumb = '';
    } else if (images.length === 1) {
      thumb = '<img src="' + escapeAttr(images[0]) + '" alt="" loading="lazy">';
    } else {
      var step = (100 / images.length).toFixed(2);
      var slides = images.map(function (src, i) {
        return '<img src="' + escapeAttr(src) + '" alt="" loading="lazy" data-hgn-bundle-slide="' + i + '">';
      }).join('');
      thumb = '<div class="hgn-side-cart__bundle-thumb-cycle" data-hgn-bundle-cycle data-hgn-bundle-slide-count="' + images.length + '">' + slides + '</div>';
    }
    var inner = bundle.items.map(function (it) {
      return (
        '<div class="hgn-side-cart__bundle-line">' +
          '<span class="hgn-side-cart__bundle-line-title">' + escapeHtml(it.product_title || it.title) + '</span>' +
          '<span class="hgn-side-cart__bundle-line-qty">\u00d7' + (it.quantity || 1) + '</span>' +
        '</div>'
      );
    }).join('');
    /* Price block — actual-price basis (2026-07-10 rewrite).
       Strikethrough = the REAL sum of the bundle's line prices
       (presentment, exact); paid = that sum minus the computed
       savings, which lands exactly on the kit's target price for
       GBP carts. All three figures are formatMoney-exact so
       strike − paid always equals the Save pill — the previous
       per-figure formatLive friendly rounding could render
       "$80 → $60, Save $17" on non-GBP markets.

       Legacy bundle without the target-price prop → fall back to
       just showing the presentment paid total (no strikethrough,
       no saving pill). Acceptable per "don't worry about existing
       carts". */
    var priceBlock;
    if (bundle.gbpPaidCents != null) {
      var savingPresentmentCents = bundleSavingsPresentmentCents(bundle) + (kit5Cents || 0);
      var paidPresentmentCents = Math.max(0, (bundle.retailCents || 0) - savingPresentmentCents);
      if (savingPresentmentCents > 0) {
        priceBlock =
          '<p class="hgn-side-cart__bundle-price">' +
            '<s class="hgn-side-cart__bundle-price-rrp">' + formatMoney(bundle.retailCents || 0) + '</s>' +
            '<span class="hgn-side-cart__bundle-price-paid">' + formatMoney(paidPresentmentCents) + '</span>' +
          '</p>' +
          '<span class="hgn-side-cart__bundle-saving">Save ' + formatMoney(savingPresentmentCents) + '</span>';
      } else {
        priceBlock = '<p class="hgn-side-cart__bundle-price">' + formatMoney(paidPresentmentCents) + '</p>';
      }
    } else {
      priceBlock = '<p class="hgn-side-cart__bundle-price">' + formatMoney(bundle.paidCents || bundle.retailCents) + '</p>';
    }
    return (
      '<article class="hgn-side-cart__bundle" data-hgn-side-cart-bundle-card data-hgn-bundle-id="' + escapeAttr(bundle.id) + '"' + (bundle.edit ? ' data-hgn-bundle-edit="' + escapeAttr(bundle.edit.slug || '') + '"' : '') + '>' +
        '<div class="hgn-side-cart__bundle-head' + (collage ? ' hgn-side-cart__bundle-head--collage' : '') + '">' +
          '<div class="hgn-side-cart__bundle-thumb' + (collage ? ' hgn-side-cart__bundle-thumb--collage' : '') + '">' + thumb + '</div>' +
          '<div class="hgn-side-cart__bundle-info">' +
            /* Curation-aware (2026-09-16): an edit is named as itself — "The
               Halloween Edit" — with the tier kit as the eyebrow; a hand-built
               kit keeps "Starter kit" + its tier label as the title. */
            '<p class="hgn-side-cart__bundle-eyebrow">' + (bundle.edit ? escapeHtml(bundle.label) : 'Starter kit') + ' \u2022 ' + qty + ' items</p>' +
            '<h3 class="hgn-side-cart__bundle-title">' + escapeHtml(bundle.edit ? bundle.edit.title : bundle.label) + '</h3>' +
            priceBlock +
          '</div>' +
          '<button type="button" class="hgn-side-cart__bundle-remove" data-hgn-side-cart-action="remove-bundle" data-hgn-side-cart-bundle="' + escapeAttr(bundle.id) + '" aria-label="Remove the kit">' +
            '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" aria-hidden="true">' +
              '<path d="m6 6 12 12M18 6 6 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
            '</svg>' +
          '</button>' +
        '</div>' +
        '<button type="button" class="hgn-side-cart__bundle-toggle" data-hgn-side-cart-action="toggle-bundle" aria-expanded="false">' +
          '<span>What\u2019s in this kit</span>' +
          '<svg viewBox="0 0 24 24" width="10" height="10" fill="none" aria-hidden="true">' +
            '<path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</button>' +
        '<div class="hgn-side-cart__bundle-body">' + inner + '</div>' +
      '</article>'
    );
  }

  /* Render the auto-added free gift as a celebratory reward row.
     No qty controls (always 1), no remove (orchestrator auto-removes
     when threshold drops). The "Free Gift" pill is gated on the line
     ACTUALLY being free (paid cents === 0) — the gift line property
     alone isn't enough; if /cart/update.js failed to apply the code
     the line might still be at full retail and the total includes it.
     Showing FREE when it isn't would lie to the shopper. */
  function renderGiftLine(item) {
    var thumb = item.image
      ? '<img src="' + escapeAttr(item.image) + '" alt="' + escapeAttr(item.product_title || item.title) + '" loading="lazy">'
      : '';
    var url = item.url || ('/products/' + (item.handle || ''));
    /* Gift discount is now ORDER-level (minted at checkout-click).
       Strikethrough = the gift line's ACTUAL presentment price —
       the same figure `_computeTotalSavings` counts and the mint
       covers, so the strike always matches the discount the
       shopper receives. The `_gift_retail_gbp_cents` add-time
       snapshot is only a fallback (it goes stale after a price
       change, and on non-GBP markets it captured a presentment
       value mislabelled as GBP). */
    var giftRetailGbp = readGiftRetailGbpCents(item);
    var presentmentRetail = giftRetailPresentmentCents(item);
    var retailLabel = '';
    if (presentmentRetail > 0) {
      retailLabel = formatMoney(presentmentRetail);
    } else if (giftRetailGbp != null && giftRetailGbp > 0) {
      retailLabel = formatGbpCents(giftRetailGbp);
    }
    var priceBlock = retailLabel
      ? '<span class="hgn-side-cart__item-price hgn-side-cart__item-price--strike">' + retailLabel + '</span>' +
        '<span class="hgn-side-cart__item-gift-pill">Free Gift</span>'
      : '<span class="hgn-side-cart__item-gift-pill">Free Gift</span>';
    return (
      '<div class="hgn-side-cart__item hgn-side-cart__item--gift">' +
        '<a class="hgn-side-cart__item-thumb" href="' + escapeAttr(url) + '">' + thumb + '</a>' +
        '<div class="hgn-side-cart__item-info">' +
          '<a class="hgn-side-cart__item-title" href="' + escapeAttr(url) + '">' + escapeHtml(item.product_title || item.title) + '</a>' +
          '<div class="hgn-side-cart__item-meta">' + priceBlock + '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function renderLineItem(item, adhocCtx) {
    var thumb = item.image
      ? '<img src="' + escapeAttr(item.image) + '" alt="' + escapeAttr(item.product_title || item.title) + '" loading="lazy">'
      : '';
    var url = item.url || ('/products/' + (item.handle || ''));
    /* Line price = retail minus order-level discount allocations.
       `final_line_price` only covers line-level discounts, so any
       order-level code (welcome offer, kit on a non-bundle line)
       wouldn't show through. Strikethrough RRP if there's a saving. */
    var retailCents = item.original_line_price != null ? item.original_line_price : (item.line_price || 0);
    var paidCents = linePaidCents(item);
    /* Apply ad-hoc per-line preview when context says we should.
       For percentage codes: lineSaved = retail × pct.
       For fixed-amount codes: allocate proportionally — this line's
       share of the non-kit-non-gift subtotal × total adhoc cents.
       The "paid" price drops by that allocation so the strikethrough
       UX mirrors the gift line. */
    var adhocLineCents = 0;
    if (adhocCtx) {
      if (adhocCtx.kind === 'percentage') {
        adhocLineCents = Math.round(retailCents * adhocCtx.pct);
      } else if (adhocCtx.kind === 'fixed' && adhocCtx.basisCents > 0) {
        adhocLineCents = Math.round(
          (retailCents / adhocCtx.basisCents) * adhocCtx.totalCents
        );
      }
      adhocLineCents = Math.max(0, Math.min(retailCents, adhocLineCents));
      if (adhocLineCents > 0) {
        paidCents = Math.max(0, paidCents - adhocLineCents);
      }
    }
    var lineSaved = Math.max(0, retailCents - paidCents);
    var priceHtml = lineSaved > 0
      ? '<span class="hgn-side-cart__item-price">' +
          '<s class="hgn-side-cart__item-price--strike">' + formatMoney(retailCents) + '</s> ' +
          formatMoney(paidCents) +
        '</span>'
      : '<span class="hgn-side-cart__item-price">' + formatMoney(paidCents || retailCents) + '</span>';
    return (
      '<div class="hgn-side-cart__item">' +
        '<a class="hgn-side-cart__item-thumb" href="' + escapeAttr(url) + '">' + thumb + '</a>' +
        '<div class="hgn-side-cart__item-info">' +
          '<a class="hgn-side-cart__item-title" href="' + escapeAttr(url) + '">' + escapeHtml(item.product_title || item.title) + '</a>' +
          '<div class="hgn-side-cart__item-meta">' +
            priceHtml +
            '<span class="hgn-side-cart__item-qty">' +
              '<button type="button" data-hgn-side-cart-action="dec" data-hgn-side-cart-line="' + item._lineIndex + '" data-hgn-side-cart-qty="' + item.quantity + '" aria-label="Decrease quantity"' + (item.quantity <= 1 ? ' disabled' : '') + '>\u2212</button>' +
              '<span class="hgn-side-cart__item-qty-value">' + item.quantity + '</span>' +
              '<button type="button" data-hgn-side-cart-action="inc" data-hgn-side-cart-line="' + item._lineIndex + '" data-hgn-side-cart-qty="' + item.quantity + '" aria-label="Increase quantity">+</button>' +
            '</span>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="hgn-side-cart__item-remove" data-hgn-side-cart-action="remove" data-hgn-side-cart-line="' + item._lineIndex + '">Remove</button>' +
        (function () {
          /* Matt 2026-07-24: eligible one-off lines offer a move into
             the shopper's Nail Drop (reverse of the queue's dupe
             badge). Shown only when drop is available, a lane is set,
             the product matches the lane, and it isn't queued yet. */
          try {
            var dqM = window.HGN && window.HGN.dropQueue;
            var smM = window.HGN && window.HGN.shopMode;
            if (!dqM || !smM || typeof smM.isDropAvailable !== 'function' || !smM.isDropAvailable()) return '';
            var laneM = typeof dqM.getFocus === 'function' ? dqM.getFocus() : null;
            if (!laneM) return '';
            var tierM = (window.HGN && typeof window.HGN.tierFromProductType === 'function')
              ? window.HGN.tierFromProductType(item.product_type) : null;
            if (tierM !== laneM) return '';
            if (typeof dqM.hasItem === 'function' && dqM.hasItem(String(item.variant_id))) return '';
            return '<button type="button" class="hgn-side-cart__item-remove" style="margin-left:12px;color:#8c4d35;" data-hgn-side-cart-move-to-drop' +
              ' data-variant-id="' + escapeAttr(String(item.variant_id)) + '"' +
              ' data-line="' + item._lineIndex + '"' +
              ' data-title="' + escapeAttr(item.product_title || item.title || '') + '"' +
              ' data-handle="' + escapeAttr(item.handle || '') + '"' +
              ' data-image="' + escapeAttr(item.image || '') + '"' +
              ' data-tier="' + escapeAttr(tierM) + '">Move to my Nail Drop</button>';
          } catch (e) { return ''; }
        })() +
      '</div>'
    );
  }

  /* ───────── Boot ───────── */
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else { fn(); }
  }
  ready(function () {
    var root = $(SC_SELECTOR);
    if (!root) return;
    var instance = new HGNSideCart(root);
    window.HGN = window.HGN || {};
    window.HGN.sideCart = {
      open:    function () { instance.open(); },
      close:   function () { instance.close(); },
      refresh: function () { return instance.refresh(); },
      /* Line count of the last-fetched cart — lets the kit-build IIFE
         decide whether its in-list "Add my kit to basket" CTA should
         render (mixed baskets only; on kit-only carts the foot's
         "Checkout with my kit" one-tap is the single action). */
      itemCount: function () { return (instance.cart && instance.cart.item_count) || 0; },
      /* Cart-page bridge — the redesigned cart page Checkout button
         delegates here so the same checkout-click mint flow (BASKET-*
         discount, ad-hoc combine, Nail Points, etc.) is shared across
         both surfaces. The instance pre-warms `this.cart` on every
         page load via the constructor's `this.refresh()`, so the
         function works whether or not the drawer has been opened. */
      proceedToCheckout: function () { return instance._proceedToCheckout(); },
      /* Cached consolidated savings (kit + gift + ad-hoc preview +
         Nail Points), recomputed inside `_render` on every refresh.
         Lets the cart page render the same "You save £X" without
         re-implementing the savings math here. Returns 0 before the
         first render lands; the cart page re-reads on every
         `hgn:cart:change` so the value catches up immediately. */
      savings: function () { return instance._lastSavingsCents || 0; },
      /* Discounted subtotal — items_subtotal_price minus the synthetic
         savings the side cart subtracts in its foot (bundle + gift +
         NP + ad-hoc preview). Computed once per `_render` so the
         cart page can mirror the side cart's "Subtotal" without re-
         implementing the math. Returns null before the first render
         so the cart page knows to leave the server-rendered value in
         place. */
      displayedSubtotalCents: function () {
        return (typeof instance._lastDisplayedSubtotalCents === 'number')
          ? instance._lastDisplayedSubtotalCents
          : null;
      },
      /* Phase-2 cart-page bridges — route the cart page's panel
         Apply / Cancel buttons through the side cart's existing
         handlers so we get ONE set of business logic for the
         apply state-machine (intent attribute writes, code mint,
         per-customer guards, etc.). The handlers themselves dispatch
         `hgn:cart:change` on completion, which the cart-page
         controller listens to → re-renders the section so applied
         state is reflected. */
      applyAdHoc:        function (code) { return instance._handleAdHocApply(code); },
      cancelAdHoc:       function ()     { return instance._handleAdHocCancel(); },
      cancelNailPoints:  function ()     { return instance._clearNailPointsState(); },
      /* Cached Nail Points balance from /api/beans/balance (fetched
         in the side cart's constructor). `null` means "not yet
         fetched"; `{ ... }` means fetched (may be zero balance).
         Cart-page Beans panel reads this on hydrate; falls back to
         "Apply" → open drawer when the balance hasn't arrived. */
      beansBalance:      function ()     { return instance.beansBalance; },
      /* Surfaces the side cart's last ad-hoc apply error text so the
         cart-page panel can show it inline without its own error
         element. Returns empty string when the side cart's error
         element is hidden / empty. */
      lastAdHocError:    function () {
        var el = instance.adhocErrorEl;
        if (!el) return '';
        return el.hidden ? '' : (el.textContent || '');
      }
    };
  });
})();
